import { DatePipe } from '@angular/common';
import {
  AfterViewInit,
  Component,
  effect,
  HostListener,
  NgZone,
  OnDestroy,
  OnInit,
  signal,
  ViewChild,
  inject,
  ElementRef,
  ChangeDetectorRef
} from '@angular/core';
import { QuerystringListComponent } from '../querystring-list/querystring-list.component';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { cloneDeep, debounce, filter, findIndex, isArray, isEqual, pick, uniq } from 'lodash-es';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Confirmation, MenuItem, MessageService } from 'primeng/api';
import { ConfirmationDialogService } from 'src/app/services/confirmation-dialog.service';
import { DialogService } from 'primeng/dynamicdialog';
import {
  BehaviorSubject,
  Observable,
  Subscription,
  combineLatest,
  distinctUntilChanged,
  firstValueFrom,
  forkJoin,
  filter as rxjsFilter,
  fromEvent,
  map,
  skip,
  take
} from 'rxjs';
import {
  deleteViewerInfo,
  dragDropFailure,
  dragDropSuccess,
  parTblFailure,
  parTblSuccess,
  tableTypeFailure,
  tableTypeSuccess,
  updParentTbl,
  updTableType,
  updateAppDM,
  updateAppDMFailure,
  updateDragDrop,
  updateViewerInfo
} from 'src/app/STORE/actions/applicationdatamodel.actions';
import {
  getDataModel,
  getScripts,
  saveAppDatamodelBatch,
  saveDatamodelTableFailure,
  saveDatamodelTableSuccess,
  setAllTables
} from 'src/app/STORE/actions/datamodel.actions';
import * as propertyActions from 'src/app/STORE/actions/propertypane.actions';
import { getRoles } from 'src/app/STORE/actions/roles.actions';
import { setNavigationEnd } from 'src/app/STORE/actions/router.actions';
import {
  getSampleData,
  saveSampleData,
  setSampleData,
  triggerSampleData
} from 'src/app/STORE/actions/sampleData.actions';
import { setIdMapping } from 'src/app/STORE/actions/screens.actions';
import { getFields, setFields, setFieldsForTable } from 'src/app/STORE/actions/services.actions';
import {
  getAppSettings,
  getTechnologyStack,
  getTechnologyStackBySuiteId
} from 'src/app/STORE/actions/technologystack.actions';
import {
  appDMFailData,
  appDMSuccData,
  dropFailed,
  dropSucc,
  parTblFailed,
  parTblSucc,
  tblTypeFailed,
  tblTypeSucc
} from 'src/app/STORE/selectors/applicationdatamodel.selector';
import { fsLoginInitiated, selectedAppData } from 'src/app/STORE/selectors/applifecycle.selector';
import { userData } from 'src/app/STORE/selectors/auth.selector';
import {
  allDataModelTables,
  complexTypeTables,
  dataModel,
  dataModelTreeSaveFailure,
  dataModelTreeSaveSuccess
} from 'src/app/STORE/selectors/datamodel.selector';
import {
  funcPKflds,
  picklist,
  propertiesType,
  propertiesValues,
  selLkTbl,
  tabMapFlds
} from 'src/app/STORE/selectors/propertypane.selector';
import { rolesTable } from 'src/app/STORE/selectors/roles.selector';
import { sampleDataTable } from 'src/app/STORE/selectors/sampleData.selector';
import { tableFieldsForDM } from 'src/app/STORE/selectors/services.selector';
import { appSettingsData, memberApps, technologystackData } from 'src/app/STORE/selectors/technologystack.selector';
import { ApiConstants } from 'src/app/base/api-constants';
import { GlobalConstants } from 'src/app/base/global.constants';
import { HttpBaseService } from 'src/app/base/http-base.service';
import { PickupListService } from 'src/app/components/pickup-list/pickup-list.service';
import { ReferenceUtilService } from 'src/app/components/reference-tree-view/reference-util.service';
import { AppLoaderService } from 'src/app/services/app-loader.service';
import { VsQueryBuilderService } from 'src/app/components/vs-qb-builder/vs-query-builder.service';
import { AppGlobalService } from 'src/app/services/app.global.service';
import { FsBaseService } from 'src/app/services/fs-base.service';
import { getPendingService } from 'src/app/services/pendingHttpServices.service';
import * as utilEnum from 'src/app/services/util.enum';
import { ApplicationTypes, DefaultFields } from 'src/app/services/util.enum';
import { UtilService } from 'src/app/services/util.service';
import { MonacoEditorHelperService } from 'src/app/services/monaco-editor-helper.service';
import { v4 as uuidv4 } from 'uuid';
import {
  AiGenerationType,
  SchemaToDataModelComponent
} from 'src/app/components/schema-to-data-model/schema-to-data-model.component';
import { SplitButton } from 'primeng/splitbutton';
import { ActionType, ModelType, UiActions } from 'src/app/components/reference-tree-view/reference.enum';
import { DataModelService } from 'src/app/services/data-model.service';

// declare var $: any;

export enum nodeType {
  FIELD = 'FIELD',
  FIELDGROUP = 'FIELD_GROUP',
  TABLE = 'TABLE',
  GROUP = 'TABLE_GROUP'
}

export class DMConstants {
  public static COMPLEX_TYPE = 'composite_datatype';
  public static COMPLEX_FIELD_TYPE = 'Complex Datatype';
  public static LOOKUP_FIELD_TYPE = 'Lookup';
  public static LOOKUP_TYPE_TABLE = 'table';
  public static LOOKUP_TYPE_WEBSERVICE = 'call_a_web_service';
  public static AUTONUM_TYPE = 'Auto-number';
  public static TRANS_ONLY = 'transactional_only';
  public static TRANS_ANALY = 'transactional_+_analytical';
  public static TRANSIENT = 'transient';
  public static ANALY_ONLY = 'analytical_only';
  public static GROUP_ICON = 'fa layer-group group-icon';
  public static FIELD_GROUP_ICON = 'fa object-group field-group-icon';
  public static TABLE_ICON = 'fa table table-icon';
  public static FIELD_ICON = 'fa pen-field field-icon';
  public static QUERY_VIEW = 'query_view';
  public static SINGLE_QUERY = 'single';
  public static MULTIPLE_QUERY = 'multiple';
}
@AutoUnsubscribe({ arrayName: 'subscriptions' })
@Component({
  selector: 'vb-data-model',
  templateUrl: './data-model.component.html',
  styleUrls: ['./data-model.component.scss'],
  providers: [DialogService],
  standalone: false //NOSONAR
})
export class DataModelComponent implements OnInit, AfterViewInit, OnDestroy {
  private store = inject(Store);
  private dataModelService = inject(DataModelService);
  private fbuilder = inject(FormBuilder);
  private appGlobalService = inject(AppGlobalService);
  private monacoHelper = inject(MonacoEditorHelperService);
  private messageService = inject(MessageService);
  private confirmationDialogService = inject(ConfirmationDialogService);
  private zone = inject(NgZone);
  private datePipe = inject(DatePipe);
  private bs = inject(HttpBaseService);
  private loader = inject(AppLoaderService);
  private util = inject(UtilService);
  private qbService = inject(VsQueryBuilderService);
  private router = inject(Router);
  private acRoute = inject(ActivatedRoute);
  private pendingService = inject(getPendingService);
  private translate = inject(TranslateService);
  private utilService = inject(UtilService);
  private fsService = inject(FsBaseService);
  private dynamicDialogService = inject(DialogService);
  private pickupListService = inject(PickupListService);
  private referenceUtil = inject(ReferenceUtilService);
  private changeDetectorRef = inject(ChangeDetectorRef);

  fsData: any;
  @ViewChild('op')
  public op;
  @ViewChild('splitter')
  public splitter;
  @ViewChild('querystringList')
  public queryStringListComponent;
  @ViewChild('addFieldsInput') addFieldsInput!: ElementRef<HTMLTextAreaElement>;
  popupOpened = false;
  unSubList: any = [];
  dataMlSub: any = [];
  showPopup = false;
  showType = false;
  currNode: any;
  hideDts = false;
  initialFieldProperties: any;
  memberAppIds: any[] = [];
  initialTableProperties: any;
  activeNode: any;
  queryCheck = false;
  prevActiveNode: any;
  backupProperties: any;
  dataSetMap = new Map<string, string>();
  isInitilized = false;
  ftree: any;
  propertiesTasks: any = { added: [], deleted: [] };
  appId = '';
  orgId = '';
  excelColumns: any[];
  private _dataModelDataOrder: any = [];
  get dataModelDataOrder(): any {
    return this._dataModelDataOrder;
  }
  set dataModelDataOrder(value: any) {
    this._dataModelDataOrder = value;
    this.dataModelDataOrder$.next(value ? [...value] : []); // Emit a new reference to trigger async pipe securely
  }
  dataModelDataOrder$: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  backupOrder: any = [];
  selectedNodeType: string;
  selectedNode: any;
  propertyPaneValues$: Observable<any> = this.store.select(propertiesValues);
  propertiesType$: Observable<any> = this.store.select(propertiesType);
  dataModelTreeSaveFailure$ = this.store.select(dataModelTreeSaveFailure);
  dataModelTreeSaveSuccess$ = this.store.select(dataModelTreeSaveSuccess);
  data$: Observable<any> = this.store.select(dataModel);
  complexDataTypes$: Observable<any> = this.store.select(complexTypeTables);
  allDataModelTables$: Observable<any> = this.store.select(allDataModelTables);
  allRoles$: Observable<any> = this.store.select(rolesTable);
  complexTables: any = null;
  complexTypes: any = null;
  complexTypesForDataType: any = null;
  removedComplexTables: any = [];
  private hasReloadedOnDMFail = false;
  normalTables: any = null;
  sub: Subscription = new Subscription();
  sampleDataSub: Subscription = new Subscription();
  ref$: Subscription = new Subscription();
  debounceTime = 1000;
  titleMaxLength = this.util.titleMaxLength;
  fieldMaxCount = 25;
  allRoles: any = [];
  allTables: any = [];
  items: MenuItem[];
  types: any = [];
  showLoader = false;
  isBetaAccessPrivilegeConsumable = false;
  private treeFocusScrollGuardAttached = false;
  activeIndex = signal(0);
  subscriptions: any = [];
  rolesSub = new Subscription();
  activeFieldSid;
  qbFields = {};
  currentTableName: string;
  currentTableId: string;
  appUserFields: any;
  appUserTableId: any;
  updatedDatatypeList = {};
  complexDataTypeIds = {};
  updatedTableName = {};
  hasReference = false;
  formDefaultValues: any = {};
  filteredDefaultValues: any = {};
  allProps: any = {};
  waitingOnresponse: any = false;
  allFieldsAndTypes: any = [];
  rowid: null;
  selectedRow: any;
  enabledReferenceModal = false;
  softUpdateProps = false;
  techStackData: any = {};
  dataTypes = [
    {
      name: 'filter',
      value: 'filter',
      class: 'form-control',
      isFilter: true
    },
    {
      name: '-----------------',
      value: '',
      class: 'type-separator',
      isDivider: true
    },
    {
      name: 'String',
      value: 'String',
      class: ''
    },
    {
      name: 'Number',
      value: 'Number',
      class: ''
    },
    {
      name: 'Drop Down',
      value: 'Dropdown',
      class: ''
    },
    {
      name: 'Look Up',
      value: 'Lookup',
      class: ''
    },
    {
      name: 'Date Time',
      value: 'DateTime',
      class: ''
    },
    {
      name: 'Boolean',
      value: 'Boolean',
      class: ''
    },
    {
      name: 'Text',
      value: 'Text',
      class: ''
    },
    {
      name: '-----------------',
      value: '',
      class: 'type-separator',
      isDivider: true
    },
    {
      name: 'CheckBox',
      value: 'Checkbox',
      class: ''
    },
    {
      name: 'Checkbox Group',
      value: 'Checkboxgroup',
      class: ''
    },
    {
      name: 'Currency',
      value: 'Currency',
      class: ''
    },
    {
      name: 'Date Only',
      value: 'Date',
      class: ''
    },
    {
      name: 'Double',
      value: 'Double',
      class: ''
    },
    {
      name: 'Email',
      value: 'Email',
      class: ''
    },
    {
      name: 'File Attachment',
      value: 'File Attachments',
      class: ''
    },
    {
      name: 'Image Carousel',
      value: 'Image Carousel',
      class: ''
    },
    {
      name: 'Radio Button',
      value: 'Radio',
      class: ''
    },
    {
      name: 'URL',
      value: 'URL',
      class: ''
    },
    {
      name: 'Yes No',
      value: 'Yes No',
      class: ''
    },
    {
      name: 'Color',
      value: 'Color',
      class: ''
    },
    {
      name: 'Auto Number',
      value: 'Auto-number',
      class: ''
    },
    {
      name: '-----------------',
      value: '',
      class: 'type-separator',
      isDivider: true
    }
  ];
  uiTypes: any = [];
  systemFields = ['sync time', 'pid'];
  selectedGroup: any[];
  filteredGroups: any = [];
  debounceFieldOrderSave: any;
  groupTitles: string[] = [];
  tablesList: string[] = [];
  tablesInfo: any[] = [];
  tableMap: any = {};
  tableFieldMap: any = {};
  fldTypMap: any = {};

  tableTitles: string[] = [];
  fieldTitles: any = {};
  fieldGroupTitles: any = {};
  currentIteratingTable: any;

  savedRecordId: any;
  generateScript: boolean;
  isLoading = false;
  propertyLoading = false;
  dataModelInfo: any;
  sampleDatas: any = [];
  sampleDataWorkSheet: any;
  sampleDataLoading = false;
  appForm: any = new FormGroup({
    name: new FormControl(null, Validators.required)
  });
  searchTerm: any;
  showBetaTableSearch = false;
  filter: any;
  showVisualizer = false;
  showDbVisualizer = false;
  menuItems: MenuItem[];
  queryStringItems: MenuItem[];
  disallowEdit = false;
  tableForm = new FormGroup({
    name: new FormControl(''),
    type: new FormControl(DMConstants.TRANS_ONLY)
  });
  tableTypeOptions: any = [];
  showTblPopup = false;
  createTblPos: any = null;
  showPropPane = false;
  isRdbms = false;
  uniqSid = '';
  visLoading = false;
  settingsData: any = null;
  tabId: string;
  backupData: any;
  initialCall = false;
  user: any;
  viewerSid: any = null;
  waitingNode: any = null;
  offlineEvent: Observable<Event>;
  onlineEvent: Observable<Event>;
  curNodeData: any = null;
  pickList: any;
  dataModelFlds: any;
  public panelSizes = [30, 70];
  private sizes;
  readonly maxSize = 30;
  selectedNodeTitle: string;
  messages: any = [];
  templateProps: any;
  tabIdkey: any;
  trackedEvents: any;
  fsLogged: any;
  initialLoading = true;
  defaultFieldsArray: any[] = [
    DefaultFields.CREATED_BY,
    DefaultFields.CREATED_DATE,
    DefaultFields.MODIFIED_BY,
    DefaultFields.MODIFIED_DATE
  ];
  fkDeats: any = {};
  applicationType = '';
  defDataset: any = null;
  tblTypSveInPrg = false;
  referredTableData: any;
  lastestUploadData;
  isAiDataModelMergeInProgress: boolean;
  excluded = ['TABLE_INDEX', 'TABLE_FOREIGN_KEY', 'TABLE_LOOKUP_DEFINITION'];
  isMergeLogsPopupOpen = false;
  aiMergeErrorLogs: any[] = [];
  initialData: any = [];
  isAiDataModelMergedJustNow: boolean = false;
  isCompanionLoading = false;
  isCompanionOrigin = false;
  private companionTreeReady = false;
  loadedAppId = '';
  private isDragging = false;
  private rearrageTreeLegTimer: any = null;

  private mapTableActionType(modified: any, tableData?: any, node?: any): ActionType {
    if (!modified) return ActionType.TABLE_TYPE_UPDATE;
    const act = (modified.action || '').toUpperCase();
    switch (act) {
      case 'TABLE_DELETE':
      case 'DELETE_TABLE':
        return ActionType.TABLE_DELETE;
      case 'PARENT_TABLE_DELETE':
      case 'PARENT_TABLE_REMOVE':
        return ActionType.PARENT_TABLE_REMOVE;
      case 'PARENT_TABLE_UPDATE':
        return ActionType.PARENT_TABLE_UPDATE;
      case 'TABLE_TYPE_UPDATE_TO_TRANSIENT':
        return ActionType.TABLE_TYPE_UPDATE_TO_TRANSIENT;
      case 'TABLE_TYPE_UPDATE_TO_COMPOSITE':
        return ActionType.TABLE_TYPE_UPDATE_TO_COMPOSITE;
      case 'TABLE_TYPE_UPDATE_TO_ANALYTICAL':
        return ActionType.TABLE_TYPE_UPDATE_TO_ANALYTICAL;
      case 'TABLE_TYPE_UPDATE_FROM_COMPOSITE':
        return ActionType.TABLE_TYPE_UPDATE_FROM_COMPOSITE;
      case 'TRANSACTION_TABLE_REMOVE':
        return ActionType.TRANSACTION_TABLE_REMOVE;
      case 'EXPORT_FIELDS_REMOVE':
        return ActionType.EXPORT_FIELDS_REMOVE;
      case 'EXPORT_FILTERS_REMOVE':
        return ActionType.EXPORT_FILTERS_REMOVE;
      case 'IMPORT_FIELDS_REMOVE':
        return ActionType.IMPORT_FIELDS_REMOVE;
      case 'TABLE_DATASET_REMOVE':
        return ActionType.TABLE_DATASET_REMOVE;
      case 'TABLE_ACL_CUSTOM_ACTION_DELETE':
        return ActionType.TABLE_ACL_CUSTOM_ACTION_DELETE;
      case 'MANDATORY_FILTERS_UPDATE':
        return ActionType.MANDATORY_FIELD_REMOVE;
      case 'OPTIONAL_FILTERS_UPDATE':
        return ActionType.OPTIONAL_FIELD_REMOVE;
      case 'UNIQUE_LOOKUPS_UPDATE':
        return ActionType.UNIQUE_FIELD_REMOVE;
      case 'QUERY_TYPE_UPDATE': {
        const oldType = node?.data?.t_query_type || modified.old_t_query_type;
        const newType = tableData?.t_query_type;
        if (oldType === 'single' && newType === 'multiple') {
          return ActionType.UPDATE_QUERY_TYPE_FROM_SINGLE;
        }
        if (oldType === 'multiple' && newType === 'single') {
          return ActionType.UPDATE_QUERY_TYPE_FROM_MULTIPLE;
        }
        return ActionType.TABLE_TYPE_UPDATE;
      }
      case 'QUERY_VIEW_MULTIPLE_DETAIL_PAGE': {
        const wasEnabled = node?.data?.t_create_detail_page === true;
        const nowEnabled = tableData?.t_create_detail_page === true;
        if (wasEnabled && !nowEnabled && tableData?.t_query_type == 'multiple') {
          return ActionType.DISABLE_DEFAULT_ROW_DETAIL_PAGE;
        }
        return ActionType.TABLE_TYPE_UPDATE;
      }
      case 'DISABLE_DEFAULT_ROW_DETAIL_PAGE':
        return ActionType.DISABLE_DEFAULT_ROW_DETAIL_PAGE;
      case 'UPDATE_QUERY_TYPE_FROM_SINGLE':
        return ActionType.UPDATE_QUERY_TYPE_FROM_SINGLE;
      case 'UPDATE_QUERY_TYPE_FROM_MULTIPLE':
        return ActionType.UPDATE_QUERY_TYPE_FROM_MULTIPLE;
      default:
        return ActionType.TABLE_TYPE_UPDATE;
    }
  }

  private mapFieldPropertyActionType(modified: any): ActionType {
    if (!modified) return ActionType.FIELD_TYPE_UPDATE;
    const act = (modified.propertyAction || modified.action || '').toUpperCase();
    switch (act) {
      case 'FIELD_DELETE':
      case 'DELETE_FIELD':
        return ActionType.FIELD_DELETE;
      case 'FIELD_RENAME':
        return ActionType.FIELD_RENAME;
      case 'ALLOWED_VALUE_REMOVE':
        return ActionType.ALLOWED_VALUE_REMOVE;
      case 'FIELD_FORMULA_BUILDER_FIELD_REMOVE':
        return ActionType.FIELD_FORMULA_BUILDER_FIELD_REMOVE;
      case 'FORMULA_BUILDER_UPDATE':
        return ActionType.FORMULA_BUILDER_UPDATE;
      case 'FIELD_PROPERTY_UPDATE_TO_TRANSIENT':
      case 'UPDATE_TRANSIENT':
        return ActionType.FIELD_PROPERTY_UPDATE_TO_TRANSIENT;
      case 'MANDATORY_FIELD_REMOVE':
        return ActionType.MANDATORY_FIELD_REMOVE;
      case 'OPTIONAL_FIELD_REMOVE':
        return ActionType.OPTIONAL_FIELD_REMOVE;
      case 'UNIQUE_FIELD_REMOVE':
        return ActionType.UNIQUE_FIELD_REMOVE;
      case 'REMOVE_PID_FIELD':
        return ActionType.REMOVE_PID_FIELD;
      case 'UPDATE_MULTIPLE':
        return ActionType.ALLOWED_VALUE_REMOVE;
      case 'FIELD_TYPE_UPDATE': {
        return ActionType.FIELD_TYPE_UPDATE;
      }
      default:
        return ActionType.FIELD_TYPE_UPDATE;
    }
  }

  // Normalize a raw field type label/value to a token used in ActionType enum construction
  private normalizeFieldTypeToken(raw: string): string {
    if (!raw) return '';
    const v = raw.trim().toLowerCase();
    if (['dropdown', 'drop down'].includes(v)) return 'DROPDOWN';
    if (['auto-number', 'autonumber', 'auto number'].includes(v)) return 'AUTONUMBER';
    if (['checkbox'].includes(v)) return 'CHECKBOX';
    if (['color'].includes(v)) return 'COLOR';
    if (['file attachment', 'file attachments', 'file', 'file_attachment', 'file_attachments'].includes(v))
      return 'FILE_ATTACHMENT';
    if (['image', 'image carousel', 'image_carousel'].includes(v)) return 'IMAGE';
    if (['radio', 'radio button', 'radio_button'].includes(v)) return 'RADIO';
    if (['yes or no', 'yes_or_no', 'yesno', 'yes/no', 'yesorno', 'yes orno'].includes(v)) return 'YESORNO';
    if (['boolean'].includes(v)) return 'BOOLEAN';
    if (['number', 'double', 'currency'].includes(v)) return 'FORMULA_TYPE';
    if (['string', 'text'].includes(v)) return 'STRING';
    if (['date time', 'datetime'].includes(v)) return 'DATETIME';
    if (['date', 'date only'].includes(v)) return 'DATE';
    if (['lookup', 'look up'].includes(v)) return 'LOOKUP';
    return v.toUpperCase();
  }

  // Determine the most specific FIELD_TYPE_UPDATE_* ActionType constant supported by the enum.
  private computeFieldTypeUpdateActionType(oldType: string, newType: string): ActionType {
    const oldTok = this.normalizeFieldTypeToken(oldType);
    const newTok = this.normalizeFieldTypeToken(newType);

    if (!oldTok || !newTok || oldTok === newTok) {
      return ActionType.FIELD_TYPE_UPDATE;
    }

    const specificAction = this.findSpecificFieldTypeAction(oldTok, newTok);
    return specificAction ?? ActionType.FIELD_TYPE_UPDATE;
  }

  private findSpecificFieldTypeAction(oldTok: string, newTok: string): ActionType | null {
    const enumAny: any = ActionType;
    const specificTargets = [
      'AUTONUMBER', 'CHECKBOX', 'COLOR', 'FILE_ATTACHMENT',
      'IMAGE', 'RADIO', 'YESORNO', 'BOOLEAN'
    ];

    // Check for source-specific action types (FROM_DROPDOWN, FROM_FORMULA_TYPE)
    const sourceAction = this.findSourceSpecificAction(oldTok, newTok, specificTargets, enumAny);
    if (sourceAction) {
      return sourceAction;
    }

    // Check for target-specific action types
    return this.findTargetSpecificAction(newTok, specificTargets, enumAny);
  }

  private findSourceSpecificAction(
    oldTok: string,
    newTok: string,
    specificTargets: string[],
    enumAny: any
  ): ActionType | null {
    const sourceTypes = ['DROPDOWN', 'FORMULA_TYPE'];

    if (!sourceTypes.includes(oldTok)) {
      return null;
    }

    if (specificTargets.includes(newTok)) {
      const key = `FIELD_TYPE_UPDATE_FROM_${oldTok}_TO_${newTok}`;
      if (enumAny[key]) {
        return enumAny[key];
      }
    }

    const fallbackKey = `FIELD_TYPE_UPDATE_FROM_${oldTok}`;
    return enumAny[fallbackKey] ?? null;
  }

  private findTargetSpecificAction(newTok: string, specificTargets: string[], enumAny: any): ActionType | null {
    if (!specificTargets.includes(newTok)) {
      return null;
    }

    const key = `FIELD_TYPE_UPDATE_TO_${newTok}`;
    return enumAny[key] ?? null;
  }

  realtimeModifiedRecords: any = [];
  initialFetchStartTime: Date;
  refAppMetaInfos: {} = {};

  constructor() {
    effect(() => {
      this.handleChange(this.activeIndex());
    });
  }

  setAddFieldsFocus() {
    setTimeout(() => {
      this.addFieldsInput?.nativeElement?.focus();
    });
  }

  loadDataTypes() {
    this.dataTypes = [
      {
        name: 'filter',
        value: 'filter',
        class: 'form-control',
        isFilter: true
      },
      {
        name: '-----------------',
        value: '',
        class: 'type-separator',
        isDivider: true
      },
      {
        name: 'String',
        value: 'String',
        class: ''
      },
      {
        name: 'Number',
        value: 'Number',
        class: ''
      },
      {
        name: 'Drop Down',
        value: 'Dropdown',
        class: ''
      },
      {
        name: 'Look Up',
        value: 'Lookup',
        class: ''
      },
      {
        name: 'Date Time',
        value: 'DateTime',
        class: ''
      },
      {
        name: 'Boolean',
        value: 'Boolean',
        class: ''
      },
      {
        name: 'Text',
        value: 'Text',
        class: ''
      },
      {
        name: '-----------------',
        value: '',
        class: 'type-separator',
        isDivider: true
      },
      {
        name: 'CheckBox',
        value: 'Checkbox',
        class: ''
      },
      {
        name: 'Checkbox Group',
        value: 'Checkboxgroup',
        class: ''
      },
      {
        name: 'Currency',
        value: 'Currency',
        class: ''
      },
      {
        name: 'Date Only',
        value: 'Date',
        class: ''
      },
      {
        name: 'Double',
        value: 'Double',
        class: ''
      },
      {
        name: 'Email',
        value: 'Email',
        class: ''
      },
      {
        name: 'File Attachment',
        value: 'File Attachments',
        class: ''
      },
      {
        name: 'Image Carousel',
        value: 'Image Carousel',
        class: ''
      },
      {
        name: 'Radio Button',
        value: 'Radio',
        class: ''
      },
      {
        name: 'URL',
        value: 'URL',
        class: ''
      },
      {
        name: 'Yes No',
        value: 'Yes No',
        class: ''
      },
      {
        name: 'Color',
        value: 'Color',
        class: ''
      },
      {
        name: 'Auto Number',
        value: 'Auto-number',
        class: ''
      },
      {
        name: '-----------------',
        value: '',
        class: 'type-separator',
        isDivider: true
      }
    ];
  }

  unsubscribeListener() {
    this.unSubList.forEach((k) => {
      if (k && typeof k.unsubscribe === 'function') {
        k.unsubscribe();
      }
    });
  }

  ngOnDestroy(): void {
    /* Autounsubscribe will unsubscribe all the subscriptions added to subscriptions array. */
    this.utilService.destroyFancyTreeSubscriptions($('#tree'));
    this.unsubscribeListener();

    // Store data in IndexedDB before destroying component
    if (this.fsData && this.fsData.length > 0) {
      this.dataModelService.storeDataModels(this.appId, this.fsData);
    }

    this.store.dispatch(propertyActions.setPropertiesData({ propertiesData: null }));
    this.store.dispatch(setSampleData({ sampleDataTable: null }));
    this.sub.unsubscribe();
    this.sampleDataSub.unsubscribe();
    this.store.dispatch(
      deleteViewerInfo({
        delApiConstants: ApiConstants.deleteViewer,
        userData: {
          entityName: 'ApplicationDataModel',
          name: this.appId,
          email: this.user.email,
          tabId: this.tabId,
          orgId: this.orgId,
          entityId: this.viewerSid
        }
      })
    );
    /* Remove event listeners to avoid memory leak.
       Since it is using in Js it will not be garbage collected automatically and will be there in detached dom elements */
    $('tr').off('click');
    $('tr').find('#filter').off('keyup');
    $('tr').find('#filter').off('search');
    $('.input').off('keydown');
    $(':ui-fancytree').fancytree('destroy');
    $('.data-field-type').off();
    $('.data-field-type').remove();
    $('tr').off();
    $('tr').remove();
    $('#tree').remove();
    /* Remove Html element to avoid memory leak.
    Since it is using in Js it will not be garbage collected automatically and will be there in detached dom elements */
    if (this.splitter?.el?.nativeElement) {
      $(this.splitter.el?.nativeElement).remove();
    }
    this.removeDiagram();
    this.loader.hide();
    if ($('.context-menu-list')) {
      $('.context-menu-list').remove();
      if ($('#context-menu-layer')) {
        $('#context-menu-layer').remove();
      }
    }
  }

  loadTableProperties() {
    const apiConstants: any = {
      ...ApiConstants.getDatamodelProperties,
      ...{
        fetchType: 'table'
      }
    };
    this.store.dispatch(propertyActions.getPropertiesData({ propPaneApiConstants: apiConstants }));
  }

  loadFieldProperties(fieldType?: string) {
    const apiConstants: any = {
      ...ApiConstants.getDatamodelProperties,
      ...{
        fetchType: 'field',
        fieldType
      }
    };
    this.store.dispatch(propertyActions.getPropertiesData({ propPaneApiConstants: apiConstants }));
  }

  /**
   * Gets the latest data from fsData for a given sid.
   * This ensures we always use fresh data even if tree nodes have stale cached data.
   */
  getLatestDataFromFsData(sid: string): any {
    if (!sid || !this.fsData) {
      return null;
    }
    return this.fsData.find((d) => d?.sid === sid) || null;
  }

  loadFieldValues(data) {
    this.propertyLoading = true;
    if (data) {
      this.store.dispatch(propertyActions.setPropertiesValues({ propertiesValues: data }));
    }
  }

  loadTableValueBySid(data) {
    this.propertyLoading = true;
    if (data) {
      this.store.dispatch(propertyActions.setPropertiesValues({ propertiesValues: data }));
    }
  }

  showMessage(status: string, message: string, detail?: string) {
    this.messageService.clear();
    this.messageService.add({
      life: 10000,
      severity: status,
      summary: message,
      detail: detail
    });
  }

  removeDiagram() {
    setTimeout(() => {
      if (document.querySelector('#diagram')) {
        document.querySelector('#diagram')?.remove();
      }
    });
  }

  callback(svgCode) {
    return svgCode;
  }

  setExcelColumns() {
    if (!this.initialFieldProperties) {
      return;
    }
    this.excelColumns = [
      { type: 'text', title: 'Group', width: 120 },
      { type: 'text', title: 'Table', width: 120 },
      { type: 'text', title: 'FieldGroup', width: 120 },
      { type: 'text', title: 'Field', width: 120 }
    ];
    for (const property in this.initialFieldProperties) {
      const obj = this.initialFieldProperties[property];
      for (const key in obj) {
        const column = { type: 'text', title: obj[key].label, width: 120 };
        this.excelColumns.push(column);
      }
    }
  }

  getAllRoles() {
    const apiConstants = ApiConstants.getRolesData;
    this.store.dispatch(
      getRoles({
        apiConstants,
        filter: {
          start: 0,
          length: 1000
        }
      })
    );
  }
  configureTableProperties(node: any) {
    this.store.dispatch(propertyActions.setPropertiesValues({ propertiesValues: null }));
    this.showPropPane = true;
    // Sync tree node data with latest data from fsData
    if (node?.data?.sid) {
      const freshData = this.getLatestDataFromFsData(node?.data?.sid);
      if (freshData) {
        node.data = { ...node.data, ...freshData };
      }
    }
    this.loadTableProperties();
    if (!node.title) {
      return;
    }
    const sid = node?.data?.sid || node?.data?.id;
    this.loadTableValueBySid(node?.data);
    this.store.dispatch(propertyActions.setTableNames({ tableNames: this.normalTables }));
    const picklist = {
      fields: [],
      tables: [],
      primaryFields: [],
      noImgFAFields: [],
      allFields: [],
      lookupFields: [],
      indexFields: []
    };
    const parentNode = this.getParentTable(node);
    const fields = parentNode.children;
    picklist.fields = this.formPickuplistProperties(fields, picklist.fields);
    const tree = $.ui.fancytree.getTree('#tree');
    const tables = tree.rootNode?.children;
    picklist.tables = this.formPickuplistforTable(tables, sid, picklist.tables);
    this.store.dispatch(propertyActions.setPickupProperties({ picklist: null }));
    this.store.dispatch(setAllTables({ allTables: null }));
    this.store.dispatch(setAllTables({ allTables: picklist.tables }));
    if (
      node?.data?.t_type === DMConstants.TRANS_ANALY ||
      node?.data?.t_type === DMConstants.TRANS_ONLY ||
      node?.data?.t_type === DMConstants.QUERY_VIEW ||
      node?.data?.t_type === DMConstants.TRANSIENT
    ) {
      this.pickupListService.configurePickupList(sid, picklist);
    } else if (node?.data?.t_type === DMConstants.ANALY_ONLY) {
      if (!this.isRdbms) {
        this.pickupListService.configurePickupList(sid, picklist);
      } else {
        this.store.dispatch(propertyActions.setPickupProperties({ picklist }));
      }
    }
    // if (node?.data?.t_type === DMConstants.TRANS_ANALY || node?.data?.t_type === DMConstants.ANALY_ONLY) {
    //   this.getTechStackData();
    // }
  }

  setMandatoryAndLookupFields(node, tableId) {
    this.store.dispatch(setFields({ fields: null }));
    this.getFields(tableId);
    this.store.dispatch(propertyActions.setLookupFields({ lookupFields: null }));
    this.store.dispatch(propertyActions.setMandatryFil({ mandatoryFilters: null }));
    if (node?.data?.f_lookupTo) {
      const apiConstants = ApiConstants.getDatamodelTableData;
      this.showLoader = true;
      //this.propertyLoading = false;
      this.EventTracker.start('lookupSub');
      const lookupSub = this.bs[apiConstants.method](apiConstants, { sid: node?.data?.f_lookupTo }).subscribe({
        next: (data: any) => {
          this.EventTracker.stop('lookupSub');
          console.log(`lookupSub : ${this.EventTracker.trackedEvents.lookupSub.duration}`);
          try {
            const lookupFields = data.t_lookupFields;
            this.store.dispatch(
              propertyActions.setLookupFields({
                lookupFields: lookupFields
              })
            );
            const mandatoryFilters = data.t_mFilters;
            const optionalFilters = data.t_oFilters;
            if (mandatoryFilters || optionalFilters) {
              this.store.dispatch(
                propertyActions.setMandatryFil({
                  mandatoryFilters: {
                    mandatoryFilters: data.t_mFilters,
                    optionalFilters: data.t_oFilters
                  }
                })
              );
            }
            this.showLoader = false;
          } catch (e) {
            console.error(e);
            this.showLoader = false;
          }
        },
        error: (error: any) => {
          this.showLoader = false;
        }
      });
      this.addToSubscriptionsList(lookupSub);
      this.EventTracker.start('fieldsSub');
      let tableId;
      tableId = node?.data?.f_lookupTo;
      const fieldsSub = this.bs[apiConstants.method](ApiConstants.getFieldInfo, { tableId: tableId }).subscribe({
        next: (data: any) => {
          this.EventTracker.stop('fieldsSub');
          console.log(`fieldsSub : ${this.EventTracker.trackedEvents.fieldsSub.duration}`);
          try {
            this.store.dispatch(propertyActions.settableFields({ tabMapFlds: null }));
            const tabMapFlds = data;
            this.store.dispatch(
              propertyActions.settableFields({
                tabMapFlds: tabMapFlds
              })
            );
          } catch (e) {
            console.error(e);
          }
        },
        error: (error: any) => {
          console.error(error);
        }
      });
      this.addToSubscriptionsList(fieldsSub);
    }
  }

  configureFieldProperties(node: any) {
    this.showPropPane = true;
    this.loadFieldProperties(node?.data?.f_type);
    if (!node.title) {
      return;
    }
    const sid = node?.data?.sid || node?.data?.id;
    this.qbService.configureQueryBuilder(this.appUserTableId, node.data.f_tableId, this.currentTableName, sid);
    this.loadFieldValues(node?.data);
    const parentNode = this.getParentTable(node);
    this.store.dispatch(propertyActions.setParentNodeType({ parentNodeType: null }));
    this.store.dispatch(propertyActions.setParentNodeType({ parentNodeType: parentNode?.data?.t_type }));
    if (node?.data?.f_type?.toLowerCase() === 'lookup') {
      this.setMandatoryAndLookupFields(node, node.data.f_tableId);
    }
  }

  configureTableGroupProperties(data: any) {
    this.showPropPane = false;
    this.store.dispatch(propertyActions.setPropertiesData({ propertiesData: null }));
    this.store.dispatch(propertyActions.setPropertiesValues({ propertiesValues: null }));
  }

  configureFieldGroupProperties(data: any) {
    this.showPropPane = false;
    this.store.dispatch(propertyActions.setPropertiesData({ propertiesData: null }));
    this.store.dispatch(propertyActions.setPropertiesValues({ propertiesValues: null }));
  }

  formPickuplistProperties(fields, picklist) {
    if (!fields) {
      return [];
    }
    fields.forEach((e) => {
      if (!e.title) {
        return;
      }
      if (e.type === nodeType.FIELD) {
        picklist.push({ name: $.ui.fancytree.unescapeHtml(e.title), sid: e?.data?.sid || e?.sid });
      } else if (e.type === nodeType.FIELDGROUP) {
        if (e.children) {
          this.formPickuplistProperties(e.children, picklist);
        }
      }
    });
    return picklist;
  }

  formPickuplistforTable(tables, sid, picklist) {
    if (!tables) {
      return [];
    }
    tables.forEach((node) => {
      if (!node.title) {
        return;
      }
      if (
        node.type === nodeType.TABLE &&
        (node?.data?.t_type === DMConstants.TRANS_ONLY || node?.data?.t_type === DMConstants.TRANS_ANALY)
      ) {
        picklist.push({ name: $.ui.fancytree.unescapeHtml(node.title), sid: node?.data?.sid });
      } else if (node.type === nodeType.GROUP) {
        if (node.children) {
          this.formPickuplistforTable(node.children, sid, picklist);
        }
      }
    });
    return picklist;
  }

  debounceFilter = debounce(this.filterTree.bind(this), this.debounceTime / 3);

  filterTreeContent(e) {
    const tree = $.ui.fancytree.getTree('#tree'),
      match = e.target.value;
    console.log(`filterTreeContent match value: ${match}`);
    if ((e && e.which === $.ui.keyCode.ESCAPE) || $.trim(match as string) === '') {
      tree.clearFilter();
      return;
    }
    this.debounceFilter(e);
  }

  filterTree(e) {
    let n,
      tree = $.ui.fancytree.getTree('#tree'),
      args = 'autoApply autoExpand fuzzy hideExpanders highlight leavesOnly nodata'.split(' '),
      opts: any = {},
      filterFunc = $('#branchMode').is(':checked') ? tree.filterBranches : tree.filterNodes,
      match = e.target.value;
    if ((e && e.which === $.ui.keyCode.ESCAPE) || $.trim(match as string) === '') {
      tree.clearFilter();
      return;
    }
    console.log(`filterTree match value: ${match}`);
    $.each(args, function (i, o) {
      opts[o] = $(`#${o}`).is(':checked');
    });
    opts.mode = $('#hideMode').is(':checked') ? 'hide' : 'hide';
    /* if ($("#regex").is(":checked")) {
      n = filterFunc.call(tree, function (node) {
        return new RegExp(match as string, "i").test(node.title);
      }, opts);
    } else {
      // Pass a string to perform case insensitive matching
      n = filterFunc.call(tree, match);
    } */

    n = tree.filterNodes(match);
  }

  processTableInfos(reloadType) {
    this.complexTables = [];
    this.normalTables = [];
    this.tablesInfo.forEach((e: any) => {
      if (e?.data?.t_type === DMConstants.COMPLEX_TYPE) {
        this.complexTables.push({ sid: e?.data?.sid, name: e.title });
      } else if (e?.data?.t_type === DMConstants.TRANS_ONLY || e?.data?.t_type === DMConstants.TRANS_ANALY) {
        this.normalTables.push({ sid: e?.data?.sid, name: e.title });
      }
    });
    this.store.dispatch(propertyActions.setTableNames({ tableNames: this.normalTables }));
    if (reloadType) {
      this.loadTableInfoForType();
    }
  }

  onActivateNode(node) {
    this.showPropPane = false;
    this.store.dispatch(propertyActions.setPropertiesData({ propertiesData: null }));
    this.store.dispatch(propertyActions.setPropertiesValues({ propertiesValues: null }));
    if (!node) {
      return;
    }
    if (node.type === nodeType.TABLE) {
      this.configureTableProperties(node);
    } else if (node.type === nodeType.FIELD) {
      this.configureFieldProperties(node);
    } else if (node.type === nodeType.GROUP) {
      this.configureTableGroupProperties(node);
    } else if (node.type === nodeType.FIELDGROUP) {
      this.configureFieldGroupProperties(node);
    }
  }

  private getBetaFieldTitleIconClass(fieldTitle: string): string {
    const normalizedTitle = (fieldTitle || '').toLowerCase().replace(/[_-]+/g, ' ');

    if (/(email|mail)/.test(normalizedTitle)) {
      return 'beta-icon-mail';
    }
    if (/(language|locale)/.test(normalizedTitle)) {
      return 'beta-icon-language';
    }
    if (/(first name|last name|full name|username|user|owner|assignee|created by|modified by)/.test(normalizedTitle)) {
      return 'beta-icon-user';
    }
    if (/(role|roles|group|team|members)/.test(normalizedTitle)) {
      return 'beta-icon-users';
    }
    if (/(phone|mobile|contact)/.test(normalizedTitle)) {
      return 'beta-icon-phone';
    }
    if (/(date|time)/.test(normalizedTitle)) {
      return 'beta-icon-calendar';
    }
    if (/(address|city|state|country|location)/.test(normalizedTitle)) {
      return 'beta-icon-location';
    }
    if (/(status|active|enabled|verified)/.test(normalizedTitle)) {
      return 'beta-icon-status';
    }
    if (/(url|link|website|web)/.test(normalizedTitle)) {
      return 'beta-icon-link';
    }
    if (/(id|code|number|no\.?)/.test(normalizedTitle)) {
      return 'beta-icon-code';
    }

    // Keep new/unknown field names on a deterministic default icon.
    return 'beta-icon-default';
  }

  private getTreeNodeIconClass(node: any): string {
    switch (node?.type) {
      case nodeType.FIELD:
        if (this.isBetaAccessPrivilegeConsumable) {
          return `beta-title-icon ${this.getBetaFieldTitleIconClass(node?.title)}`;
        }
        return DMConstants.FIELD_ICON;
      case nodeType.TABLE:
        return DMConstants.TABLE_ICON;
      case nodeType.FIELDGROUP:
        return DMConstants.FIELD_GROUP_ICON;
      case nodeType.GROUP:
        return DMConstants.GROUP_ICON;
      default:
        return '';
    }
  }

  initTree(data) {
    try {
      this.EventTracker.start('initTree');

      this.companionTreeReady = true;

      if (this.isCompanionOrigin) {
        this.tryActivateCompanionVisualizer();
      }
      const treeData = cloneDeep(data);
      let parentNode;
      // this.getAllTitlesAndTableInfos(treeData);
      const $$: any = $;
      const _self = this;
      $(':ui-fancytree').fancytree('destroy');
      $('#tree').fancytree({
        treeId: '1',
        source: treeData,
        autoScroll: true,
        extensions: ['edit', 'dnd5', 'table', 'gridnav', 'contextMenu', 'filter'],
        quicksearch: true,
        tooltip: true,
        filter: {
          autoApply: true, // Re-apply last filter if lazy data is loaded
          autoExpand: true, // Expand all branches that contain matches while filtered
          counter: true, // Show a badge with number of matching child nodes near parent icons
          fuzzy: false, // Match single characters in order, e.g. 'fb' will match 'FooBar'
          hideExpandedCounter: true, // Hide counter badge if parent is expanded
          hideExpanders: false, // Hide expanders if all child nodes are hidden by filter
          highlight: true, // Highlight matches by wrapping inside <mark> tags
          leavesOnly: false, // Match end nodes only
          nodata: true // Display a 'no data' status node if result is empty
          //mode: "hide"       // Grayout unmatched nodes (pass "hide" to remove unmatched node instead)
        },
        activate: function (e, data) {
          const node: any = data.node;
          if (data?.node?.title === 'No data.') {
            data?.node?.setActive(false);
            return;
          }
          _self.activeNode = data.node;
          // Load properties when node is activated (handles cases where click doesn't fire, e.g., after edit mode)
          if (!node.data.isNewRec) {
            const nodeTypeLabel = node.type === 'TABLE' ? 'Table' : 'Field';
            _self.selectedNodeTitle =
              node.title && node.type
                ? `${nodeTypeLabel}  Properties :  ${node.title}`
                : '';
            _self.zone.run(() => {
              _self.onActivateNode(node);
            });
          }
          _self.rowid = node.data.sid;
        },
        deactivate: function (e, data) {
          _self.prevActiveNode = data.node;
        },
        expand: function (event, data) {
          /* empty */
        },
        dblclick: function (event, data) {
          const target = event.originalEvent?.target;
          if (!target || !$(target).hasClass('fancytree-expander')) {
            data.node.editStart();
          }
          return false; // Prevent default expand/collapse behavior
        },
        contextMenu: {
          menu: function (node) {
            const menu: any = {};
            if (!_self.disallowEdit && !node.data.isNewRec) {
              switch (node.type) {
                case nodeType.GROUP: {
                  menu.addGroup = { name: 'Add Group', icon: 'add' };
                  menu.addChildGroup = { name: 'Add Child Group', icon: 'add' };
                  menu.sep1 = '-------';
                  menu.addChildTable = { name: 'Add Table', icon: 'add' };
                  if (!node.data.sysGen) {
                    menu.sep2 = '-------';
                    menu.delete = { name: 'Delete Group', icon: 'delete', disabled: false };
                  }
                  break;
                }
                case nodeType.FIELDGROUP: {
                  menu.addChildField = { name: 'Add Field', icon: 'add' };
                  menu.addChildFields = { name: 'Add Multiple Fields', icon: 'add' };
                  menu.sep1 = '-------';
                  menu.addFieldGroup = { name: 'Add Child Field Group', icon: 'add' };
                  menu.sep2 = '-------';
                  menu.addFieldGroupAbove = { name: 'Add Sibling Field Group Above', icon: 'add' };
                  menu.addFieldGroupBelow = { name: 'Add Sibling Field Group Below', icon: 'add' };
                  if (!node.data.sysGen) {
                    menu.sep3 = '-------';
                    menu.delete = { name: 'Delete Field Group', icon: 'delete', disabled: false };
                  }
                  break;
                }
                case nodeType.TABLE: {
                  menu.addChildField = { name: 'Add Field', icon: 'add', class: 'test' };
                  menu.addChildFields = { name: 'Add Multiple Fields', icon: 'add' };
                  if (['transactional_only', 'transactional_+_analytical'].indexOf(node.data.t_type) !== -1) {
                    menu.addAiFields = { name: 'AI Suggest Fields', icon: 'add' };
                  }
                  menu.sep1 = '-------';
                  menu.addFieldGroup = { name: 'Add Field Group', icon: 'add' };

                  menu.sep2 = '-------';
                  menu.whereUsed = { name: 'Where Used', icon: 'where-used', disabled: false };
                  if (!node.data.sysGen) {
                    menu.sep3 = '-------';
                    menu.delete = { name: 'Delete Table', icon: 'delete', disabled: false };
                  }
                  menu.sep4 = '-------';
                  menu.addSiblingTableAbove = { name: 'Add Table Above', icon: 'add' };
                  menu.addSiblingTable = { name: 'Add Table Below', icon: 'add' };

                  break;
                }
                case nodeType.FIELD: {
                  menu.addSiblingFieldAbove = { name: 'Add Field Above', icon: 'add' };
                  menu.addSiblingField = { name: 'Add Field Below', icon: 'add' };
                  menu.sep1 = '-------';
                  menu.addFieldGroupBelow = { name: 'Add Field Group', icon: 'add' };
                  if (!node.data.sysGen) {
                    menu.sep2 = '-------';
                    menu.whereUsed = { name: 'Where Used', icon: 'where-used', disabled: false };
                    menu.sep3 = '-------';
                    menu.delete = { name: 'Delete Field', icon: 'delete', disabled: false };
                  }
                  break;
                }
                default:
              }
            }

            return menu;
          },
          actions: function (node, action, options) {
            _self.handleContextMenuClick(node, action, options, false);
          }
        },
        edit: {
          triggerStart: ['f2', 'mac+enter'],
          beforeEdit: function (event: any, data: any) {
            const node = data.node;
            if (data.node.data?.sysGen) {
              _self.zone.run(() => {
                _self.showMessage('error', 'System-Generated Fields Cannot Be Edited');
              });
              return false;
            }
            if (_self.disallowEdit && !data.node.data?.isNewRec) {
              return false;
            }
            return true;
          },
          edit: function (event: any, data: any) {
            _self.curNodeData = data;
            $(data.input)
              .off('keydown')
              .on('keydown', function (event) {
                if (event.which !== $.ui.keyCode.ESCAPE && event.which !== $.ui.keyCode.ENTER) {
                  event.stopPropagation();
                  const title: any = $(data.input).val();
                  if (title.length > _self.titleMaxLength) {
                    _self.zone.run(() => {
                      _self.showMessage(
                        'error',
                        _self.translate.instant('NAME_MAX_LENGTH_ERROR', { maxNo: _self.titleMaxLength })
                      );
                    });
                  }
                } else {
                  const node = data.node;
                  switch (event.which) {
                    case $.ui.keyCode.ESCAPE:
                      node.editEnd(false, event);
                      break;
                    case $.ui.keyCode.ENTER:
                      node.editEnd(true, event);
                    //  return false; // so we don't start editmode on Mac
                  }
                }
              });
          },
          click: function (event: any, data: any) {
            console.log(event, data);
          },
          beforeClose: function (event: any, data: any) {
            if ($('#tree').length === 0) {
              return true;
            }
            if (!data.save) {
              return true;
            }
            const nodeTitle = $(data.input).val();
            if (!nodeTitle) {
              return true;
            }
            if (!data.originalEvent) {
              return false;
            }
            if (data.originalEvent.target.closest('.p-toast')) {
              return false;
            } // used closet to handle the clikcks anywhere on the toast, not triggering any other actions when clicked on the toast.
            const rename = !data.isNew && data.save;
            let oldtitleToCheck;
            if (rename) {
              oldtitleToCheck = data.orgTitle.toLowerCase();
              oldtitleToCheck = oldtitleToCheck.replace(/\s\s+/g, ' ');
            }
            const title: any = $(data.input).val();

            if (data.originalEvent?.type === 'blur') {
              data.originalEvent.preventDefault();
              return false;
            }
            if (data.originalEvent?.type === 'keydown') {
              if (data.originalEvent?.keyCode === 27) {
                return true;
              }
            }
            let start = performance.now();
            if (title.length > _self.titleMaxLength) {
              _self.zone.run(() => {
                _self.showMessage(
                  'error',
                  _self.translate.instant('NAME_MAX_LENGTH_ERROR', { maxNo: _self.titleMaxLength })
                );
              });
              return false;
            }
            if (!title) {
              return true;
            }
            start = performance.now();
            const myRe = /^[a-zA-Z][a-zA-Z0-9 _]*$/;

            const array = myRe.exec(title);
            if (!array) {
              _self.zone.run(() => {
                _self.showMessage('error', _self.translate.instant('ALPHANUMEREIC_CHARACTERS_ALLOWED'));
              });
              //data.node.setTitle('');
              data.originalEvent.preventDefault();
              //data.save = false;
              return false;
            }
            const node = data.node;
            start = performance.now();
            let titleToCheck = title.toLowerCase();
            titleToCheck = titleToCheck.replace(/\s\s+/g, ' ');
            const nType = {
              TABLE: 'Table name',
              FIELD: 'Field name',
              FIELD_GROUP: 'Field group name',
              TABLE_GROUP: 'Group name'
            };

            if (
              _self.util.getRestrictedKeywords().some((keyword) => keyword.toLowerCase() === titleToCheck.toLowerCase())
            ) {
              _self.zone.run(() => {
                const translatedMessage = _self.utilService.showKeywordWarning('Reserved Keyword', nType[node.type]);
                _self.messages.name = translatedMessage;
                _self.showMessage('error', translatedMessage);
                data.input.val('');
              });
              data.originalEvent.preventDefault();
              return false;
            }
            if (titleToCheck?.toLowerCase() === GlobalConstants.isActiveField.toLowerCase()) {
              _self.zone.run(() => {
                _self.showMessage('error', _self.translate.instant('RES_FLD_NAME'));
                data.input.val('');
              });
              data.originalEvent.preventDefault();
              return false;
            }

            if (_self.systemFields.includes(titleToCheck)) {
              _self.zone.run(() => {
                _self.showMessage('error', _self.translate.instant('SYS_FLD_WARN'));
              });
              data.originalEvent.preventDefault();
              return false;
            }

            if (_self.isRdbms && _self.util.getRestrictedSQLKeywords().includes(titleToCheck)) {
              _self.zone.run(() => {
                const translatedMessage = _self.utilService.showKeywordWarning('Sql Keyword', nType[node.type]);
                _self.messages.name = translatedMessage;
                _self.showMessage('error', translatedMessage);
                data.input.val('');
              });
              data.originalEvent.preventDefault();
              return false;
            }
            start = performance.now();
            if (rename && oldtitleToCheck === titleToCheck) {
              $(data.input).off('keydown'); //To avoid memory leak
              return true;
            }
            if (_self.pendingService?.isPending?.getValue() && !rename) {
              _self.zone.run(() => {
                _self.showMessage('info', _self.translate.instant('CONCURRENCY_ERROR1'));
              });
              _self.waitingNode = node;
              data.originalEvent.preventDefault();
              return false;
            }

            _self.messageService.clear();

            switch (node.type) {
              case nodeType.GROUP:
                if (!_self.groupTitles) {
                  _self.groupTitles = [titleToCheck];
                }
                if (_self.groupTitles.includes(titleToCheck)) {
                  _self.zone.run(() => {
                    _self.showMessage('error', _self.translate.instant('DUPLICATE_GROUPNAME'));
                  });
                  data.originalEvent.preventDefault();
                  return false;
                } else if (_self.tableTitles?.includes(titleToCheck)) {
                  _self.zone.run(() => {
                    _self.showMessage('error', _self.translate.instant('DUPLICATE_GROUP_TABLE_NAMES'));
                  });
                  data.originalEvent.preventDefault();
                  return false;
                }
                if (rename && _self.groupTitles.includes(oldtitleToCheck)) {
                  const i = _self.groupTitles.indexOf(oldtitleToCheck);
                  _self.groupTitles[i] = titleToCheck;
                } else {
                  _self.groupTitles.push(titleToCheck);
                }

                break;
              case nodeType.TABLE:
                if (!_self.tableTitles) {
                  _self.tableTitles = [titleToCheck];
                }
                if (_self.utilService.getRestrictedTableKeywords().includes(_self.toLowerCaseKeywords(titleToCheck))) {
                  _self.zone.run(() => {
                    const translatedMessage = _self.utilService.showKeywordWarning('Reserved Keyword', titleToCheck);
                    _self.showMessage('error', translatedMessage);
                  });
                  data.originalEvent.preventDefault();
                  return false;
                } else if (_self.tableTitles.includes(titleToCheck)) {
                  _self.zone.run(() => {
                    _self.showMessage('error', _self.translate.instant('DUPLICATE_TABLENAME'));
                  });
                  data.originalEvent.preventDefault();
                  return false;
                } else if (_self.groupTitles?.includes(titleToCheck)) {
                  _self.zone.run(() => {
                    _self.showMessage('error', _self.translate.instant('DUPLICATE_GROUP_TABLE_NAMES'));
                  });
                  data.originalEvent.preventDefault();
                  return false;
                }
                if (rename && _self.tableTitles.includes(oldtitleToCheck)) {
                  const i = _self.tableTitles.indexOf(oldtitleToCheck);
                  _self.tableTitles[i] = titleToCheck;
                } else {
                  _self.tableTitles.push(titleToCheck);
                }

                break;
              case nodeType.FIELD:
                const parentKey = _self.getParentTable(node)?.key;
                // Use fieldTitles as the source of truth: it is kept in sync synchronously on
                // add (createFields), delete (removeTitles) and rename, unlike dataModelFlds
                // which only updates asynchronously via the Firestore listener.
                const fieldNames = _self.fieldTitles[parentKey];
                const normalizedNames = fieldNames?.map((f: string) => f.toLowerCase().replace(/ /g, ''));
                const oldNameToCheck = rename ? oldtitleToCheck.replace(/ /g, '') : null;
                // Exclude the field's own current name (one occurrence) so renaming a field to a
                // spacing/casing variant of itself is not incorrectly flagged as a duplicate.
                const namesToValidate = normalizedNames ? [...normalizedNames] : [];
                if (rename && oldNameToCheck) {
                  const selfIdx = namesToValidate.indexOf(oldNameToCheck);
                  if (selfIdx > -1) {
                    namesToValidate.splice(selfIdx, 1);
                  }
                }
                if (namesToValidate.includes(titleToCheck.replace(/ /g, ''))) {
                  _self.zone.run(() => {
                    _self.showMessage('error', _self.translate.instant('DUPLICATE_FIELDNAME'));
                  });
                  data.originalEvent.preventDefault();
                  return false;
                }
                if (fieldNames) {
                  if (rename && normalizedNames.includes(oldNameToCheck)) {
                    const i = normalizedNames.indexOf(oldNameToCheck);
                    _self.fieldTitles[parentKey][i] = titleToCheck;
                  } else {
                    _self.fieldTitles[parentKey].push(titleToCheck);
                  }
                } else {
                  _self.fieldTitles[parentKey] = [titleToCheck];
                }

                break;
              case nodeType.FIELDGROUP:
                const groupparentKey = _self.getParentTable(node)?.key;
                const fieldGroups = _self.fieldGroupTitles[groupparentKey];
                if (fieldGroups && fieldGroups.includes(titleToCheck)) {
                  _self.zone.run(() => {
                    _self.showMessage('error', _self.translate.instant('DUPLICATE_FIELDGROUP_NAME'));
                  });
                  data.originalEvent.preventDefault();
                  return false;
                }
                if (fieldGroups) {
                  if (rename && fieldGroups.includes(oldtitleToCheck)) {
                    const i = fieldGroups.indexOf(oldtitleToCheck);
                    _self.fieldGroupTitles[groupparentKey][i] = titleToCheck;
                  } else {
                    _self.fieldGroupTitles[groupparentKey].push(titleToCheck);
                  }
                } else {
                  _self.fieldGroupTitles[groupparentKey] = [titleToCheck];
                }

                break;
            }
            $(data.input).off('keydown'); //To avoid memory leak
            return true;
          },
          save: function (event: any, data: any) {
            setTimeout(function () {
              // To check whether the node is available in tree because concurrent user might have delete
              const tree = $.ui.fancytree.getTree('#tree');
              const treNode = tree.getNodeByKey(data.node.key);
              if (treNode) {
                let title = data.node.title;
                title = title.replace(/\s\s+/g, ' '); //Remove multiple spaces inside the name
                data.node.setTitle(title);
                _self.saveFancyTreeTableOrder(data);
                // Recompute the beta field-name based icon now that the title is finalized
                if (_self.isBetaAccessPrivilegeConsumable && data.node.type === nodeType.FIELD) {
                  data.node.icon = _self.getTreeNodeIconClass(data.node);
                }
                // Re-render node to show icon after save
                data.node.render(true);
              }
            });
            return true;
          },
          close: function (event: any, data: any) {
            // Editor was removed
            _self.curNodeData = null;
            if (data.save && data.isNew) {
              // Since we started an async request, mark the node as preliminary
              $(data.node.span).addClass('pending');
              let command = 'addChildField';
              switch (data.node.type) {
                case nodeType.GROUP:
                  command = 'addGroup';
                  break;
                case nodeType.TABLE:
                  command = 'addSiblingTable';
                  break;
                case nodeType.FIELD:
                  command = 'addSiblingField';
                  break;
                case nodeType.FIELDGROUP:
                  command = 'addFieldGroup';
                  break;
                default:
                  command = 'addChildField';
                  break;
              }
              if (data && data.originalEvent && data.originalEvent.type === 'mousedown') {
                return;
              }
              const node = data.node;
              _self.createNode(data.node, command, {}, true);
              $(data.node.span).removeClass('pending');
            }
          }
        },
        dnd5: {
          preventRecursion: true, // Prevent dropping nodes on own descendants
          preventVoidMoves: true, // Prevent moving nodes 'before self', etc.
          preventForeignNodes: true,
          scroll: true,
          scrollSensitivity: 60,
          scrollSpeed: 5,
          dragStart: function (node, data: any) {
            _self.isDragging = true;
            data.effectAllowed = 'all';
            data.dropEffect = 'move';
            // Return true to allow the drag operation
            if (data.node.data.sysGen) {
              _self.isDragging = false;
              return false;
            }
            if (data.node.type === nodeType.FIELD || data.node.type === nodeType.FIELDGROUP) {
              parentNode = _self.getParentTable(data.node);
            }
            return true;
          },
dragEnd: function (node, data) {
            _self.isDragging = false;
            _self.rearrageTreeLegIndicator(50);
          },
          dragEnter: function (node, data) {
            return true;
          },
          dragDrop: function (node: any, data) {
            // Check if dragged node exists in fsData array before allowing drop
            const draggedNodeSid = data.otherNode?.data?.sid;
            if (draggedNodeSid && !_self.fsData?.some((item) => item?.sid === draggedNodeSid)) {
              _self.showMessage('warn', _self.translate.instant('NODE_NOT_SYNCED'));
              return;
            }

            let newNode,
              transfer = data.dataTransfer,
              sourceNodes = data.otherNodeList,
              mode = data.dropEffect;
            if (data.hitMode === 'after') {
              // If node are inserted directly after tagrget node one-by-one,
              // this would reverse them. So we compensate:
              sourceNodes.reverse();
            }
            if (data.otherNode) {
              if (_self.pendingService?.isPending?.getValue()) {
                _self.showMessage('info', _self.translate.instant('CONCURRENCY_ERROR1'));
              } else {
                _self.messageService.clear();
                // Drop another Fancytree node from same frame (maybe a different tree however)
                if (mode === 'move') {
                  if (data.otherNode.type === nodeType.FIELD) {
                    if (
                      ((data.hitMode === 'after' || data.hitMode === 'before') &&
                        (node.type === nodeType.FIELD || node.type === nodeType.FIELDGROUP)) ||
                      (data.hitMode === 'over' && (node.type === nodeType.TABLE || node.type === nodeType.FIELDGROUP))
                    ) {
                      const curParent = _self.getParentTable(data.node);
                      if (
                        parentNode.data?.sid === curParent.data?.sid &&
                        _self.checkForDuplicates(node, data.otherNode)
                      ) {
                        _self.updateonDragEnd(node, data);
                      }
                    }
                  } else if (data.otherNode.type === nodeType.FIELDGROUP) {
                    if (
                      ((data.hitMode === 'after' || data.hitMode === 'before') &&
                        (node.type === nodeType.FIELD || node.type === nodeType.FIELDGROUP)) ||
                      (data.hitMode === 'over' && node.type === nodeType.TABLE)
                    ) {
                      const curParent = _self.getParentTable(data.node);
                      if (
                        parentNode.data?.sid === curParent.data?.sid &&
                        _self.checkForDuplicates(node, data.otherNode)
                      ) {
                        _self.updateonDragEnd(node, data);
                      }
                    }
                  } else if (data.otherNode.type === nodeType.TABLE) {
                    if (
                      ((data.hitMode === 'after' || data.hitMode === 'before') &&
                        (node.type === nodeType.TABLE || node.type === nodeType.GROUP)) ||
                      (data.hitMode === 'over' && node.type === nodeType.GROUP)
                    ) {
                      // && node.parent["type"]=="G"
                      _self.updateonDragEnd(node, data);
                    }
                  } else if (data.otherNode.type === nodeType.GROUP) {
                    if (
                      // Table 
                      ((data.hitMode === 'after' || data.hitMode === 'before') &&
                        (node.type === nodeType.TABLE || node.type === nodeType.GROUP)) ||
                      (data.hitMode === 'over' && node.type === nodeType.GROUP)
                    ) {
                      _self.updateonDragEnd(node, data);
                    }
                  }
                }
              }
            } else {
              // Drop a non-node
              node.addNode({ title: transfer.getData('text') }, data.hitMode);
            }
            // node.setExpanded();
          }
        },
        table: {
          indentation: 40,
          nodeColumnIdx: 1,
          checkboxColumnIdx: 0
        },
        gridnav: {
          autofocusInput: false,
          handleCursorKeys: true
        },

        createNode: function (event, data) {
          const isauditfield = ['sid', 'created by', 'modified by', 'created date', 'modified date'].includes(
            data.node.title?.toLowerCase()
          );
          //let toggleFields = ["sid", "created by", "modified by", "created date", "modified date"]
          const node: any = data.node,
            $tdList = $(node.tr).find('>td');
          //Hide and show system generated fields
          if (node.data?.sysGen && node.type === nodeType.FIELD && isauditfield) {
            $(node.tr).attr('audit-field', 'yes');
          }
          if (node.type === nodeType.TABLE) {
            if (!node.isFolder()) {
              data.node.folder = true;
            }
          }

          const childs = node.children || [];
          const levelClassc = `level${node.getLevel()}`;
          let nodeVerticalBarHeight = 36 * (childs.length - 1) - 10; //+ 13 + 20;
          $($tdList[1]).find('>.vertical-line, >.horizondal-line').remove();

          // Span the remaining columns if it's a folder.
          // We can do this in createNode instead of renderColumns, because
          // the `isFolder` status is unlikely to change later
          if (node.isFolder()) {
            if (!_self.isBetaAccessPrivilegeConsumable) {
              const verticalLine = $('<div>')
                .addClass(`vertical-line ${levelClassc}`)
                .css({
                  height: `${nodeVerticalBarHeight}px`
                });

              if (!node.isExpanded()) {
                verticalLine.hide();
              }

              $($tdList[1]).append(verticalLine);

              if (levelClassc !== 'level1') {
                const horizondalLine = $('<div>').addClass(`horizondal-line ${levelClassc}`);
                $($tdList[1]).append(horizondalLine);
              }
            }
            if (node.data.isNewRec) {
              if (node.type === nodeType.TABLE || node.type === nodeType.GROUP || node.type === nodeType.FIELDGROUP) {
                $tdList.eq(1).prop('colspan', 2);
                $tdList.eq(1).next().remove();
              } else {
                $tdList.eq(1).prop('colspan', 3);
              }
              // to remove spinner td in folder node
              $tdList.eq(1).prop('colspan', 3).next().remove();
              $tdList.eq(4).off('click').on('click', '#context-menu-trigger', _self.openContextMenu.bind(_self));
              $tdList.eq(2).find('.node-spinner').removeClass('d-none');
              $tdList.eq(4).off('click').on('click', '#context-menu-trigger', _self.openContextMenu.bind(_self));
            } else {
              // to remove spinner td in folder node
              $tdList.eq(1).prop('colspan', 3).next().remove();
              // to remove field type td in folder node
              $tdList.eq(1).next().remove();
              $tdList.eq(4).off('click').on('click', '#context-menu-trigger', _self.openContextMenu.bind(_self));
            }
          } else {
            if (node.children) {
              console.log('node.children');
              console.log(node.children);
              nodeVerticalBarHeight = node.children.length * 36 - 10;
              if (!_self.isBetaAccessPrivilegeConsumable) {
                const verticalLine = $('<div>')
                  .addClass(`vertical-line ${levelClassc}`)
                  .css({
                    height: `${nodeVerticalBarHeight}px`
                  });
                if (!node.isExpanded()) {
                  verticalLine.hide();
                }
                $($tdList[1]).append(verticalLine);
              }
            }

            if (!_self.isBetaAccessPrivilegeConsumable) {
              const horizondalLine = $('<div>').addClass(`horizondal-line ${levelClassc}`);
              $($tdList[1]).append(horizondalLine);
            }

            const parentNode = _self.getParentTable(node);
            $(node.tr).attr('pid', parentNode?.data?.sid);
            if (node.type === 'FIELD') {
              $(node.tr).attr(
                'data-metadata',
                JSON.stringify({
                  sid: node.data.sid,
                  name: node.title,
                  type: 'FIELD',
                  entity: 'DATA_MODEL',
                  subType: node.data.f_type,
                  dataModelId: parentNode?.data?.sid,
                  dataModelName: parentNode?.title
                })
              );
            }
            if (!node.data.isNewRec) {
              $tdList.eq(2).find('.node-spinner').addClass('d-none');
            } else {
              $tdList.eq(2).find('.node-spinner').removeClass('d-none');
            }
          }
          if (!node.icon) {
            node.icon = _self.getTreeNodeIconClass(node);
            node.renderTitle();
          }
        },
        renderColumns: function (event, data) {
          if (data.tree.count() > 1) {
            $('.btn-wrapper').addClass('d-none');
          }
          const node: any = data.node;
          const $tdList = $(node.tr).find('>td');
          if (node.type === nodeType.TABLE || node.type === nodeType.GROUP || node.type === nodeType.FIELDGROUP) {
            if (!$tdList.eq(2).find('.contextMenu').length) {
              $tdList.eq(2).append(`<div class="dropdown contextMenu">
                <button class="btn toggle-button p-button-icon-only"
                    id="context-menu-trigger">
                   <span class="pi pi-ellipsis-v"></span>
                </button>
            </div>`);
              $tdList.eq(2)[0].classList.add('context-menu-td');
            }
            // QV parameter validation error icon
            if (node.data.t_type === 'query_view' && node.data.qvIsError) {
              if (!$tdList.eq(1).find('.qv-error-icon').length) {
                $tdList
                  .eq(1)
                  .find('.fancytree-title')
                  .after('<span class="qv-error-icon pi pi-exclamation-circle"></span>');
              }
            } else {
              $tdList.eq(1).find('.qv-error-icon').remove();
            }
            $tdList.eq(2).off('click').on('click', '#context-menu-trigger', _self.openContextMenu.bind(_self));
          } else if (node.type === nodeType.FIELD) {
            if (!$tdList.eq(3).find('.dropdown-toggle').length) {
              $tdList.eq(3).append(`<div class="dropdown dataTypes">
                <button class="btn dropdown-toggle toggle-button hidden"
                    type="button" [disabled]="disallowEdit"
                    id="data-field-type">
                    {{ 'STRING' | translate }}
                </button>
            </div>`);
              $tdList.eq(3)[0]?.classList.add('field-type');
            }
            $tdList.eq(3).find('.dropdown-toggle')[0]?.classList.remove('hidden');
            $tdList.eq(4).find('.dropdown-toggle')[0]?.classList.remove('hidden');
            if (node.data.sysGen || node.data.isNewRec || _self.disallowEdit) {
              $tdList.eq(3).find('.dropdown-toggle').attr('disabled', 'true');
            }
            const fieldType = node.data.f_type || 'String';
            if (_self.dataTypes.filter((dt) => dt.value === 'Lookup').length === 0 && fieldType === 'Lookup') {
              _self.dataTypes.push({
                name: 'Look Up',
                value: 'Lookup',
                class: ''
              });
            }
            const fieldVal = filter(_self.dataTypes, (e: any) => e.value === fieldType);
            let fieldName = '';
            if (fieldVal[0]) {
              fieldName = fieldVal[0].name;
            } else if (fieldType === DMConstants.COMPLEX_FIELD_TYPE) {
              const id = node.data.f_cDataTypeId;
              const fieldValue = filter(_self.complexTables, (e: any) => e.sid === id);
              fieldName = fieldValue[0] ? fieldValue[0].name : '';
            } else {
              const fieldValue = filter(_self.complexTables, (e: any) => e.sid === fieldType);
              fieldName = fieldValue[0] ? fieldValue[0].name : '';
            }
            $tdList.eq(3).find('#data-field-type').text(fieldName);
            $tdList.eq(3).off('click').on('click', '#data-field-type', _self.selectType.bind(_self));
            if (!$tdList.eq(4).find('.contextMenu').length) {
              $tdList.eq(4).append(`<div class="dropdown contextMenu">
                <button class="btn toggle-button p-button-icon-only"
                    id="context-menu-trigger">
                   <span class="pi pi-ellipsis-v p-button-icon"></span>
                </button>
            </div>`);
              $tdList.eq(4)[0]?.classList.add('context-menu-td');
            }
            $tdList.eq(4).off('click').on('click', '#context-menu-trigger', _self.openContextMenu.bind(_self));
            if (_self.menuItems && _self.menuItems[0].label === 'Show Audit Fields') {
              $('tr[audit-field]').attr('audit-field', 'yes');
            } else if (_self.menuItems && _self.menuItems[0].label === 'Hide Audit Fields') {
              $('tr[audit-field]').attr('audit-field', 'no');
            }
          }
        },
        collapse: function (event, data) {
          (data?.node?.children || []).forEach((ele) => {
            $(ele?.tr)?.remove();
          });
        },
        modifyChild: function (event: any, data: any) {
          data.tree.info(event.type, data);
          // Skip expensive tree line recalculation during active drag to prevent lag
          if (!_self.isDragging) {
          _self.rearrageTreeLegIndicator(50);
          }
        },
        click: (event: any, data: any) => {
          if (data?.node?.title === 'No data.') {
            return false;
          }
          _self.selectedNode = data;
          _self.rowid = data.node.data.sid;
          // Property loading is handled in the activate callback
          // Click handler handles UI concerns only
          const target = event.originalEvent?.target;
          const row$ = $(data.node.tr);
          if ($(target).hasClass('fancytree-expander')) {
            if (data.node.isExpanded()) {
              row$.find('.vertical-line').hide();
            } else {
              row$.find('.vertical-line').show();
            }
            _self.rearrageTreeLegIndicator(50);
          } else {
            this.rearrageTreeLegIndicator();
          }
          return true;
        },
        init: function (event, data) {
          _self.isInitilized = true;
          _self.isLoading = false;
          _self.loader.hide();
          _self.propertyLoading = false;
        }
      });
      _self.attachTreeFocusScrollGuard();
      $(_self.ftree).on('nodeCommand', function (event, data) {
        const node = data.data.node;
        _self.createNode(node, data.cmd, data.data.options, true);
      });

      _self.rearrageTreeLegIndicator(50);

      this.EventTracker.stop('initTree');
      console.log(`initTree : ${this.EventTracker.trackedEvents.initTree.duration}`);

      //
    } catch (err) {
      console.error(err);
    }
  }

  /**
   * Prevents the tree from "jumping" when a node span receives focus on click.
   *
   * When the tree has been scrolled and a partially-visible table/field node is
   * clicked, the browser focuses the node span and natively scrolls it into
   * view, snapping the scroll position. Overriding `focus()` cannot stop this
   * because focus-on-click is a browser default action, not a programmatic
   * `focus()` call. Instead we record the scroll position on `mousedown` and
   * restore it synchronously on the following `focusin` (same task, before
   * paint), so there is no visible jump. Keyboard focus (no preceding
   * `mousedown`) is left untouched.
   */
  private attachTreeFocusScrollGuard(): void {
    const container = document.querySelector('.tree-container') as HTMLElement | null;
    if (!container || this.treeFocusScrollGuardAttached) {
      return;
    }
    this.treeFocusScrollGuardAttached = true;

    // Fancytree scrolls a freshly-activated node into view when it is clicked,
    // which makes the tree "jump" on the first click after the user has
    // manually scrolled. We pin the scroll position for the duration of the
    // click gesture so selecting a node never moves the tree, while leaving
    // wheel scrolling and drag-and-drop auto-scroll untouched.
    let savedScrollTop = 0;
    let pinning = false;
    let timers: ReturnType<typeof setTimeout>[] = [];

    const restore = (): void => {
      if (pinning && container.scrollTop !== savedScrollTop) {
        container.scrollTop = savedScrollTop;
      }
    };
    const stopPinning = (): void => {
      pinning = false;
      timers.forEach((t) => clearTimeout(t));
      timers = [];
    };

    // Capture phase (runs before fancytree): remember where we were and arm
    // a short series of restores to also catch fancytree's async scroll.
    container.addEventListener(
      'mousedown',
      (event: MouseEvent) => {
        const target = event.target as HTMLElement | null;
        if (!target || !target.closest('.fancytree-node')) {
          // Ignore clicks on the scrollbar / empty area so they scroll normally.
          return;
        }
        savedScrollTop = container.scrollTop;
        pinning = true;
        timers.forEach((t) => clearTimeout(t));
        timers = [0, 16, 32, 64, 120, 200].map((delay) =>
          setTimeout(restore, delay)
        );
        timers.push(setTimeout(stopPinning, 260));
      },
      true
    );

    // Bubble phase (runs after fancytree's mousedown handler): correct the
    // synchronous scroll-into-view before the browser paints, so there is no
    // visible flicker.
    container.addEventListener(
      'mousedown',
      (event: MouseEvent) => {
        const target = event.target as HTMLElement | null;
        if (!target || !target.closest('.fancytree-node')) {
          return;
        }
        restore();
      },
      false
    );

    // Any genuine user scroll (wheel) or drag releases the pin immediately.
    container.addEventListener('wheel', stopPinning, true);
    container.addEventListener('mousemove', stopPinning, true);
  }

  formTreelinesOnDrop(node) {
    const childs = node.children || [];
    const levelClassc = `level${node.getLevel()}`;
    const nodeVerticalBarHeight = 36 * (childs.length - 1) - 10; //+ 13 + 20;
    const $tdList = $(node.tr).find('>td');
    $($tdList[1]).find('>.vertical-line, >.horizondal-line').remove();

    if (this.isBetaAccessPrivilegeConsumable) {
      if (node.children) {
        node.children.forEach((nd) => {
          this.formTreelinesOnDrop(nd);
        });
      }
      return;
    }

    if (node.isFolder()) {
      const verticalLine = $('<div>')
        .addClass(`vertical-line ${levelClassc}`)
        .css({
          height: `${nodeVerticalBarHeight}px`
        });
      if (!node.isExpanded()) {
        verticalLine.hide();
      }
      $($tdList[1]).append(verticalLine);
      if (levelClassc !== 'level1') {
        const horizondalLine = $('<div>').addClass(`horizondal-line ${levelClassc}`);
        $($tdList[1]).append(horizondalLine);
      }
      if (node.children) {
        node.children.forEach((nd) => {
          this.formTreelinesOnDrop(nd);
        });
      }
    } else {
      const horizondalLine = $('<div>').addClass(`horizondal-line ${levelClassc}`);
      $($tdList[1]).append(horizondalLine);
    }
  }

  updateonDragEnd(node, data) {
    const otherNode = data.otherNode;
    const prevSib = otherNode.getPrevSibling();
    data.otherNode.moveTo(node, data.hitMode);
    const newPrevSib = otherNode.getPrevSibling();
    const parNode = otherNode.getParent();
    const apidata = {
      draggedNode: otherNode.data.sid,
      type: otherNode.data.type,
      dragFrom: prevSib?.data.sid,
      dragTo: newPrevSib?.data.sid,
      dragFromPNode: prevSib?.data.pNode,
      dragToPNode: newPrevSib?.data.pNode,
      pNode: parNode.title === 'root' ? null : parNode.data.sid,
      appId: this.appId,
      orgId: this.orgId,
      tabId: this.tabId
    };
    this.pendingService.isPending = new BehaviorSubject(true);
    this.showLoader = true;
    this.store.dispatch(dragDropFailure({ dropFailed: null }));
    this.store.dispatch(dragDropSuccess({ dropSucc: null }));
    this.store.dispatch(
      updateDragDrop({
        dropApiConstants: ApiConstants.updateDragDrop,
        data: apidata
      })
    );
    this.formTreelinesOnDrop(node);
    if (data?.node?.title !== 'root') {
      this.formTreelinesOnDrop(this.activeNode);
    }
    const failSub = this.store.select(dropFailed).subscribe((data) => {
      if (data) {
        if (data.err) {
          this.showErrMsg(data);
          this.reloadCurrentRoute();
        }
        if (failSub) {
          failSub.unsubscribe();
        }
        this.pendingService.isPending = new BehaviorSubject(false);
        this.showLoader = false;
        if (data.actionData) {
          const tree = $.ui.fancytree.getTree('#tree');
          const node = tree.getNodeByKey(data.actionData?.draggedNode);
          if (node) {
            this.moveNode(node, node.data);
          }
        }
      }
    });
    this.addToSubscriptionsList(failSub);
    const drpSuccSub = this.store.select(dropSucc).subscribe((data) => {
      if (data) {
        if (drpSuccSub) {
          drpSuccSub.unsubscribe();
        }
        this.pendingService.isPending = new BehaviorSubject(false);
        this.showLoader = false;
      }
    });
    this.addToSubscriptionsList(drpSuccSub);
  }

  checkForDuplicates(copyToNode, currNode) {
    if (currNode.type === nodeType.FIELD || currNode.type === nodeType.FIELDGROUP) {
      const otherNodeParent = this.getParentTable(copyToNode);
      const nodeParent = this.getParentTable(currNode);
      if (otherNodeParent === nodeParent) {
        return true;
      }
      const coptToparentTable = copyToNode.type === nodeType.TABLE ? copyToNode : this.getParentTable(copyToNode);
      const parentKey = coptToparentTable.key;
      const tableFields = this.fieldTitles[parentKey];
      const title = currNode.title.toLowerCase();
      if (tableFields && tableFields.includes(title)) {
        this.showMessage('error', 'Duplicate Field names not allowed');
        return false;
      }
      if (tableFields) {
        this.fieldTitles[parentKey].push(title);
      } else {
        this.fieldTitles[parentKey] = [title];
      }
      const oldParentKey = this.getParentTable(currNode)?.key;
      const index = this.fieldTitles[oldParentKey].indexOf(title);
      if (index > -1) {
        this.fieldTitles[oldParentKey].splice(index, 1);
      }
    }
    return true;
  }

  addTable() {
    if (!this.propertiesTasks.added.length) {
      this.messages = [];
      this.showTblPopup = true;
      this.createTblPos = null;
    } else {
      this.showMessage('info', 'Currently Datamodel save is in progress. Please wait once the save is complete.');
    }
  }

  addGroup() {
    if (!this.propertiesTasks.added.length) {
      const tree: any = $.ui.fancytree.getTree('#tree');
      // Remove the "No data." placeholder node if present
      if (tree.getRootNode()?.children && tree.getRootNode()?.children[0]?.title?.toLowerCase() === 'no data.') {
        tree.getRootNode().removeChildren();
      }
      const id = uuidv4();
      const node = {
        title: '',
        sid: id,
        key: id,
        type: nodeType.GROUP,
        folder: true,
        icon: DMConstants.GROUP_ICON
      };
      // Ensure the tree is rendered before adding children.
      // When all nodes are collapsed, FancyTree uses lazy rendering and
      // the DOM elements may not exist, causing insertBefore to fail.
      const treeRootNode = tree.getRootNode();
      if (!treeRootNode.ul) {
        tree.render(true);
      }
      setTimeout(() => {
        tree.getRootNode().editCreateNode('child', node);
      }, 0);
    } else {
      this.showMessage('info', 'Currently Datamodel save is in progress. Please wait once the save is complete.');
    }
  }

  isNoDataNode(node) {
    return node.children && node.children.length === 1 && node.children[0].title === 'No data.';
  }

  isTreeOrderSave(node) {
    return node.type === nodeType.GROUP || node.type === nodeType.TABLE;
  }

  getVal(data) {
    const nodeData = data?.node?.data;
    if (this.isField(data?.node?.type)) {
      const parentNode = this.getParentTable(data?.node);
      const tableId = parentNode.data.sid || parentNode.data.id;
      return {
        name: $.ui.fancytree.unescapeHtml(data?.node.title),
        aid: this.appId,
        f_tableId: tableId,
        f_type: nodeData.f_type,
        sid: nodeData.sid,
        orgId: this.orgId
      };
    }
    return null;
  }

  /**
   *
   * @param value // newly selected data type
   * @param data // Tree node data of field for which type change happens
   */
  updateDataTypeChange(value, data, oldValue) {
    const id = data?.node?.data?.sid;
    // let apiName = "checkDatamodelReferences";
    // this.isLoading = true;
    // api reference to check on field type change
    // await this.getReferences(id, apiName).then((value: any) => {
    //   let node = $.ui.fancytree.getTree("#tree").getActiveNode();
    //   this.confirmTypeChange(node, false, value);
    // });
    this.updatedDatatypeList[id] = value;
    if (value === DMConstants.COMPLEX_FIELD_TYPE) {
      this.complexDataTypeIds[id] = data.node.data.f_cDataTypeId;
    }
    const val = data?.node?.data;
    if (!val) {
      return;
    }

    this.propertyLoading = false;
    if (this.isTableData(val)) {
      return; //Properties values table details .This is occuring while adding fields from table node and changing the datatype
    }
    const fieldTypeVal = this.updatedDatatypeList[val?.sid];
    if (!fieldTypeVal) {
      return;
    }
    delete this.updatedDatatypeList[val?.sid];
    const isComplexType = val.f_type === DMConstants.COMPLEX_FIELD_TYPE || value === DMConstants.COMPLEX_FIELD_TYPE;
    // if (val.f_type===fieldTypeVal && !isComplexType) { // if the value is same avoid unnecessaray request for save
    //   return;
    // }

    this.getDefaultValues(fieldTypeVal, data?.node);
    if (fieldTypeVal === 'Date') {
      this.formDefaultValues = { ...this.formDefaultValues, ...{ f_dFormat: this.settingsData.dateFormat } };
    }
    if (fieldTypeVal === 'DateTime') {
      this.formDefaultValues = { ...this.formDefaultValues, ...{ f_tFormat: this.settingsData.dateTimeFormat } };
    }
    let propertiesValues = cloneDeep(val);
    if (this.hasReference) {
      const node = $.ui.fancytree.getTree('#tree').getActiveNode();
      const $tdList = $(node.tr).find('>td');
      $tdList.eq(3).find('#data-field-type').text(oldValue);
      propertiesValues.f_type = oldValue;
      this.store.dispatch(propertyActions.setPropertiesValues({ propertiesValues }));
      return;
    }
    if (this.formDefaultValues) {
      const defaultFields = pick(propertiesValues, [
        'sid',
        'name',
        'f_fieldId',
        'f_sysF',
        'sysGen',
        'aid',
        'orgId',
        'recDeleted',
        'f_tableId',
        'type',
        'preNode',
        'pNode'
      ]);
      if (Object.prototype.hasOwnProperty.call(propertiesValues, 'f_hasAnalyticalSync')) {
        const parentNode = this.getParentTable(data.node);
        if (value === DMConstants.COMPLEX_FIELD_TYPE) {
          this.formDefaultValues.f_hasAnalyticalSync = false;
        } else if (parentNode?.data?.t_type === DMConstants.TRANS_ANALY) {
          this.formDefaultValues.f_hasAnalyticalSync = true;
        }
      }
      const ignoreFields = pick(propertiesValues, [
        'f_lookupToSid',
        'f_dFieldSid',
        'f_lookUpIMapSid',
        'f_lookUpOMapSid',
        'f_dpsSid'
      ]);
      const props: any = {};
      for (const prp in propertiesValues) {
        if (
          !Object.prototype.hasOwnProperty.call(this.formDefaultValues, prp) &&
          !Object.prototype.hasOwnProperty.call(defaultFields, prp) &&
          !Object.prototype.hasOwnProperty.call(ignoreFields, prp) &&
          (propertiesValues[prp] || propertiesValues[prp] === '')
        ) {
          props[prp] = null;
        }
      }
      if (propertiesValues.f_lookupTo) {
        props.old_f_lookupTo = propertiesValues.f_lookupTo;
      }
      propertiesValues = { ...props, ...defaultFields, ...this.formDefaultValues, ...ignoreFields };
    }
    propertiesValues.f_type = fieldTypeVal;
    if (propertiesValues.f_type === DMConstants.COMPLEX_FIELD_TYPE) {
      propertiesValues.f_cDataTypeId = this.complexDataTypeIds[val.sid];
      // propertiesValues.f_searchable = "no";
      delete this.complexDataTypeIds[val.sid];
    } else {
      delete propertiesValues.f_cDataTypeId;
    }
    if (value === DMConstants.AUTONUM_TYPE) {
      propertiesValues.f_editing = 'no';
    }
    if (fieldTypeVal === 'File Attachments' || fieldTypeVal === 'Image Carousel') {
      propertiesValues.f_hasAnalyticalSync = false;
    }
    if (propertiesValues.f_maxFrac) {
      propertiesValues.f_maxFrac = Number(propertiesValues.f_maxFrac);
    }
    if (propertiesValues.f_minFrac) {
      propertiesValues.f_minFrac = Number(propertiesValues.f_minFrac);
    }
    if (propertiesValues.f_maxASize) {
      propertiesValues.f_maxASize = Number(propertiesValues.f_maxASize);
    }
    if (propertiesValues.f_maxLimit) {
      propertiesValues.f_maxLimit = Number(propertiesValues.f_maxLimit);
    }
    if (propertiesValues.f_allowedFTypes) {
      propertiesValues.f_allowedFTypes = null;
    }
    if (propertiesValues.f_multiValMax) {
      propertiesValues.f_multiValMax = Number(propertiesValues.f_multiValMax);
    }
    if (propertiesValues.f_multiValMin) {
      propertiesValues.f_multiValMin = Number(propertiesValues.f_multiValMin);
    }
    // propertiesValues.valueChange = true;
    const props = cloneDeep(propertiesValues);
    delete props.preNode;
    delete props.pNode;
    delete props.name;
    let dataToSend = {
      fieldTypeProperties: {
        aid: this.appId,
        orgId: this.orgId,
        f_type: value,
        old_f_type: oldValue,
        f_cDataTypeId: propertiesValues?.f_cDataTypeId,
        f_tableId: propertiesValues?.f_tableId,
        sid: propertiesValues.sid,
        tabId: this.tabId,
        ...props,
        type: nodeType.FIELD
      }
    };
    const deletedReference: any = [];
    try {
      if (val.f_cMandatory) {
        deletedReference.push(
          this.util.createObjForDelRef(
            val.sid,
            JSON.parse(val.f_cMandatory).sid,
            utilEnum.propertyName.MANDATORY_CONDITIONAL
          )
        );
      }
      if (val.f_editC) {
        deletedReference.push(
          this.util.createObjForDelRef(val.sid, JSON.parse(val.f_editC).sid, utilEnum.propertyName.EDIT_CONDITIONAL)
        );
      }
      if (val.f_viewC) {
        deletedReference.push(
          this.util.createObjForDelRef(val.sid, JSON.parse(val.f_viewC).sid, utilEnum.propertyName.VIEW_CONDITIONAL)
        );
      }
      const formulas = JSON.parse(val?.f_formula);
      uniq(formulas.filter((f) => f.type === 'field').map((formula) => formula.fieldId)).forEach((fldid) => {
        deletedReference.push(this.util.createObjForDelRef(val.sid, fldid, utilEnum.propertyName.FORMULA_BUILDER));
      });
    } catch (e) {
      console.error(e);
    }
    if (deletedReference.length) {
      dataToSend = { ...dataToSend, ...{ deletedReference: deletedReference } };
    }
    this.store.dispatch(
      updateAppDM({
        apiConstants: ApiConstants.applDMUpdatefldType,
        appDMData: dataToSend
      })
    );
    const tree = $.ui.fancytree.getTree('#tree');
    const node = tree.getNodeByKey(val.sid);
    if (node.data.f_formula) {
      const parenttbNode = this.getParentTable(data.node);
      if (parenttbNode.data?.t_formulas) {
        try {
          const fb = JSON.parse(parenttbNode.data?.t_formulas);
          if (fb[val.sid]) {
            delete fb[val.sid];
          }
          parenttbNode.data = { ...parenttbNode.data, ...{ t_formulas: JSON.stringify(fb) } };
          const tblObj = {
            sid: parenttbNode.data.sid,
            tabId: this.tabId,
            t_formulas: parenttbNode.data.t_formulas,
            aid: this.appId,
            orgId: this.orgId,
            type: nodeType.TABLE
          };
          this.store.dispatch(
            updateAppDM({
              apiConstants: ApiConstants.updateFields,
              appDMData: [tblObj]
            })
          );
        } catch (e) {
          console.log(e);
        }
      }
    }
    node.data = propertiesValues;
    propertiesValues = { ...propertiesValues, ...{ typeChange: true } };
    this.store.dispatch(propertyActions.setPropertiesValues({ propertiesValues }));
    if (value === 'Lookup') {
      this.getFieldsByParent(node);
    }
  }

  isTableData(val) {
    return val.type === nodeType.TABLE;
  }
  isFieldData(val) {
    return val.type === nodeType.FIELD;
  }

  savePropertyPane(val: any) {
    if (!val) {
      return;
    }
    if (!val.valueChange) {
      return;
    }
    const data = { ...val };
    delete data.valueChange;
    delete data.typeChange;
    if (Object.prototype.hasOwnProperty.call(data, 'tableacl')) {
      delete data.tableacl;
    }
    if (this.isTableData(val) && !this.disallowEdit) {
      if (!this.tblTypSveInPrg) {
        this.updateTable(data);
      }
    } else if (this.isFieldData(val) && !this.disallowEdit) {
      this.updateField(data);
    }
  }

  updateParentTbl(tableData, node, action, pidFld?) {
    try {
      let obj = {
        tProps: {
          orgId: this.orgId,
          aid: this.appId,
          sid: tableData.sid,
          t_pTableId: tableData.t_pTableId,
          t_pTable: tableData.t_pTable,
          old_t_pTable: null,
          old_t_pTableId: null,
          name: tableData.name,
          old_name: '',
          tabId: this.tabId
        },
        action: action,
        tabId: this.tabId
      };
      switch (action) {
        case GlobalConstants.create:
          obj = {
            ...obj,
            ...{
              pField: pidFld
            }
          };
          break;
        case GlobalConstants.update:
          obj.tProps.old_t_pTable = node.data.t_pTable;
          obj.tProps.old_t_pTableId = node.data.t_pTableId;
          break;
        case GlobalConstants.delete:
          obj = {
            ...obj,
            ...{
              psid: pidFld
            }
          };
          obj.tProps.old_t_pTable = node.data.t_pTable;
          obj.tProps.old_t_pTableId = node.data.t_pTableId;
      }
      this.store.dispatch(parTblFailure({ parTblFailed: null }));
      this.store.dispatch(parTblSuccess({ parTblSucc: null }));
      this.store.dispatch(
        updParentTbl({
          parApiConstants: ApiConstants.applDMUpdateParentTbl,
          parTblData: obj
        })
      );
      node.data = { ...tableData };
      const ptfailSub = this.store.select(parTblFailed).subscribe((data) => {
        if (data) {
          this.isLoading = false;
          if (data.err) {
            this.showErrMsg(data);
            this.reloadCurrentRoute();
          }
          if (ptfailSub) {
            ptfailSub.unsubscribe();
          }
        }
      });
      this.addToSubscriptionsList(ptfailSub);
      const ptSuccSub = this.store.select(parTblSucc).subscribe((data) => {
        if (data) {
          if (ptSuccSub) {
            ptSuccSub.unsubscribe();
          }
          this.isLoading = false;
        }
      });
      this.addToSubscriptionsList(ptSuccSub);
    } catch (e) {
      console.error(e);
    }
  }

  formFKForParentTable(tableData, node, psid, action, info?) {
    switch (action) {
      case 'CREATE':
        this.updateParentTbl(tableData, node, action, info);
        break;
      case 'UPDATE':
        this.updateParentTbl(tableData, node, action);
        break;
    }
  }

  createPidForTable(node, tableData) {
    this.isLoading = true;
    let psid = this.getPid(node);
    let psidData;
    if (!psid) {
      const title = 'Pid';
      const titleToCheck = title.toLowerCase();
      const parentKey = node.key;
      const tableFields = this.fieldTitles[parentKey];
      if (tableFields) {
        this.fieldTitles[parentKey].push(titleToCheck);
      } else {
        this.fieldTitles[parentKey] = [titleToCheck];
      }
      let preNodeId = null;
      let prevNode = null;
      if (node.hasChildren()) {
        const child = node.children;
        preNodeId = child[child.length - 1].data?.sid;
        prevNode = child[child.length - 1];
      }
      psid = uuidv4();
      let nodeObj = {
        title: title,
        type: nodeType.FIELD,
        key: psid,
        f_sysF: true,
        data: {
          sid: psid,
          f_type: 'String',
          sysGen: true,
          f_sysF: true,
          preNode: preNodeId,
          pNode: node.data.sid,
          tabId: this.tabId
        },
        icon: 'fa pen-field field-icon'
      };
      let tableId = node.type === nodeType.TABLE ? node.data.sid || node.data.id : '';
      const parentTable = this.getParentTable(node);
      if (!tableId) {
        tableId = parentTable.data.sid;
      }
      this.getDefaultValues(nodeObj.data.f_type, nodeObj);
      const syncToAnalytical = parentTable?.data?.t_type === DMConstants.TRANS_ANALY;
      psidData = {
        ...nodeObj.data,
        ...this.formDefaultValues,
        name: nodeObj.title,
        aid: this.appId,
        f_tableId: tableId,
        sysGen: true,
        f_sysF: true,
        f_hasAnalyticalSync: syncToAnalytical,
        type: nodeType.FIELD,
        orgId: this.orgId,
        f_indexed: true
      };
      if (psidData.f_aValues && isArray(psidData.f_aValues)) {
        psidData.f_aValues = JSON.stringify({ values: psidData.f_aValues });
      }
      nodeObj = { ...nodeObj, ...{ data: { ...psidData } } };
      node.addChildren(nodeObj);
      this.formFKForParentTable(tableData, node, psid, 'CREATE', psidData);
    }
  }

  getPid(tblnode) {
    if (tblnode.children) {
      const pidNode = tblnode.children.find((node) => node.title === 'Pid');
      return pidNode ? pidNode?.data.sid : '';
    }
    return '';
  }

  updOrDelPidForTable(node, tableData) {
    let action = 'delete';
    if (tableData?.t_pTableId) {
      action = 'update';
    }
    const psid = this.getPid(node);
    let foreignKey;
    this.isLoading = true;
    if (action === 'update') {
      this.formFKForParentTable(tableData, node, psid, 'UPDATE', foreignKey);
    } else {
      const tree = $.ui.fancytree.getTree('#tree');
      const pidNode = tree.getNodeByKey(psid);
      pidNode.data.sysGen = false;
      this.updateParentTbl(tableData, node, 'DELETE', psid);
    }
  }

  resetTasksObj() {
    return { added: [], deleted: [] };
  }

  addToSubscriptionsList(subName) {
    this.subscriptions.push(subName);
  }

  checkReferenceTblKeys(node: any, tableData: any, fancyTreeDataChange: any) {
    const referenceKeys = [
      {
        key: 't_funcPKey',
        id: 't_funcPKeySid',
        action: 'FUNCTIONAL_PRIMARY_KEY_DELETE'
      },
      {
        key: 't_mandatory_filters',
        id: 't_mandatory_filters_sid',
        action: 'MANDATORY_FILTERS_UPDATE'
      },
      {
        key: 't_unique_for_lookup',
        id: 't_unique_for_lookup_sid',
        action: 'UNIQUE_LOOKUPS_UPDATE'
      },
      {
        key: 't_optional_filters',
        id: 't_optional_filters_sid',
        action: 'OPTIONAL_FILTERS_UPDATE'
      },
      {
        key: 't_lookupFields',
        id: 't_lookupFieldsSid',
        action: 'LOOKUPFIELDS_DELETE'
      },
      {
        key: 't_pTable',
        id: 'sid',
        action: 'PARENT_TABLE_DELETE'
      },
      {
        key: 't_mFilters',
        id: 't_mFiltersSid',
        action: 'LOOKUPFIELDS_DELETE'
      },
      {
        key: 't_oFilters',
        id: 't_oFiltersSid',
        action: 'LOOKUPFIELDS_DELETE'
      },
      {
        key: 't_query_type',
        id: 'sid',
        action: 'QUERY_TYPE_UPDATE'
      },
      {
        key: 't_create_detail_page',
        id: 'sid',
        action: 'QUERY_VIEW_MULTIPLE_DETAIL_PAGE'
      }
      //UniqueId - transient tables
    ];
    const changedData: any = {
      ['t_funcPKey']: tableData.t_funcPKey,
      ['t_funcPKeySid']: tableData.t_funcPKeySid,

      ['t_lookupFields']: tableData.t_lookupFields,
      ['t_lookupFieldsSid']: tableData.t_lookupFieldsSid,

      ['t_mandatory_filters']: tableData.t_mandatory_filters,
      ['t_mandatory_filters_sid']: tableData.t_mandatory_filters_sid,

      ['t_unique_for_lookup']: tableData.t_unique_for_lookup,
      ['t_unique_for_lookup_sid']: tableData.t_unique_for_lookup_sid,

      ['t_optional_filters']: tableData.t_optional_filters,
      ['t_optional_filters_sid']: tableData.t_optional_filters_sid,

      ['t_hasAnalyticalSync']: tableData.t_hasAnalyticalSync,

      ['t_pTable']: tableData.t_pTable
        ? Object.prototype.hasOwnProperty.call(tableData?.t_pTable, 'name')
          ? tableData.t_pTable?.name
          : typeof tableData.t_pTable === 'string'
            ? tableData.t_pTable
            : null
        : null,
      ['t_pTableId']: tableData.sid,

      ['t_mFilters']: tableData.t_mFilters,
      ['t_mFiltersSid']: tableData.t_mFiltersSid,

      ['t_oFilters']: tableData.t_oFilters,
      ['t_oFiltersSid']: tableData.t_oFiltersSid,
      ['t_query_type']: tableData.t_query_type,
      ['t_create_detail_page']: tableData.t_create_detail_page
    };
    // if (tableData.t_type!==DMConstants.QUERY_VIEW) {
    //   changedData.t_query_type = null;
    // }
    let modifiedField = referenceKeys.filter((o: any) => {
      if (
        (o.key === 't_lookupFields' ||
          o.key === 't_mFilters' ||
          o.key === 't_oFilters' ||
          o.key === 't_optional_filters' ||
          o.key === 't_unique_for_lookup' ||
          o.key === 't_mandatory_filters') &&
        node?.data[o.key]
      ) {
        const t1 = (node?.data[o.key] || '')?.split(',');
        const t2 = (changedData[o.key] || '')?.split(',');

        t1.map((p: string) => {
          if (!t2.includes(p)) {
            o.referredField = p;
          }
        });

        return !!o.referredField;
      }

      return node?.data[o.key] && changedData[o.key] !== node?.data[o.key];
    });

    if (node?.data.t_type !== tableData.t_type) {
      modifiedField = [];
    }
    const refs = {
      modifiedField: modifiedField,
      isChanged: modifiedField.length > 0
    };
    this.tblUpdate(refs, tableData, node, fancyTreeDataChange);
    return {
      modifiedField: modifiedField,
      isChanged: modifiedField.length > 0
    };
  }

  //f_searchable

  updateTable(tableData) {
    this.isLoading = true;
    this.removedComplexTables = [];
    const id = tableData.sid || tableData.id;
    //update ordering info
    const fancyTreeDataChange = false;
    let node: any;
    let tree: any;
    const index = findIndex(this.tablesInfo, (o: any) => o?.data?.sid === id || o.sid === id);
    if (index >= 0) {
      const currObj = this.tablesInfo[index];
      if (currObj?.title !== tableData.name) {
        currObj.title = tableData.name;
        this.tablesInfo[index] = currObj;
        this.processTableInfos(true);
      }
    }
    tree = $.ui.fancytree.getTree('#tree');
    node = tree.getNodeByKey(tableData.sid);
    const references: any = this.checkReferenceTblKeys(node, tableData, fancyTreeDataChange);
  }

  // Check for table search conflicts when adding mandatory/optional filter fields
  checkTableSearchConflicts(node, tableData, fancyTreeDataChange): boolean {
    if (!this.enabledReferenceModal) {
      const addedFilterFields: string[] = [];
      for (const filterKey of ['t_mandatory_filters', 't_optional_filters']) {
        const oldFilters = (node?.data?.[filterKey] || '').split(',').filter(f => f);
        const newFilters = (tableData?.[filterKey] || '').split(',').filter(f => f);
        addedFilterFields.push(...newFilters.filter(f => !oldFilters.includes(f)));
      }
      if (addedFilterFields.length > 0) {
        const requests = addedFilterFields.map(fieldSid => ({
          modelId: fieldSid,
          modelType: ModelType.FIELD,
          actionType: ActionType.MANDATORY_FIELD_UPDATE,
          action: UiActions.UPDATE,
          appId: this.appId
        }));
        this.enabledReferenceModal = true;
        const nodeInfo = { name: '', type: 'Field' };
        let conflictSids: string[] = [];
        this.referenceUtil.handleWithReferences({
          payload: requests,
          node: nodeInfo,
          extras: { action: 'UPDATE' },
          filter: (refs: any[]) => {
            const tableSearchRefs = refs.filter((r: any) => r.propertyName === 'TABLE_SEARCH');
            conflictSids = Array.from(new Set<string>(tableSearchRefs.map((r: any) => r.referredModelId)));
            nodeInfo.name = conflictSids.join(',');
            return tableSearchRefs;
          },
          onConfirm: () => {
            this.enabledReferenceModal = false;
            this.isLoading = false;
            const fieldNames = conflictSids
              .map((sid: string) => this.getLatestDataFromFsData(sid)?.name || sid)
              .join(', ');
            const message = this.translate.instant('TABLE_SEARCH_CONFLICT_MESSAGE', { fieldNames });
            const header = this.translate.instant('TABLE_SEARCH_CONFLICT_HEADER');
            const _self = this;
            this.zone.run(() => {
              _self.confirmationDialogService.confirm({
                header,
                message,
                acceptIcon: 'pi pi-check',
                rejectIcon: 'pi pi-times',
                accept: () => {
                  _self.updateTableProps(tableData, node, fancyTreeDataChange);
                },
                reject: () => {
                  _self.store.dispatch(propertyActions.setPropertiesValues({
                    propertiesValues: { ...node?.data, typeChange: true }
                  }));
                }
              });
            });
          },
          onNoReferences: () => {
            this.enabledReferenceModal = false;
            this.updateTableProps(tableData, node, fancyTreeDataChange);
          },
          onCancel: () => {
            this.enabledReferenceModal = false;
            this.isLoading = false;
            this.store.dispatch(propertyActions.setPropertiesValues({
              propertiesValues: { ...node?.data, typeChange: true }
            }));
          },
          onError: () => {
            this.enabledReferenceModal = false;
            this.isLoading = false;
          }
        });
        return true;
      }
    }
    return false;
  }

  tblUpdate(references, tableData, node, fancyTreeDataChange) {
    if (this.checkTableSearchConflicts(node, tableData, fancyTreeDataChange)) {
      return;
    }
    let tsid = tableData[references.modifiedField[0]?.id] || null;
    let referencesExecuted = false;
    if (
      references.modifiedField[0]?.referredField &&
      (references.modifiedField[0]?.key === 't_mandatory_filters' ||
        references.modifiedField[0]?.key === 't_optional_filters' ||
        references.modifiedField[0]?.key === 't_unique_for_lookup')
    ) {
      tsid = references.modifiedField[0]?.referredField;
      // Skip retrieve API call entirely - pickup-list already validates for both partial and full removal
      if (references?.isChanged && tsid) {
        this.isLoading = false;
        this.updateTableProps(tableData, node, fancyTreeDataChange);
        return;
      }
    }

    if (references.isChanged && tsid && references.modifiedField[0]?.key === 't_pTable') {
      referencesExecuted = true;
    }

    if (references.isChanged && tsid && references.modifiedField[0]?.key === 't_query_type') {
      referencesExecuted = true;
    }

    if (references.isChanged && tsid && references.modifiedField[0]?.key === 't_create_detail_page') {
      referencesExecuted = true;
    }

    //will be enabled once changes are done
    if (references?.isChanged && tsid && referencesExecuted) {
      if (!this.enabledReferenceModal) {
        const actionType = this.mapTableActionType(references.modifiedField[0], tableData, node);
        const action = UiActions.UPDATE;
        const modelType =
          actionType == ActionType.MANDATORY_FIELD_REMOVE ||
          actionType == ActionType.OPTIONAL_FIELD_REMOVE ||
          actionType == ActionType.UNIQUE_FIELD_REMOVE
            ? ModelType.FIELD
            : ModelType.TABLE;
        this.enabledReferenceModal = true;
        this.fetchModelReferences({ modelId: tsid, modelType, actionType, action }).then(
          (value: any) => {
            this.isLoading = false;
            if (value.length > 0) {
              const d: any = {
                tableData: tableData,
                node: node,
                fancyTreeDataChange: fancyTreeDataChange,
                genericAction: actionType,
                tablePropsInfo: {
                  type:
                    references.modifiedField[0]?.key === 't_lookupFields'
                      ? 'Lookup Fields'
                      : references.modifiedField[0]?.key === 't_mFilters'
                        ? 'Mandatory Input Filters'
                        : references.modifiedField[0]?.key === 't_oFilters'
                          ? 'Optional Input Filters'
                          : references.modifiedField[0]?.key === 't_mandatory_filters'
                            ? 'Mandatory Input Parameters'
                            : references.modifiedField[0]?.key === 't_unique_for_lookup'
                              ? 'Unique Fields For Lookup'
                              : references.modifiedField[0]?.key === 't_optional_filters'
                                ? 'Optional Input Parameters'
                                : references.modifiedField[0]?.key === 't_query_type'
                                  ? 'Query Type'
                                  : references.modifiedField[0]?.key === 't_create_detail_page'
                                    ? 'Default Detail Row'
                                    : '',
                  name: references.modifiedField[0]?.referredField
                }
              };
              const _self = this;
              _self.showRefForpTbl(node, value, d);
            } else {
              const _self = this;
              this.enabledReferenceModal = false;
              this.updateTableProps(tableData, node, fancyTreeDataChange);
            }
          },
          (error) => {
            this.isLoading = false;
          }
        );
      }
    } else {
      this.isLoading = false;
      if (!this.softUpdateProps) {
        this.updateTableProps(tableData, node, fancyTreeDataChange);
      }
    }
  }

  showRefForpTbl(node, value, d) {
    const _self = this;
    this.zone.run(() => {
      if (_self.popupOpened) {
        return;
      }
      _self.util.setPopupRestriction(_self.popupOpened);
      this.appGlobalService.write('transientFieldUpdate', 'false');
      _self.showReferenceTree(node?.data, value, d);
    });
  }

  updateTableProps(tableData: any, node: any, fancyTreeDataChange: boolean) {
    let parentTblChange = false;
    if (tableData.t_pTable) {
      if (typeof tableData.t_pTable === 'object') {
        tableData.t_pTableId = tableData.t_pTable?.sid;
        tableData.t_pTable = tableData.t_pTable?.name;
      }
      const pTable = node.data?.t_pTable;
      // while parent table change, we have to send foreign key also in request. So added a condition
      if (pTable !== tableData.t_pTable) {
        fancyTreeDataChange = true;
        if (this.isRdbms) {
          parentTblChange = true;
          if (pTable) {
            //update table, foreign key for pid
            this.updOrDelPidForTable(node, tableData);
          } else {
            //create pid field, update table, create foreignkey for pid
            this.createPidForTable(node, tableData);
          }
        }
      }
    } else {
      const pTable = node.data?.t_pTable;
      if (pTable) {
        tableData.t_pTableId = null;
        fancyTreeDataChange = true;
        if (this.isRdbms) {
          //delete pid field, update table, delete foreignkey of pid
          this.updOrDelPidForTable(node, tableData);
          parentTblChange = true;
        }
      }
      if (tableData.t_pTableId) {
        tableData.t_pTableId = null;
      }
    }
    if (tableData.t_datasetName) {
      if (typeof tableData.t_datasetName === 'object') {
        tableData.t_datasetName = tableData.t_datasetName?.sid;
      }
    }
    if (tableData.t_transactionalTable) {
      if (typeof tableData.t_transactionalTable === 'object') {
        tableData.t_transactionalTable = tableData.t_transactionalTable.sid;
      }
    }
    if (tableData?.t_type) {
      const tableType = node.data?.t_type;
      if (tableType !== tableData.t_type) {
        this.loadTableTypeProps(tableData, node, tableType, fancyTreeDataChange, parentTblChange);
      } else {
        this.updateTableData(tableData, parentTblChange, node);
      }
    }
  }

  loadTableTypeProps(
    tableData: any,
    node: any,
    tableType: string,
    fancyTreeDataChange: boolean,
    parentTblChange: boolean
  ) {
    const ind = this.normalTables.findIndex((t) => t.sid === tableData.sid);
    if (tableData.t_type === DMConstants.TRANS_ONLY || tableData.t_type === DMConstants.TRANS_ANALY) {
      if (ind < 0) {
        this.normalTables = [...this.normalTables, { sid: tableData.sid, name: tableData.name }];
      }
    } else {
      // analytical table
      if (ind > -1) {
        const nTbls = [...this.normalTables];
        nTbls.splice(ind, 1);
        this.normalTables = [...nTbls];
      }
    }
    this.loadTableInfoForType();
    this.store.dispatch(propertyActions.setTableNames({ tableNames: this.normalTables }));
    // Update allTables to sync foreign key dialog's referenced table dropdown
    this.store.dispatch(setAllTables({ allTables: [...this.normalTables] }));
    fancyTreeDataChange = true;
    if (this.isRdbms && (tableData.t_type === DMConstants.TRANS_ONLY || tableData.t_type === DMConstants.TRANS_ANALY)) {
      // get sid field when type change from Analytical to transactional
      if (tableType === DMConstants.ANALY_ONLY) {
        if (node.children) {
          const sidNode = node.children.find((dt) => dt.title === 'Sid');
          if (sidNode) {
            this.uniqSid = sidNode.data?.sid;
          }
        }
      }
    }
    this.updateTableData(tableData, parentTblChange, node);
  }

  updateTableType(node, data, oldData) {
    let dataToSend: any = {
      oldTableType: oldData.t_type,
      newTableType: data.t_type,
      tableId: data.sid,
      appId: this.appId,
      orgId: this.orgId,
      tabId: this.tabId,
      tableProperties: null,
      type: nodeType.TABLE
    };
    switch (data.t_type) {
      case DMConstants.TRANS_ONLY:
        dataToSend = {
          ...dataToSend,
          ...{
            tableProperties: {
              t_type: data.t_type,
              t_datasetName: null,
              t_aTableName: null,
              t_transactionalTable: null
            },
            datasetId: oldData.t_datasetName,
            transactionalTableId: oldData.t_transactionalTable
          }
        };
        break;
      case DMConstants.TRANS_ANALY:
        dataToSend = {
          ...dataToSend,
          ...{
            tableProperties: {
              t_type: data.t_type,
              t_datasetName: data.t_datasetName ? data.t_datasetName : this.defDataset,
              t_aTableName: data.name,
              t_transactionalTable: null
            },
            transactionalTableId: oldData.t_transactionalTable,
            datasetId: data.t_datasetName ? data.t_datasetName : this.defDataset
          }
        };
        break;
      case DMConstants.ANALY_ONLY:
        dataToSend = {
          ...dataToSend,
          ...{
            tableProperties: {
              t_type: data.t_type,
              t_pTableId: null,
              t_pTable: null,
              t_aTableName: null,
              t_datasetName: data.t_datasetName ? data.t_datasetName : this.defDataset,
              t_transactionalTable: null,
              dpNeeded: false,
              lpNeeded: false
            },
            datasetId: data.t_datasetName ? data.t_datasetName : this.defDataset
          }
        };
        break;
    }
    dataToSend = {
      ...dataToSend,
      ...{
        tableProperties: {
          ...dataToSend.tableProperties,
          ...{
            sid: data.sid,
            aid: this.appId,
            orgId: this.orgId,
            tabId: this.tabId,
            action: 'TABLE_TYPE_UPDATE'
          }
        }
      }
    };
    node.data = { ...node.data, ...dataToSend.tableProperties };
    let fldTasks = this.updateSysGenFields(node);
    dataToSend = {
      ...dataToSend,
      ...fldTasks
    };
    this.store.dispatch(tableTypeFailure({ tblTypeFailed: null }));
    this.store.dispatch(tableTypeSuccess({ tblTypeSucc: null }));
    this.isLoading = true;
    this.tblTypSveInPrg = true;
    this.store.dispatch(
      updTableType({
        tblTypeApiConstants: ApiConstants.applDMUpdateTblTyp,
        payload: dataToSend
      })
    );

    const tbTypfailSub = this.store.select(tblTypeFailed).subscribe((data) => {
      if (data) {
        this.isLoading = false;
        this.tblTypSveInPrg = false;
        if (data.err) {
          this.showErrMsg(data);
          this.reloadCurrentRoute();
        }
        if (tbTypfailSub) {
          tbTypfailSub.unsubscribe();
        }
      }
    });
    this.addToSubscriptionsList(tbTypfailSub);
    const tblTypSuccSub = this.store.select(tblTypeSucc).subscribe((data) => {
      if (data) {
        if (tblTypSuccSub) {
          tblTypSuccSub.unsubscribe();
        }
        this.isLoading = false;
        this.tblTypSveInPrg = false;
      }
    });
    this.addToSubscriptionsList(tblTypSuccSub);
  }

  updateTableData(tableData: any, parentTblChange: boolean, node: any) {
    if (tableData) {
      if (tableData.valueChange) {
        delete tableData.valueChange;
        delete tableData.typeChange;
      }
      tableData.tabId = this.tabId;
      if (!parentTblChange && !isEqual(node.data, tableData)) {
        const baseObj = {
          orgId: this.orgId,
          aid: this.appId,
          sid: tableData.sid,
          tabId: this.tabId,
          type: nodeType.TABLE
        };
        tableData.t_funcPKeySid = node.data.t_funcPKeySid
          ? node.data.t_funcPKeySid
          : tableData?.t_funcPKey
            ? uuidv4()
            : undefined;
        const obj = {
          ...baseObj,
          name: tableData.name,
          old_name: node.data.name,
          t_funcPKey: tableData?.t_funcPKey,
          t_funcPKeySid: tableData.t_funcPKeySid,
          old_t_funcPKey: node.data?.t_funcPKey,
          t_type: tableData.t_type
        };

        if (tableData.name !== node.data.name) {
          this.selectedNodeTitle = `Table Properties : ${tableData.name}`;
          this.store.dispatch(
            updateAppDM({
              apiConstants: ApiConstants.applDMUpdateName,
              appDMData: obj
            })
          );
        } else if ((node.data.t_funcPKey || tableData.t_funcPKey) && tableData.t_funcPKey !== node.data.t_funcPKey) {
          if (obj.old_t_funcPKey === null) {
            if (this.fsData.filter((fld) => fld.sid === obj.t_funcPKey).sysGen) {
              return;
            }
          } else {
            const oldFarray = obj.old_t_funcPKey.split(',');
            const newFarray = obj.t_funcPKey.split(',');
            if (
              this.fsData.filter((fd) => fd.sid === newFarray.filter((fld) => !oldFarray.includes(fld))[0])[0]
                ?.sysGen &&
              this.fsData.filter((fd) => fd.sid === newFarray.filter((fld) => !oldFarray.includes(fld))[0]).length >
                0 &&
              newFarray.length > oldFarray.length
            ) {
              this.showMessage('error', 'System Generated fields cannot be included in Functional Primary Key');
              return;
            }
          }
          this.store.dispatch(
            updateAppDM({
              apiConstants: ApiConstants.applDMUpdateFuncPK,
              appDMData: obj
            })
          );
        } else if (tableData.t_type !== node.data.t_type) {
          this.updateTableType(node, tableData, node.data);
        } else if (
          ((node.data.t_mFilters || tableData.t_mFilters) && tableData.t_mFilters !== node.data.t_mFilters) ||
          ((node.data.t_lookupFields || tableData.t_lookupFields) &&
            tableData.t_lookupFields !== node.data.t_lookupFields)
        ) {
          tableData.t_lookupFieldsSid = node.data.t_lookupFieldsSid ? node.data.t_lookupFieldsSid : uuidv4();
          tableData.t_mFiltersSid = node.data.t_mFiltersSid ? node.data.t_mFiltersSid : uuidv4();
          tableData.t_oFiltersSid = node.data.t_oFiltersSid ? node.data.t_oFiltersSid : uuidv4();
          if (tableData.t_lookupFields && tableData.t_lookupFields !== node.data.t_lookupFields) {
            if (node.children) {
              const childs = node.children;
              const sNodeSid = childs.find((c) => c.title === 'Sid')?.data?.sid;
              if (sNodeSid && !tableData.t_lookupFields.includes(sNodeSid)) {
                tableData.t_lookupFields += `,${sNodeSid}`;
              }
            }
            if (tableData.t_mFilters) {
              const f = tableData.t_mFilters.split(',').find((mf) => !tableData.t_lookupFields.includes(mf));
              if (f) {
                tableData.t_mFilters = tableData.t_mFilters
                  .split(',')
                  .filter((mf) => tableData.t_lookupFields.includes(mf))
                  .join(',');
              }
            }
            if (tableData.t_oFilters) {
              const f = tableData.t_oFilters.split(',').find((of) => !tableData.t_lookupFields.includes(of));
              if (f) {
                tableData.t_oFilters = tableData.t_oFilters
                  .split(',')
                  .filter((of) => tableData.t_lookupFields.includes(of))
                  .join(',');
              }
            }
          }
          this.store.dispatch(
            updateAppDM({
              apiConstants: ApiConstants.applDMUpdateLookup,
              appDMData: {
                ...baseObj,
                old_t_lookupFields: node.data?.t_lookupFields,
                t_lookupFields: tableData.t_lookupFields,
                t_lookupFieldsSid: tableData.t_lookupFieldsSid,
                t_mFiltersSid: tableData.t_mFiltersSid,
                old_t_mFilters: node.data?.t_mFilters,
                t_mFilters: tableData.t_mFilters,
                t_oFiltersSid: tableData.t_oFiltersSid,
                name: tableData.name
              }
            })
          );

          if (tableData.t_oFilters !== node.data.t_oFilters) {
            this.updateFieldAPI(node, tableData, baseObj);
          }
        } else if (
          (node.data.t_exportProps || tableData.t_exportProps) &&
          tableData.t_exportProps !== node.data.t_exportProps
        ) {
          this.store.dispatch(
            updateAppDM({
              apiConstants: ApiConstants.applDMUpdateExprops,
              appDMData: {
                ...baseObj,
                t_exportProps: tableData.t_exportProps,
                old_t_exportProps: node.data.t_exportProps,
                templateId: this.templateProps?.templateId,
                templateName: this.templateProps?.templateName,
                action: this.templateProps?.action
              }
            })
          );
        } else {
          this.updateFieldAPI(node, tableData, baseObj);
        }
        node.data = tableData;
      }
    }
  }

  updateFieldAPI(node, tableData, baseObj) {
    let diffObj: any = this.utilService.getDifKeyValObj(node.data, tableData, [
      'tabId',
      'sid',
      'createdBy',
      'createdDate',
      'modifiedBy',
      'modifiedDate',
      't_techName',
      't_hasAnalyticalSync',
      't_hasLP',
      't_hasDP',
      't_hasSample',
      't_hasAttachments',
      'tabId',
      't_uniqueIdSid',
      't_oFiltersSid',
      'preNode',
      'pNode',
      'isNewRec'
    ]);
    if (diffObj && Object.keys(diffObj).length) {
      let apiConstant = ApiConstants.updateFields;
      if (tableData.t_type === DMConstants.QUERY_VIEW && diffObj.t_query_type) {
        apiConstant = ApiConstants.updateQueryType;
      } else if (
        tableData.t_type === DMConstants.QUERY_VIEW &&
        (Object.prototype.hasOwnProperty.call(diffObj, 't_optional_filters') ||
          Object.prototype.hasOwnProperty.call(diffObj, 't_unique_for_lookup') ||
          Object.prototype.hasOwnProperty.call(diffObj, 't_mandatory_filters'))
      ) {
        apiConstant = ApiConstants.updateQueryViewFilters;
      }
      diffObj = { ...diffObj, ...baseObj };

      // For QV parameter validation, ensure both mandatory and optional filters are included
      if (apiConstant === ApiConstants.updateQueryType || apiConstant === ApiConstants.updateQueryViewFilters) {
        diffObj.t_mandatory_filters = tableData.t_mandatory_filters || '';
        diffObj.t_optional_filters = tableData.t_optional_filters || '';
      } else if (apiConstant === ApiConstants.updateFields && tableData.t_type === DMConstants.QUERY_VIEW) {
        // Include parameters for regular field updates on Query Views (e.g., query content changes)
        diffObj.t_mandatory_filters = tableData.t_mandatory_filters || '';
        diffObj.t_optional_filters = tableData.t_optional_filters || '';
      }

      diffObj = this.getOldDataAndSid(diffObj, tableData, node);
      //t_list_query is to validate the mandatory and optional filters for query view update

      if (!Object.prototype.hasOwnProperty.call(diffObj, 't_list_query') && tableData.t_query_type == 'multiple') {
        if (tableData?.t_list_query && tableData?.t_list_query?.includes('$$')) {
          diffObj.t_list_query = this.formatQSNameToSid(node.data?.t_list_query);
        } else {
          diffObj.t_list_query = tableData?.t_list_query || '';
        }
      }

      if (!Object.prototype.hasOwnProperty.call(diffObj, 't_detail_query') && tableData.t_query_type == 'single') {
        if (tableData?.t_detail_query && tableData?.t_detail_query?.includes('$$')) {
          diffObj.t_detail_query = this.formatQSNameToSid(node.data.t_detail_query);
        } else {
          diffObj.t_detail_query = tableData?.t_detail_query || '';
        }
      }
      if (!diffObj) {
        return;
      }
      if (apiConstant === ApiConstants.updateQueryType || apiConstant === ApiConstants.updateQueryViewFilters) {
        this.store.dispatch(
          updateAppDM({
            apiConstants: apiConstant,
            appDMData: diffObj
          })
        );
      } else {
        this.store.dispatch(
          updateAppDM({
            apiConstants: apiConstant,
            appDMData: [diffObj]
          })
        );
      }
    }
  }

  callRefForUpdFls(fieldData) {
    const tree = $.ui.fancytree.getTree('#tree');
    const node = tree.getNodeByKey(fieldData.sid);
    if (fieldData.f_lookupService) {
      if (typeof fieldData.f_lookupService === 'object') {
        fieldData.f_lookupService = fieldData.f_lookupService.sid;
      }
    }
    if (fieldData.f_dField) {
      if (typeof fieldData.f_dField === 'object') {
        fieldData.f_dField = fieldData.f_dField.sid;
      }
    }
    if (isArray(fieldData.f_aValues)) {
      fieldData.f_aValues = JSON.stringify({ values: fieldData.f_aValues });
    }
    if (isArray(fieldData.f_allowedFTypes)) {
      fieldData.f_allowedFTypes = fieldData.f_allowedFTypes.join();
    }
    if (fieldData.f_minDate) {
      const date = new Date(fieldData.f_minDate);
      fieldData.f_minDate = date.getTime();
    }
    if (fieldData.f_maxDate) {
      const date = new Date(fieldData.f_maxDate);
      fieldData.f_maxDate = date.getTime();
    }
    if (
      fieldData.f_dVal &&
      (fieldData.f_type.toLowerCase() === 'date' || fieldData.f_type.toLowerCase() === 'datetime')
    ) {
      if (typeof fieldData.f_dVal !== 'string') {
        try {
          const date = new Date(fieldData.f_dVal);
          fieldData.f_dVal = date.getTime();
        } catch (e) {
          fieldData.f_dVal = null;
        }
      }
    }
    if (fieldData.f_type !== DMConstants.LOOKUP_FIELD_TYPE) {
      this.clearLookupFields(fieldData);
    } else {
      this.clearLookupFieldsBasedOnLookupType(fieldData);
    }

    const references: any = this.checkReferencefieldKeys(node.data, fieldData);
    const fsid = fieldData[references.modifiedField[0]?.id] || null;

    // Skip reference check for UPDATE_NONSYNC as it doesn't impact other components
    const propertyAction = references?.modifiedField?.[0]?.propertyAction;
    const shouldSkipReferenceCheck = propertyAction === 'UPDATE_NONSYNC';

    if (references?.isChanged && fsid && !this.enabledReferenceModal && !shouldSkipReferenceCheck) {
      const modelType = ModelType.FIELD;
      const mappedActionType = this.mapFieldPropertyActionType({ propertyAction: propertyAction });
      const actionType = mappedActionType;
      const action = UiActions.UPDATE;
      this.fetchModelReferences({ modelId: fsid, modelType, actionType, action }).then(
        (value: any) => {
          if (value.length > 0) {
            const d: any = {
              node: node,
              fieldData: fieldData,
              value: value,
              genericAction: 'UPDATE_FIELD_PROPS',
              propertyAction: references.modifiedField[0]?.propertyAction,
              actionType: mappedActionType
            };
            if (references.modifiedField[0]?.propertyAction === 'UPDATE_TRANSIENT') {
              this.appGlobalService.write('transientFieldUpdate', 'true');
            } else {
              this.appGlobalService.write('transientFieldUpdate', 'false');
            }
            const _self = this;
            this.zone.run(() => {
              if (_self.popupOpened) {
                return;
              }
              _self.util.setPopupRestriction(_self.popupOpened);
              _self.showReferenceTree(node?.data, value, d);
            });
          } else {
            this.updateFieldProps(node, fieldData);
          }
        },
        (error) => {
          this.isLoading = false;
          console.log(error); // Error triggered when reject() is returned.
        }
      );
    } else {
      this.updateFieldProps(node, fieldData);
    }
  }

  updateField(fieldData) {
    const sysFields = [
      'Sid',
      'Created By',
      'Created Date',
      'Modified By',
      'Modified Date',
      'Jid',
      'Sync Time',
      GlobalConstants.isActiveField
    ];
    // prevent batch call update for sys gen fields
    // if (fieldData.sysGen && sysFields.includes(fieldData.name)) {
    //   return;
    // }
    const tree = $.ui.fancytree.getTree('#tree');
    const node = tree.getNodeByKey(fieldData.sid);
    if (fieldData.f_lookupType === DMConstants.LOOKUP_TYPE_TABLE) {
      if (fieldData.f_lookupTo) {
        if (typeof fieldData.f_lookupTo === 'object') {
          fieldData.f_lookupTo = fieldData.f_lookupTo.sid;
        }
        if ((fieldData.f_lookupTo || node.data.f_lookupTo) && fieldData.f_lookupTo !== node.data.f_lookupTo) {
          if (fieldData.f_lookupTo) {
            const lkSub$ = this.store.select(selLkTbl);
            const tblMap$ = this.store.select(tabMapFlds);
            const lkdetSub = combineLatest(lkSub$, tblMap$).subscribe((data) => {
              if (data && data[0] && data[1]) {
                const lktbl = data[0];
                const lktblFlds = data[1];
                // send lookup details if the lookup is from different app
                if (
                  lktbl.sid === fieldData.f_lookupTo &&
                  lktbl.appId !== fieldData.appId &&
                  lktblFlds.length &&
                  lktblFlds[0].f_tableId === fieldData.f_lookupTo
                ) {
                  const lkdetails = {
                    lookupFields: lktbl?.t_lookupFields
                      ? this.util.formMapForParFld(lktblFlds, lktbl?.t_lookupFields.split(','))
                      : undefined,
                    mandatoryFilters: lktbl?.t_mFilters
                      ? this.util.formMapForParFld(lktblFlds, lktbl?.t_mFilters.split(','))
                      : undefined,
                    optionalFilters: lktbl?.t_oFilters
                      ? this.util.formMapForParFld(lktblFlds, lktbl?.t_oFilters.split(','))
                      : undefined,
                    functionalPrimaryKeys: lktbl?.t_funcPKey
                      ? this.util.formMapForParFld(lktblFlds, lktbl?.t_funcPKey.split(','))
                      : undefined
                  };
                  fieldData = {
                    ...fieldData,
                    ...{
                      f_lookupDetails: JSON.stringify(lkdetails)
                    }
                  };
                  if (fieldData?.f_lookupDetails?.mandatoryFilters) {
                    const sublkflds = fieldData.f_lookupDetails.mandatoryFilters.filter(
                      (fld) => fld.f_type.toLowerCase() === 'lookup'
                    );
                    if (sublkflds.length) {
                      const pfkSub = this.store.select(funcPKflds).subscribe((flds) => {
                        lkdetails.mandatoryFilters = {
                          ...lkdetails.mandatoryFilters,
                          ...{ functionalPrimaryKeys: flds }
                        };
                      });
                      this.addToSubscriptionsList(pfkSub);
                    } else {
                      this.callRefForUpdFls(fieldData);
                    }
                  } else {
                    this.callRefForUpdFls(fieldData);
                  }
                } else if (lktbl.appId === fieldData.appId) {
                  this.callRefForUpdFls(fieldData);
                }
              }
            });
            this.addToSubscriptionsList(lkdetSub);
          }
          if (node.data.f_lookupTo) {
            fieldData.f_lookupDetails = null;
          }
        } else {
          this.callRefForUpdFls(fieldData);
        }
      }
    } else {
      this.callRefForUpdFls(fieldData);
    }
  }

  updateFieldProps(node: any, fieldData: any) {
    const parentNode = this.getParentTable(node);
    if ((node.data.f_formula || fieldData.f_formula) && fieldData.f_formula !== node.data.f_formula) {
      if (fieldData.f_formula) {
        const obj = { [fieldData.sid]: fieldData.f_formula };
        if (parentNode.data?.t_formulas) {
          try {
            let fb = JSON.parse(parentNode.data?.t_formulas);
            fb = { ...fb, ...obj };
            parentNode.data = { ...parentNode.data, ...{ t_formulas: JSON.stringify(fb) } };
          } catch (e) {
            console.log(e);
          }
        } else {
          parentNode.data = { ...parentNode.data, ...{ t_formulas: JSON.stringify(obj) } };
        }
      } else if (parentNode.data.t_formulas) {
        parentNode.data = { ...parentNode.data, ...{ t_formulas: null } };
      }
      const tblObj = {
        sid: parentNode.data.sid,
        tabId: this.tabId,
        t_formulas: parentNode.data.t_formulas,
        orgId: this.orgId,
        aid: this.appId,
        type: nodeType.TABLE
      };
      this.store.dispatch(
        updateAppDM({
          apiConstants: ApiConstants.updateFields,
          appDMData: [tblObj]
        })
      );
    }
    if (fieldData.f_fKeyId) {
      if (fieldData.f_fKeyId.includes('f_pTableFId')) {
        try {
          const data = JSON.parse(fieldData.f_fKeyId);
          fieldData.f_fKeyId = data?.f_fKeyId;
          fieldData.f_pTableFId = data?.f_pTableFId;
        } catch (e) {
          console.error(e);
        }
      }
    }
    if (fieldData.f_multiValMin) {
      fieldData.f_multiValMin = Number(fieldData.f_multiValMin);
    }
    if (fieldData.f_multiValMax) {
      fieldData.f_multiValMax = Number(fieldData.f_multiValMax);
    }
    if (fieldData) {
      if (fieldData.valueChange) {
        delete fieldData.valueChange;
        delete fieldData.typeChange;
      }
      fieldData.tabId = this.tabId;
      const baseObj = {
        orgId: this.orgId,
        aid: this.appId,
        sid: fieldData.sid,
        tabId: this.tabId,
        f_tableId: fieldData.f_tableId,
        type: nodeType.FIELD
      };
      if (fieldData.name !== node.data.name) {
        if (fieldData.name === node.title) {
          this.selectedNodeTitle = `Field Properties : ${fieldData.name}`;
          this.store.dispatch(
            updateAppDM({
              apiConstants: ApiConstants.applDMUpdateName,
              appDMData: {
                ...baseObj,
                name: fieldData.name,
                old_name: node.data.name
              }
            })
          );
        } else {
          // on renaming, if the field data name doesn't match with title, so assigning here
          fieldData.name = node.title;
        }
      } else if ((node.data.f_aValues || fieldData.f_aValues) && fieldData.f_aValues !== node.data.f_aValues) {
        this.store.dispatch(
          updateAppDM({
            apiConstants: ApiConstants.applDMUpdateAwdVal,
            appDMData: {
              ...baseObj,
              old_f_aValues: node.data.f_aValues
                ? JSON.stringify(this.replaceEmptyValWithNull(JSON.parse(node.data.f_aValues)))
                : undefined,
              f_type: fieldData.f_type,
              f_aValues: fieldData.f_aValues
            }
          })
        );
      } else {
        let diffObj: any = this.utilService.getDifKeyValObj(node.data, fieldData, [
          'tabId',
          'sid',
          'createdBy',
          'createdDate',
          'modifiedBy',
          'modifiedDate',
          'tabId',
          'f_lookupToSid',
          'f_dFieldSid',
          'f_lookUpIMapSid',
          'f_lookUpOMapSid',
          'f_dpsSid',
          'f_type',
          'preNode',
          'pNode',
          'isNewRec'
        ]);
        if (diffObj && Object.keys(diffObj).length) {
          let queryObjects: any = [];
          const addedReference: any = [],
            deletedReference: any = [];
          try {
            if (
              fieldData.f_mandatory !== null &&
              fieldData.f_mandatory === 'conditional' &&
              fieldData.f_cMandatory !== null
            ) {
              const mandatoryQuery = JSON.parse(fieldData.f_cMandatory);
              queryObjects.push({ queryId: mandatoryQuery?.sid, property: 'f_cMandatory' });
            }
            if (fieldData.f_editing !== null && fieldData.f_editing === 'conditional' && fieldData.f_editC !== null) {
              const feditQuery = JSON.parse(fieldData.f_editC);
              queryObjects.push({ queryId: feditQuery?.sid, property: 'f_editC' });
            }
            if (fieldData.f_view !== null && fieldData.f_view === 'conditional' && fieldData.f_viewC !== null) {
              const fviewQuery = JSON.parse(fieldData.f_viewC);
              queryObjects.push({ queryId: fviewQuery?.sid, property: 'f_viewC' });
            }
            if (Object.prototype.hasOwnProperty.call(diffObj, 'f_cMandatory')) {
              if (diffObj.f_cMandatory) {
                addedReference.push(
                  this.util.createReference(
                    fieldData.sid,
                    utilEnum.modelType.FIELD,
                    JSON.parse(fieldData.f_cMandatory).sid,
                    utilEnum.modelType.QUERY_BUILDER,
                    this.appId,
                    `${fieldData.f_tableId}/${fieldData.sid}`,
                    utilEnum.propertyName.MANDATORY_CONDITIONAL,
                    true
                  )
                );
              } else {
                deletedReference.push(
                  this.util.createObjForDelRef(
                    fieldData.sid,
                    JSON.parse(node.data?.f_cMandatory).sid,
                    utilEnum.propertyName.MANDATORY_CONDITIONAL
                  )
                );
              }
            }
            if (Object.prototype.hasOwnProperty.call(diffObj, 'f_editC')) {
              if (diffObj.f_editC) {
                addedReference.push(
                  this.util.createReference(
                    fieldData.sid,
                    utilEnum.modelType.FIELD,
                    JSON.parse(fieldData.f_editC).sid,
                    utilEnum.modelType.QUERY_BUILDER,
                    this.appId,
                    `${fieldData.f_tableId}/${fieldData.sid}`,
                    utilEnum.propertyName.EDIT_CONDITIONAL,
                    true
                  )
                );
              } else {
                deletedReference.push(
                  this.util.createObjForDelRef(
                    fieldData.sid,
                    JSON.parse(node.data?.f_editC).sid,
                    utilEnum.propertyName.EDIT_CONDITIONAL
                  )
                );
              }
            }
            if (Object.prototype.hasOwnProperty.call(diffObj, 'f_viewC')) {
              if (diffObj.f_viewC) {
                addedReference.push(
                  this.util.createReference(
                    fieldData.sid,
                    utilEnum.modelType.FIELD,
                    JSON.parse(fieldData.f_viewC).sid,
                    utilEnum.modelType.QUERY_BUILDER,
                    this.appId,
                    `${fieldData.f_tableId}/${fieldData.sid}`,
                    utilEnum.propertyName.VIEW_CONDITIONAL,
                    true
                  )
                );
              } else {
                deletedReference.push(
                  this.util.createObjForDelRef(
                    fieldData.sid,
                    JSON.parse(node.data?.f_viewC).sid,
                    utilEnum.propertyName.VIEW_CONDITIONAL
                  )
                );
              }
            }
            if (Object.prototype.hasOwnProperty.call(diffObj, 'f_formula')) {
              if (diffObj.f_formula && !node.data.f_formula) {
                const formulas = JSON.parse(fieldData.f_formula);
                uniq(formulas.filter((f) => f.type === 'field').map((formula) => formula.fieldId)).forEach((fldid) => {
                  addedReference.push(
                    this.util.createReference(
                      fieldData.sid,
                      utilEnum.modelType.FIELD,
                      fldid,
                      utilEnum.modelType.FIELD,
                      this.appId,
                      `${fieldData.f_tableId}/${fieldData.sid}`,
                      utilEnum.propertyName.FORMULA_BUILDER,
                      true
                    )
                  );
                });
              } else {
                const formulas = fieldData.f_formula ? JSON.parse(fieldData.f_formula) : [];
                const Oformulas = node.data.f_formula ? JSON.parse(node.data.f_formula) : [];
                const oldForFlds = uniq(Oformulas.filter((f) => f.type === 'field').map((formula) => formula.fieldId));
                const newForFlds = uniq(formulas.filter((f) => f.type === 'field').map((formula) => formula.fieldId));
                const dataToRem = oldForFlds?.filter((f) => !newForFlds?.includes(f));
                const dataToSend = newForFlds?.filter((f) => !oldForFlds?.includes(f));
                if (dataToSend.length) {
                  dataToSend.forEach((sid) => {
                    addedReference.push(
                      this.util.createReference(
                        fieldData.sid,
                        utilEnum.modelType.FIELD,
                        sid,
                        utilEnum.modelType.FIELD,
                        this.appId,
                        `${fieldData.f_tableId}/${fieldData.sid}`,
                        utilEnum.propertyName.FORMULA_BUILDER,
                        true
                      )
                    );
                  });
                }
                if (dataToRem.length) {
                  dataToRem.forEach((sid) => {
                    deletedReference.push(
                      this.util.createObjForDelRef(fieldData.sid, sid, utilEnum.propertyName.FORMULA_BUILDER)
                    );
                  });
                }
              }
            }

            if (!queryObjects.length) {
              queryObjects = null;
            }
            diffObj = { ...diffObj, ...baseObj };
            if (!isEqual(node.data.f_queryObjects, queryObjects)) {
              diffObj = { ...diffObj, ...{ f_queryObjects: queryObjects } };
            }
          } catch (e) {
            console.error(e);
          }
          diffObj = this.getOldDataAndSid(diffObj, fieldData, node);
          if (
            Object.prototype.hasOwnProperty.call(diffObj, 'f_cMandatory') ||
            Object.prototype.hasOwnProperty.call(diffObj, 'f_editC') ||
            Object.prototype.hasOwnProperty.call(diffObj, 'f_viewC') ||
            Object.prototype.hasOwnProperty.call(diffObj, 'f_formula')
          ) {
            if (!diffObj.type && !diffObj.aid && !diffObj.orgId && !diffObj.f_tableId) {
              diffObj.type = fieldData?.type;
              diffObj.aid = fieldData?.aid;
              diffObj.orgId = fieldData?.orgId;
              diffObj.f_tableId = fieldData?.f_tableId;
            }
            const datatosend = {
              fieldProperties: [diffObj],
              addedReference: addedReference.length ? addedReference : undefined,
              deletedReference: deletedReference.length ? deletedReference : undefined
            };
            this.store.dispatch(
              updateAppDM({
                apiConstants: ApiConstants.updateFieldsAndReference,
                appDMData: datatosend
              })
            );
          } else {
            this.store.dispatch(
              updateAppDM({
                apiConstants: ApiConstants.updateFields,
                appDMData: [diffObj]
              })
            );
          }
        }
      }
      node.data = fieldData;
    }
  }

  checkReferencefieldKeys(diffObj: any, data: any) {
    const modifiedField: any = [];
    const referenceKeys = [
      // {
      //   key: "f_searchable",
      //   id: "sid",
      //   action: "UPDATE",
      // },
      {
        key: 'f_hasMultiVal',
        id: 'sid',
        action: 'UPDATE',
        propertyAction: 'UPDATE_MULTIPLE'
      },
      {
        key: 'f_transientField',
        id: 'sid',
        action: 'UPDATE',
        propertyAction: 'UPDATE_TRANSIENT'
      },
      {
        key: 'f_hasAnalyticalSync',
        id: 'sid',
        action: 'UPDATE',
        propertyAction: 'UPDATE_NONSYNC'
      }
    ];
    referenceKeys.forEach((o: any) => {
      //  if (o.key==='f_hasMultiVal' && diffObj[o.key]===false && data[o.key]===true) {
      //   modifiedField.push(o);
      // }
      // else
      if (o.key === 'f_transientField' && diffObj[o.key] === false && data[o.key] === true) {
        modifiedField.push(o);
      } else if (o.key === 'f_hasAnalyticalSync' && diffObj[o.key] && data[o.key] === false) {
        modifiedField.push(o);
      } else {
        console.info('no references');
      }
    });

    return {
      modifiedField: modifiedField,
      isChanged: modifiedField.length > 0
    };
  }

  getDmObj(id, order, delRec) {
    order.forEach((d) => {
      if (d?.data?.sid === id) {
        delRec = d;
      }
      if (d.children) {
        delRec = this.getDmObj(id, d.children, delRec);
      }
    });
    return delRec;
  }

  showErrMsg(data) {
    let sendData = {
      apiErr: data.err,
      tableMap: this.tableMap,
      fieldMap: this.tableFieldMap
    };
    if (data?.actionData?.added?.length) {
      sendData = { ...sendData, ...{ admData: data.actionData.added[0] } };
    } else if (data?.actionData?.deleted?.length) {
      const d = this.getDmObj(data.actionData.deleted[0], this.backupOrder, null);
      if (d) {
        sendData = { ...sendData, ...{ admData: d } };
      }
    } else if (data?.actionData?.draggedNode) {
      const d = this.getDmObj(data.actionData.draggedNode, this.dataModelDataOrder, null);
      if (d) {
        sendData = { ...sendData, ...{ admData: d } };
      }
    } else {
      const d = this.getDmObj(data.actionData.sid, this.dataModelDataOrder, null);
      sendData = { ...sendData, ...{ admData: d } };
    }
    this.utilService.showErrMsg(sendData);
  }

  debounceBatchSave = debounce(this.saveBatch.bind(this), this.debounceTime);
  saveBatch() {
    if (this.pendingService?.isPending?.getValue()) {
      this.debounceBatchSave();
      return;
    }
    if (this.propertiesTasks) {
      if (this.propertiesTasks.added.length === 0 && this.propertiesTasks.deleted.length === 0) {
        return;
      }
    }
    if (this.propertiesTasks.added.length) {
      if (this.propertiesTasks?.added[0]?.t_type === DMConstants.QUERY_VIEW) {
        this.propertiesTasks.added[0].t_query_type = 'multiple';
      }
      const added = [...this.propertiesTasks.added];
      const addtsk = added.map((dt) => {
        if (dt.isNewRec) {
          delete dt.isNewRec;
        }
        return dt;
      });
      this.propertiesTasks = { ...this.propertiesTasks, ...{ added: [...addtsk] } };
    }
    console.log(this.propertiesTasks);
    this.backupOrder = this.dataModelDataOrder;
    let data = this.propertiesTasks;
    // send tabId if there are deleted records
    if (this.propertiesTasks.deleted?.length) {
      data = { ...data, ...{ tabId: this.tabId } };
    }
    this.store.dispatch(saveDatamodelTableSuccess({ tableResults: null }));
    this.store.dispatch(saveDatamodelTableFailure({ tableError: null }));
    const batchApiConstants = ApiConstants.saveBatch;
    this.store.dispatch(
      saveAppDatamodelBatch({
        batchApiConstants,
        data
      })
    );
    if (data.added && data.added.length > 0) {
      data.added.forEach((task) => {
        this.updatetitle({ title: task.name, type: task.type }, task);
      });
    }
    // this.waitingOnresponse = true;
    this.pendingService.isPending = new BehaviorSubject(true);
    this.showLoader = true;
    this.propertiesTasks = this.resetTasksObj();
    this.EventTracker.start('dataModelTreeSaveSuccess');
    const saveSuccessSub = this.dataModelTreeSaveSuccess$.subscribe((data) => {
      this.EventTracker.stop('dataModelTreeSaveSuccess');
      console.log(`dataModelTreeSaveSuccess : ${this.EventTracker.trackedEvents.dataModelTreeSaveSuccess.duration}`);
      if (data) {
        this.loader.hide();
        if (saveSuccessSub) {
          saveSuccessSub.unsubscribe();
        }
        this.pendingService.isPending = new BehaviorSubject(false);
        this.zone.run(() => {
          this.showLoader = false;
        });

        if (data.added.length) {
          data.added.forEach((ele) => {
            const tree = $.ui.fancytree.getTree('#tree');
            const node = tree.getNodeByKey(ele.sid);
            const data = node.data;
            delete data.isNewRec;
            node.data = data;
            const $tdList = $(node.tr).find('>td');
            $tdList.eq(2).find('.node-spinner').addClass('d-none');
            if (!ele.sysGen) {
              $tdList.eq(3).find('.dropdown-toggle').removeAttr('disabled');
            }
          });
        }
      }
    });
    this.addToSubscriptionsList(saveSuccessSub);
    this.EventTracker.start('dataModelTreeSaveFailure');
    const saveFailureSub = this.dataModelTreeSaveFailure$.subscribe((data) => {
      this.EventTracker.stop('dataModelTreeSaveFailure');
      console.log(`dataModelTreeSaveFailure : ${this.EventTracker.trackedEvents.dataModelTreeSaveFailure.duration}`);
      if (data) {
        if (data.err) {
          this.showErrMsg(data);
          if (!Array.of('FIELD_NAME_SHOULD_NOT_BE_A_RESERVED_KEYWORD','FIELD_NAME_SHOULD_NOT_BE_A_SQL_KEYWORD').includes(data.err.error?.ERROR_CODE)) {
            this.reloadCurrentRoute();
          }
        }
        if (saveFailureSub) {
          saveFailureSub.unsubscribe();
        }
        this.loader.hide();
        this.pendingService.isPending = new BehaviorSubject(false);
        this.showLoader = false;
        if (data.actionData) {
          const payload = data.actionData;
          // remove the failed nodes on addition
          if (payload.added.length) {
            payload.added.forEach((ele) => {
              const tree = $.ui.fancytree.getTree('#tree');
              const node = tree.getNodeByKey(ele.sid);
              if (node) {
                this.removeTitles(node);
                if (ele.type === nodeType.TABLE) {
                  this.tablesInfo = this.tablesInfo.filter((e) => e.data.sid !== node.data.sid);
                  this.processTableInfos(true);
                }
                node.remove();
              }
            });
          }
          // condition to check whether new node in properties task queue have valid prenode
          if (this.propertiesTasks.added.length) {
            const added = this.propertiesTasks.added;
            this.propertiesTasks.added = added.filter((ele) => {
              const tree = $.ui.fancytree.getTree('#tree');
              const node = tree.getNodeByKey(ele.sid);
              if (ele.preNode) {
                const preNode = tree.getNodeByKey(ele.preNode);
                if (!preNode) {
                  node.remove();
                  return false;
                }
              }
              return true;
            });
          }
          // add the failed deleted node
          if (payload.deleted.length) {
            payload.deleted.forEach((id) => {
              let delRec: any = null;
              delRec = this.getDmObj(id, this.backupOrder, delRec);
              const tree = $.ui.fancytree.getTree('#tree');
              if (!tree.getNodeByKey(delRec.sid)) {
                if (delRec) {
                  const node: any = delRec;
                  const sid = node.data.preNode ? node.data.preNode : node.data.pNode;
                  const appendNode = tree.getNodeByKey(sid);
                  if (appendNode) {
                    if (node.data.preNode) {
                      appendNode.addNode(node, 'after');
                    } else if (node.data.pNode) {
                      const parNode = tree.getNodeByKey(node.data.pNode);
                      if (parNode.hasChildren()) {
                        const firstChild = parNode.children[0];
                        firstChild.addNode(node, 'before');
                      } else {
                        parNode.addNode(node, 'over');
                      }
                    }
                    this.updatetitle(node, node.data);
                    if (node.type === nodeType.TABLE) {
                      this.addNewTableToTableList(node);
                    }
                  }
                }
              }
            });
          }
        }
      }
    });
    this.addToSubscriptionsList(saveFailureSub);
  }

  clearLookupFieldsBasedOnLookupType(fieldData) {
    if (fieldData.f_lookupType === DMConstants.LOOKUP_TYPE_TABLE) {
      delete fieldData.f_lookupService;
    } else {
      delete fieldData.f_dField;
      delete fieldData.f_lookupTo;
    }
  }

  clearLookupFields(fieldData) {
    delete fieldData.f_lookupTo;
    delete fieldData.f_dField;
    delete fieldData.f_lookupType;
    delete fieldData.f_lookupService;
  }

  getParentTable(node) {
    if (node?.type === nodeType.TABLE) {
      return node;
    }
    let parentNode = node.parent;
    while (parentNode && parentNode?.type !== nodeType.TABLE) {
      parentNode = parentNode?.parent;
    }
    return parentNode;
  }

  addNewTableToTableList(node) {
    this.tablesInfo.push(node);
    this.processTableInfos(true);
  }

  updateNodeOnAddition(node, data) {
    const actionProps = {
      tabId: this.tabId
    };
    const prevSib = node.getPrevSibling();
    data.preNode = prevSib ? prevSib.data?.sid : null;
    const pNode = node.getParent();
    data.pNode = pNode?.title === 'root' ? null : pNode?.data.sid;
    this.propertiesTasks.added.push(data);
  }

  addPropertiesTask(node) {
    switch (node.type) {
      case nodeType.TABLE:
        let tableData = {
          ...node.data,
          aid: this.appId,
          name: node.title,
          orgId: this.orgId,
          t_type: node?.data?.t_type,
          type: node.type,
          tabId: this.tabId
        };
        this.getDefaultValues('table', node);
        if (this.formDefaultValues) {
          tableData = { ...this.formDefaultValues, ...tableData };
        }
        if (tableData?.t_type === 'query_view') {
          tableData.t_query_type = 'multiple';
        }
        // add default dataset for analytical table
        if (tableData?.t_type === DMConstants.TRANS_ANALY || tableData?.t_type === DMConstants.ANALY_ONLY) {
          tableData.t_datasetName = this.defDataset;
        }
        // this needs to come from datamodel properties but still default value is coming as null
        if (tableData?.t_type === DMConstants.TRANS_ANALY) {
          tableData.t_aTableName = tableData.name;
        }
        this.updateNodeOnAddition(node, tableData);
        node.data = { ...tableData };
        if (node?.data?.isNewRec) {
          delete node?.data?.isNewRec;
        }
        this.addNewTableToTableList(node);
        this.createDefaultFields(node, true);
        this.store.dispatch(
          propertyActions.setPropertiesValues({ propertiesValues: { ...tableData, typeChange: true } })
        );
        break;
      case nodeType.FIELD:
        const parentNode = this.getParentTable(node);
        const tableId = parentNode.data.sid || parentNode.data.id;
        this.getDefaultValues('String', node);
        const syncToAnalytical = parentNode?.data?.t_type === DMConstants.TRANS_ANALY;
        let fieldData: any = {
          name: $.ui.fancytree.unescapeHtml(node.title),
          aid: this.appId,
          f_tableId: tableId,
          f_type: node.data.f_type,
          sid: node.data.sid,
          orgId: this.orgId,
          f_hasAnalyticalSync: syncToAnalytical,
          type: node.type,
          tabId: this.tabId
        };
        if (this.formDefaultValues) {
          fieldData = { ...this.formDefaultValues, ...fieldData };
        }
        this.updateNodeOnAddition(node, fieldData);
        node.data = { ...fieldData, ...{ isNewRec: true } };
        const $tdList = $(node.tr).find('>td');
        $tdList.eq(2).find('.node-spinner').removeClass('d-none');
        $tdList.eq(3).find('.dropdown-toggle').attr('disabled', 'true');
        this.store.dispatch(
          propertyActions.setPropertiesValues({ propertiesValues: { ...fieldData, typeChange: true } })
        );
        this.saveBatch();
        break;
      case nodeType.GROUP:
      case nodeType.FIELDGROUP:
        let data = {
          name: node.title,
          aid: this.appId,
          sid: node.data.sid,
          orgId: this.orgId,
          type: node.type,
          tabId: this.tabId
        };
        if (node.type === nodeType.FIELDGROUP) {
          const parentNode = this.getParentTable(node);
          const tableId = parentNode.data.sid || parentNode.data.id;
          data = { ...data, ...{ fg_tableId: tableId } };
        }
        this.updateNodeOnAddition(node, data);
        node.data = { ...data, ...{ isNewRec: true } };
        const $tdList1 = $(node.tr).find('>td');
        $tdList1.eq(2).find('.node-spinner').removeClass('d-none');
        this.saveBatch();
        break;
    }
  }

  // get the system generated fields for a table, including fields inside field groups
  getSysGenFieldsBasedOnTable(node: any): any[] {
    const fieldChildren: any[] = [];
    const queue: any[] = [node];

    while (queue.length > 0) {
      const currentNode = queue.shift();

      if (currentNode.data.f_sysF && currentNode.type === 'FIELD') {
        fieldChildren.push(currentNode);
      }

      if (currentNode.children?.length > 0) {
        queue.push(...currentNode.children);
      }
    }

    return fieldChildren;
  }

  updateSysGenFields(node) {
    const fldsTask: any = { added: [], updated: [], deleted: [] };
    // get the table default fields
    const sysGenFields = this.getSysGenFieldsBasedOnTable(node);
    let fields: any = [];
    const tblType = node.data.t_type;
    switch (tblType) {
      case DMConstants.TRANS_ONLY:
        fields = [
          'Sid',
          'Created By',
          'Created Date',
          'Modified By',
          'Modified Date',
          'Language Code',
          'Pid',
          GlobalConstants.isActiveField
        ];
        break;
      case DMConstants.TRANS_ANALY:
        fields = [
          'Sid',
          'Created By',
          'Created Date',
          'Modified By',
          'Modified Date',
          'Language Code',
          'Sync Time',
          'Pid',
          GlobalConstants.isActiveField
        ];
        break;
      case DMConstants.ANALY_ONLY:
        fields = [
          'Sid',
          'Created By',
          'Created Date',
          'Modified By',
          'Modified Date',
          'Language Code',
          'Sync Time',
          GlobalConstants.isActiveField
        ];
        break;
    }
    sysGenFields.forEach((fd) => {
      if (!fields.includes(fd.title)) {
        // && (node.title !== 'Application User')
        fd.data.sysGen = false;
        this.removeTitles(node);
        fldsTask.deleted.push(fd.data.sid);
        fd.remove();
      }
    });
    let syncTimeAdded = false;
    const syncTimeId = uuidv4();
    if (tblType === DMConstants.TRANS_ANALY || tblType === DMConstants.ANALY_ONLY) {
      if (!sysGenFields.find((fld) => fld.title === 'Sync Time')) {
        const preNodeId = node.children ? node.children[node.children.length - 1].data?.sid : null;
        const nodeObj = {
          title: 'Sync Time',
          type: nodeType.FIELD,
          key: syncTimeId,
          data: {
            sid: syncTimeId,
            f_type: 'String',
            sysGen: true,
            f_sysF: true,
            preNode: preNodeId,
            pNode: node.data.sid,
            tabId: this.tabId,
            f_tableId: node.data.sid,
            f_aField: true,
            f_indexed: true
            // f_searchable: 'yes'
          },
          icon: 'fa pen-field field-icon'
        };
        this.getDefaultValues(nodeObj.data.f_type, nodeObj);
        const syncToAnalytical = tblType === DMConstants.TRANS_ANALY;
        const fieldData = {
          ...nodeObj.data,
          ...this.formDefaultValues,
          name: nodeObj.title,
          aid: this.appId,
          f_hasAnalyticalSync: syncToAnalytical,
          type: nodeType.FIELD,
          orgId: this.orgId
        };
        node.addChildren(nodeObj);
        fldsTask.added.push(fieldData);
        syncTimeAdded = true;
      }
    }
    if (
      this.settingsData.deactivateRecords &&
      (tblType === DMConstants.TRANS_ANALY || tblType === DMConstants.TRANS_ONLY)
    ) {
      if (
        !sysGenFields.find((fld) => fld.title === GlobalConstants.isActiveField) &&
        node.title?.toLowerCase() !== 'Application User'?.toLowerCase()
      ) {
        const id = uuidv4();
        const preNodeId = syncTimeAdded
          ? syncTimeId
          : node.children
            ? node.children[node.children.length - 1].data?.sid
            : null;
        const nodeObj = {
          title: GlobalConstants.isActiveField,
          type: nodeType.FIELD,
          key: id,
          data: {
            sid: id,
            f_type: 'Boolean',
            sysGen: true,
            f_sysF: true,
            preNode: preNodeId,
            pNode: node.data.sid,
            tabId: this.tabId,
            f_tableId: node.data.sid,
            f_aField: true,
            f_indexed: true
            // f_searchable: 'yes'
          },
          icon: 'fa pen-field field-icon'
        };
        this.getDefaultValues(nodeObj.data.f_type, nodeObj);
        const syncToAnalytical = tblType === DMConstants.TRANS_ANALY;
        const fieldData = {
          ...nodeObj.data,
          ...this.formDefaultValues,
          name: nodeObj.title,
          aid: this.appId,
          f_hasAnalyticalSync: syncToAnalytical,
          type: nodeType.FIELD,
          orgId: this.orgId
        };
        node.addChildren(nodeObj);
        fldsTask.added.push(fieldData);
      }
    }
    // if table type is changed to trans + analytical, for default fields, synctoanal should to true
    if (sysGenFields.length && node?.data?.t_type === DMConstants.TRANS_ANALY) {
      sysGenFields.forEach((fld) => {
        const obj = {
          sid: fld.data.sid,
          tabId: this.tabId,
          f_hasAnalyticalSync: true,
          orgId: this.orgId,
          aid: this.appId,
          f_tableId: fld.data.f_tableId,
          type: nodeType.FIELD
        };
        fld.data = { ...fld.data, ...obj };
        fldsTask.updated.push(obj);
      });
    }
    return fldsTask;
  }

  debounceActivateNode = debounce(this.trigActNode.bind(this), this.debounceTime);
  trigActNode(node) {
    if (this.pendingService?.isPending?.getValue()) {
      this.debounceActivateNode(node);
      return;
    }
    if (this.rowid === node.data.sid) {
      this.onActivateNode(node);
    }
  }

  private getNodeTypeName(nodeType: string): string {
    if (this.isField(nodeType)) return 'Field';
    if (this.isTable(nodeType)) return 'Table';
    return 'Item';
  }

  private getModelType(type: string): string {
    if (type === nodeType.TABLE) return 'TABLE';
    if (type === nodeType.FIELD) return 'FIELD';
    return 'Group';
  }

  private revertNodeNameOnCancel(node: any): void {
    if (!this.isField(node.type) && !this.isTable(node.type)) {
      return;
    }

    delete this.updatedTableName[node?.data?.sid];
    const oldtitleToCheck = node?.title.toLowerCase().replace(/\s\s+/g, ' ');

    if (this.isTable(node.type)) {
      this.revertTableTitle(oldtitleToCheck, node.data.name);
    } else {
      this.revertFieldTitle(node, oldtitleToCheck);
    }
    node.setTitle(node.data.name);
  }

  private revertTableTitle(oldTitle: string, newName: string): void {
    if (this.tableTitles.includes(oldTitle)) {
      const i = this.tableTitles.indexOf(oldTitle);
      this.tableTitles[i] = newName;
    }
  }

  private revertFieldTitle(node: any, oldTitle: string): void {
    const parentKey = this.getParentTable(node)?.key;
    const tableFields = this.fieldTitles[parentKey];
    if (tableFields?.includes(oldTitle)) {
      const i = this.fieldTitles[parentKey].indexOf(oldTitle);
      this.fieldTitles[parentKey][i] = node.data.name;
    }
  }

  private executeNodeRename(node: any, properties: any, common: any): void {
    if (node.type === nodeType.TABLE) {
      this.resetRenameState();
      this.renameTable(node, properties);
      return;
    }

    if (node.type === nodeType.FIELD) {
      this.executeFieldRenameWithReferences(node, properties, common);
      return;
    }

    if (node.type === nodeType.GROUP || node.type === nodeType.FIELDGROUP) {
      this.resetRenameState();
      this.renameGroup(node, properties);
    }
  }

  private executeFieldRenameWithReferences(node: any, properties: any, common: any): void {
    this.referenceUtil
      .handleWithReferences({
        ...common,
        onConfirm: () => {
          this.resetRenameState();
          this.renameField(node, properties);
        },
        onNoReferences: () => {
          this.resetRenameState();
          this.renameField(node, properties);
        }
      })
      .catch(() => {
        this.resetRenameState();
        this.renameField(node, properties);
      });
  }

  private resetRenameState(): void {
    this.enabledReferenceModal = false;
    this.isLoading = false;
  }

  // Renaming fancytreenode
  updatePropertiesTask(node) {
    this.isLoading = true;

    if (this.enabledReferenceModal) {
      this.isLoading = false;
      this.propertyLoading = false;
      node.setTitle(node.data.name);
      return;
    }

    if (this.isField(node.type) || this.isTable(node.type)) {
      this.updatedTableName[node.data.sid] = $.ui.fancytree.unescapeHtml(node.title);
    }

    const data = node.data;
    if (!data) {
      return;
    }

    this.enabledReferenceModal = true;
    const properties = data;
    const nodeInfo = {
      name: node?.title || node?.data?.name,
      type: this.getNodeTypeName(node.type)
    };

    const common = {
      payload: {
        modelId: node?.data?.sid,
        modelType: this.getModelType(node.type),
        actionType: this.isField(node.type) ? ActionType.FIELD_RENAME : ActionType.TABLE_TYPE_UPDATE,
        action: UiActions.RENAME
      },
      node: nodeInfo,
      onCancel: () => {
        this.resetRenameState();
        this.revertNodeNameOnCancel(node);
      },
      onError: () => {
        this.resetRenameState();
      }
    } as any;

    this.executeNodeRename(node, properties, common);
  }

  renameTable(node: any, properties: any) {
    const tableData = { ...properties, name: node.title, orgId: this.orgId, tabId: this.tabId };
    if (tableData?.t_type === DMConstants.TRANS_ANALY) {
      tableData.t_aTableName = tableData.name;
    }
    delete this.updatedTableName[node.data.sid];
    this.updateTable(tableData);
    const propData = { ...tableData };
    if (node.data.sid === this.rowid) {
      propData.typeChange = true;
      propData.valueChange = true;
      this.store.dispatch(propertyActions.setPropertiesValues({ propertiesValues: propData }));
    }
    // to update name in tablemap
    this.updatetitle({ title: properties.name, type: node.data.type }, tableData);
  }

  renameField(node, properties) {
    try {
      const fieldData = { ...properties, name: node.title, aid: this.appId, orgId: this.orgId, tabId: this.tabId };
      fieldData.f_type = fieldData.f_type ? fieldData.f_type : fieldData.f_type;
      delete this.updatedTableName[node.data.sid];
      this.updateField(fieldData);
      const propData = { ...fieldData };
      if (node.data.sid === this.rowid) {
        propData.typeChange = true;
        propData.valueChange = true;
        this.store.dispatch(propertyActions.setPropertiesValues({ propertiesValues: propData }));
      }
      // to update name in fieldmap
      this.updatetitle({ title: properties.name, type: node.data.type }, fieldData);
    } catch (e) {
      console.error(e);
    }
  }
  checkFieldType(field) {
    return ['string', 'dropdown', 'text', 'radio', 'email', 'url'].includes(field.f_type.toLowerCase());
  }

  renameGroup(node, properties) {
    const data = { ...properties, name: node.title, aid: this.appId, orgId: this.orgId, tabId: this.tabId };
    const obj = {
      orgId: this.orgId,
      aid: this.appId,
      sid: data.sid,
      name: data.name,
      old_name: node.data.name,
      tabId: this.tabId
    };
    this.store.dispatch(
      updateAppDM({
        apiConstants: ApiConstants.applDMUpdateName,
        appDMData: {
          ...obj,
          type: node.type
        }
      })
    );
    node.data = data;
  }

  createDefaultFields(node, intialCall?: boolean, fields?: any) {
    if (!fields) {
      if (this.settingsData.deactivateRecords) {
        switch (node?.data?.t_type) {
          case DMConstants.TRANS_ONLY:
            fields = {
              Sid: 'String',
              'Created By': 'String',
              'Created Date': 'DateTime',
              'Modified By': 'String',
              'Modified Date': 'DateTime',
              IsActive: 'Boolean'
            };
            break;
          case DMConstants.TRANS_ANALY:
            fields = {
              Sid: 'String',
              'Created By': 'String',
              'Created Date': 'DateTime',
              'Modified By': 'String',
              'Modified Date': 'DateTime',
              'Sync Time': 'DateTime',
              IsActive: 'Boolean'
            };
            break;
          case DMConstants.ANALY_ONLY:
            fields = {
              Sid: 'String',
              'Created By': 'String',
              'Created Date': 'DateTime',
              'Modified By': 'String',
              'Modified Date': 'DateTime',
              'Sync Time': 'DateTime'
            };
            break;
          case DMConstants.COMPLEX_TYPE:
            fields = { Jid: 'String' };
            break;
          default:
            fields = {};
            break;
        }
      } else {
        switch (node?.data?.t_type) {
          case DMConstants.TRANS_ONLY:
            fields = {
              Sid: 'String',
              'Created By': 'String',
              'Created Date': 'DateTime',
              'Modified By': 'String',
              'Modified Date': 'DateTime'
            };
            break;
          case DMConstants.TRANS_ANALY:

          case DMConstants.ANALY_ONLY:
            fields = {
              Sid: 'String',
              'Created By': 'String',
              'Created Date': 'DateTime',
              'Modified By': 'String',
              'Modified Date': 'DateTime',
              'Sync Time': 'DateTime'
            };
            break;
          case DMConstants.COMPLEX_TYPE:
            fields = { Jid: 'String' };
            break;
          default:
            fields = {};
            break;
        }
      }
    }
    const fieldsList = Object.keys(fields);
    const children: any = [];
    const _self = this;
    // This prevNode will come only on table type change
    let preNodeId = null;
    if (node.hasChildren()) {
      const child = node.children;
      preNodeId = child[child.length - 1].data?.sid;
    }
    const fldProps: any = [];
    fieldsList.forEach((e, i) => {
      const title = e.trim().replace(/\s\s+/g, ' ');
      const titleToCheck = title.toLowerCase();
      const parentKey = node.key;
      const tableFields = this.fieldTitles[parentKey];
      if (tableFields) {
        this.fieldTitles[parentKey].push(titleToCheck);
      } else {
        this.fieldTitles[parentKey] = [titleToCheck];
      }
      const id = uuidv4();
      let nodeObj = {
        title: e,
        type: nodeType.FIELD,
        key: id,
        icon: this.getTreeNodeIconClass({ type: nodeType.FIELD, title: e }),
        data: {
          sid: id,
          f_type: fields[e],
          sysGen: true,
          f_sysF: true,
          preNode: i > 0 ? children[i - 1].data.sid : preNodeId,
          pNode: node.data.sid,
          tabId: this.tabId,
          isNewRec: true
        }
      };

      let tableId = node.type === nodeType.TABLE ? node.data.sid || node.data.id : '';
      const parentTable = this.getParentTable(node);
      if (!tableId) {
        tableId = parentTable.data.sid;
      }
      this.getDefaultValues(nodeObj.data.f_type, nodeObj);
      const syncToAnalytical = parentTable?.data?.t_type === DMConstants.TRANS_ANALY;
      const f_mandatory = e === 'Sid' ? 'yes' : this.formDefaultValues.f_mandatory;
      let fieldData = {
        ...nodeObj.data,
        ...this.formDefaultValues,
        name: nodeObj.title,
        aid: _self.appId,
        f_tableId: tableId,
        sysGen: true,
        f_sysF: true,
        f_hasAnalyticalSync: syncToAnalytical,
        type: nodeType.FIELD,
        orgId: this.orgId,
        f_mandatory: f_mandatory
      };
      if (fieldData?.sysGen) {
        fieldData.f_editing = 'no';
      }
      if (e === 'Sid') {
        fieldData = { ...fieldData, ...{ f_minL: 36, f_maxL: 36 } };
      }
      if (
        e == GlobalConstants.isActiveField &&
        (node?.data?.t_type === DMConstants.TRANS_ANALY || node?.data?.t_type === DMConstants.TRANS_ONLY)
      ) {
        fieldData = {
          ...fieldData,
          ...{
            // f_searchable: 'yes',
            f_mandatory: 'yes',
            f_sysF: true,
            sysGen: true,
            f_transientField: false,
            f_dVal: true,
            f_editing: 'yes'
          }
        };
      }
      if (node?.data?.t_type === DMConstants.TRANS_ANALY || node?.data?.t_type === DMConstants.ANALY_ONLY) {
        if (e === 'Sync Time') {
          fieldData = { ...fieldData, ...{ f_aField: true } };
        }
      }

      if (fieldData.f_aValues && isArray(fieldData.f_aValues)) {
        fieldData.f_aValues = JSON.stringify({ values: fieldData.f_aValues });
      }
      if (this.isRdbms) {
        fieldData.f_indexed = true;
        // fieldData.f_searchable = 'yes';
      }
      if (this.defaultFieldsArray.includes(title)) {
        // fieldData.f_searchable = 'yes';
        fieldData.f_editing = 'no';
      }
      if (
        title === 'Sid' &&
        this.isRdbms &&
        (node?.data?.t_type === DMConstants.TRANS_ONLY || node?.data?.t_type === DMConstants.TRANS_ANALY)
      ) {
        if (intialCall) {
          let tabledata = this.propertiesTasks.added.find((tb) => tb.sid === tableId);
          node.data = { ...node.data };
          let tbls = this.propertiesTasks.added;
          let tblFldTask = tbls.map((tbl) => {
            return tbl.sid === tableId ? tabledata : tbl;
          });
          this.propertiesTasks = { ...this.propertiesTasks, ...{ added: tblFldTask } };
        } else {
          this.uniqSid = id;
        }
      }
      nodeObj = { ...nodeObj, ...{ data: { ...fieldData } } };
      children.push(nodeObj);
      fldProps.push(fieldData);
    });

    if (
      this.isRdbms &&
      this.techStackData.textSearch == GlobalConstants.searchDbEs &&
      (node?.data?.t_type === DMConstants.TRANS_ONLY || node?.data?.t_type === DMConstants.TRANS_ANALY)
    ) {
      const searchableFields = fldProps.reduce((acc, field: any) => {
        acc[field.sid] = {
          fieldId: field.sid
        };
        const isPartialSearch =
          this.checkFieldType(field) && field.name.toLowerCase() !== 'sid' && field.name.toLowerCase() !== 'pid';
        if (isPartialSearch) {
          acc[field.sid].partialSearch = true;
        }
        return acc;
      }, {});

      const tableId =
        node.type === nodeType.TABLE ? node.data.sid || node.data.id : this.getParentTable(node)?.data?.sid;

      if (tableId) {
        let tabledata = this.propertiesTasks.added.find((tb) => tb.sid === tableId);

        if (tabledata) {
          this.propertiesTasks.added = this.propertiesTasks.added.map((tbl) => (tbl.sid === tableId ? tabledata : tbl));
        }
      }
    }

    if (children?.length) {
      node.addChildren(children);
      const added = [...this.propertiesTasks.added, ...fldProps];
      this.propertiesTasks = { ...this.propertiesTasks, ...{ added: added } };
    }
    this.saveBatch();
  }

  handleContextMenuClick(node, action, options, fromCommand) {
    switch (action) {
      case 'whereUsed':
        this.showWhereUsed(node);
        break;
      case 'delete':
        if (this.pendingService?.isPending?.getValue()) {
          this.showMessage('info', this.translate.instant('CONCURRENCY_ERROR1'));
        } else {
          this.messageService.clear();
          if (this.curNodeData) {
            const key = this.curNodeData.node.key;
            this.curNodeData.input.val('');
            $(this.curNodeData.input).blur();
            const tree = $.ui.fancytree.getTree('#tree');
            const node = tree.getNodeByKey(key);
            if (node) {
              this.confirmDeleteNode(node, action, options, fromCommand);
            }
          } else {
            this.confirmDeleteNode(node, action, options, fromCommand);
          }
        }
        break;
      case 'addChildFields':
        this.zone.run(() => {
          this.showPopup = true;
          this.currNode = node;
        });
        break;
      case 'addAiFields':
        this.generateModelForFieldsPrompt(node);
        break;
      default:
        this.createNode(node, action, options, fromCommand);
    }
  }

  createNode(node, action, options, fromCommand) {
    this.store.dispatch(propertyActions.setPropertiesData({ propertiesData: null }));
    this.store.dispatch(propertyActions.setPropertiesValues({ propertiesValues: null }));
    this.rowid = null;
    const AFTER = 'after';
    const BEFORE = 'before';
    let OVER = 'child';
    if (fromCommand) {
      OVER = 'after';
    }
    const id = uuidv4();
    const baseProperties = {
      title: '',
      sid: id,
      key: id
    };
    const baseFolderProperties = {
      ...baseProperties,
      folder: true
    };
    // prevent creation of node, if any other node is open
    if (!$('.fancytree-edit-input')[0] && action !== 'delete') {
      switch (action) {
        case 'addGroup':
          node.editCreateNode(AFTER, {
            type: nodeType.GROUP,
            icon: DMConstants.GROUP_ICON,
            ...baseFolderProperties
          });
          break;
        case 'addChildGroup':
          node.editCreateNode(OVER, {
            type: nodeType.GROUP,
            icon: DMConstants.GROUP_ICON,
            ...baseFolderProperties
          });
          break;
        case 'addChildTable':
          this.zone.run(() => {
            this.messages = [];
            this.showTblPopup = true;
            this.currNode = node;
            this.createTblPos = OVER;
          });
          break;
        case 'addSiblingTable':
          this.zone.run(() => {
            this.messages = [];
            this.showTblPopup = true;
            this.currNode = node;
            this.createTblPos = AFTER;
          });
          break;
        case 'addSiblingTableAbove':
          this.zone.run(() => {
            this.messages = [];
            this.showTblPopup = true;
            this.currNode = node;
            this.createTblPos = BEFORE;
          });
          break;
        case 'addSiblingField':
          node.editCreateNode(AFTER, {
            type: nodeType.FIELD,
            icon: DMConstants.FIELD_ICON,
            f_type: 'String',
            ...baseProperties
          });
          break;
        case 'addSiblingFieldAbove':
          node.editCreateNode(BEFORE, {
            type: nodeType.FIELD,
            icon: DMConstants.FIELD_ICON,
            f_type: 'String',
            ...baseProperties
          });
          break;
        case 'addChildField':
          node.editCreateNode(OVER, {
            type: nodeType.FIELD,
            icon: DMConstants.FIELD_ICON,
            f_type: 'String',
            ...baseProperties,
            ...this.initialFieldProperties
          });
          break;
        case 'addFieldGroup':
          node.editCreateNode(OVER, {
            type: nodeType.FIELDGROUP,
            icon: DMConstants.FIELD_GROUP_ICON,
            ...baseFolderProperties
          });
          break;
        case 'addFieldGroupBelow':
          node.editCreateNode(AFTER, {
            type: nodeType.FIELDGROUP,
            icon: DMConstants.FIELD_GROUP_ICON,
            ...baseFolderProperties
          });
          break;
        case 'addFieldGroupAbove':
          node.editCreateNode(BEFORE, {
            type: nodeType.FIELDGROUP,
            icon: DMConstants.FIELD_GROUP_ICON,
            ...baseFolderProperties
          });
          break;
      }
    }
  }

  processTreeData(d) {
    let data: any = [];
    if (d.title === 'root' && d.children) {
      data = [...d.children];
    }
    return data;
  }

  resetTblFldTask() {
    this.propertiesTasks = { table: [], datamodel: [], tableOrderingInfo: {} };
  }

  reloadCurrentRoute() {
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl], { relativeTo: this.acRoute });
    });
  }

  removeTitles(node) {
    const title = node.title.toLowerCase().trim();
    if (node.type === nodeType.GROUP) {
      const index = this.groupTitles.indexOf(title);
      if (index > -1) {
        this.groupTitles.splice(index, 1);
      }
    } else if (node.type === nodeType.TABLE) {
      const index = this.tableTitles.indexOf(title);
      if (index > -1) {
        this.tableTitles.splice(index, 1);
      }
    } else if (node.type === nodeType.FIELD) {
      const parentTable = this.getParentTable(node);
      const key = parentTable.key;
      const index = this.fieldTitles[key].indexOf(title);
      if (index > -1) {
        this.fieldTitles[key].splice(index, 1);
      }
    } else if (node.type === nodeType.FIELDGROUP) {
      const parentTable = this.getParentTable(node);
      const key = parentTable.key;
      const index = this.fieldGroupTitles[key].indexOf(title);
      if (index > -1) {
        this.fieldGroupTitles[key].splice(index, 1);
      }
    }
  }

  addTitles(title, type, parent) {
    if (type === nodeType.GROUP) {
      this.groupTitles.push(title);
    } else if (type === nodeType.TABLE) {
      this.tableTitles.push(title);
    } else if (type === nodeType.FIELD || type === nodeType.FIELDGROUP) {
      this.fieldTitles[parent].push(title);
    }
  }

  saveFancyTreeTableOrder(data?: any, isDelete?: boolean) {
    if (!isDelete) {
      if (data.isNew) {
        this.addPropertiesTask(data.node);
      } else {
        this.updatePropertiesTask(data.node);
      }
    }
  }

  isFieldgroup(type: string) {
    return type === nodeType.FIELDGROUP;
  }

  isField(type: string) {
    return type === nodeType.FIELD;
  }

  isGroup(type: string) {
    return type === nodeType.GROUP;
  }

  isTable(type: string) {
    return type === nodeType.TABLE;
  }

  isNewNode(options) {
    const classList = options?.$trigger[0]?.firstChild?.classList;
    if (classList) {
      return Object.values(classList).includes('fancytree-edit-input');
    }
    return false;
  }

  fetchModelReferences(payload: any) {
    const trackerKey = `${payload.modelType}_${payload.actionType}`;
    this.EventTracker.start(trackerKey);
    return this.referenceUtil
      .getReferences(payload)
      .then((res: any) => {
        this.EventTracker.stop(trackerKey);
        if (this.EventTracker?.trackedEvents?.[trackerKey]?.duration !== undefined) {
          console.log(`${trackerKey} : ${this.EventTracker.trackedEvents[trackerKey].duration}`);
        }
        return res;
      })
      .catch((err) => {
        try {
          this.EventTracker.stop(trackerKey);
        } catch {
          // do nothing
        }
        throw err;
      });
  }

  showWhereUsed(node) {
    this.zone.run(() => {
      this.isLoading = true;
    });

    this.referenceUtil.getAllReferences(node?.data?.sid, 'getAllReferences').then(
      (references: any) => {
        this.zone.run(() => {
          this.isLoading = false;
        });

        references = (references || []).filter((d: any) => !this.excluded.includes(d.propertyName));
        if (references.length > 0) {
          this.zone.run(() => {
            this.referenceUtil.openReferenceTreeDialog({
              node: { name: node?.data?.name || node?.title, type: node?.data?.type },
              referenceList: references,
              action: 'WHERE_USED'
            });
          });
        } else {
          const itemName = node?.data?.name || node?.title;
          this.zone.run(() => this.util.showNoReferencesDialog(itemName, node?.data?.type));
        }
      },
      (error) => {
        console.error(error);
        this.zone.run(() => {
          this.isLoading = false;
          this.util.showError(this.translate.instant('ERROR_FETCHING_REFERENCES'));
        });
      }
    );
  }

  confirmDeleteNode(node, action, properties, fromCommand) {
    /** Single node deletion only possible for now */
    const name = node.title;
    const _self = this;
    const isGroup = this.isFieldgroup(node.type) || this.isGroup(node.type);
    const isGroupDeletion = isGroup && node.children && node.children.length > 0;
    if (isGroupDeletion) {
      const messageObj = {
        [nodeType.GROUP]: `<span class="font-bold extra-bold">"${name}"</span> group contains tables / group. Please delete all tables / group inside the group and try again`,
        [nodeType.FIELDGROUP]: `<span class="font-bold">"${name}"</span> field group contains fields / field group. Please delete all fields inside the fields / field group and try again`
      };
      this.showMessage('warn', messageObj[node.type]);
      return;
    }

    /**Check for references before delete */
    if (isGroup) {
      // no references for groups
      this.confirmDeletion(node, action, properties, fromCommand, true);
    } else {
      this.propertyLoading = false;
      this.zone.run(() => {
        _self.isLoading = true;
      });
      this.isLoading = true;
      if (!this.enabledReferenceModal) {
        this.enabledReferenceModal = true;
        const nodeInfo = {
          name: node?.data?.name || node?.title,
          type: this.isField(node.type) ? 'Field' : 'Table'
        };
        this.referenceUtil
          .handleWithReferences({
            payload: {
              modelId: node?.data?.sid,
              modelType: this.isField(node.type) ? 'FIELD' : 'TABLE',
              actionType: this.isField(node?.type) ? ActionType.FIELD_DELETE : ActionType.TABLE_DELETE,
              action: UiActions.DELETE
            },
            node: nodeInfo,
            onConfirm: () => {
              this.enabledReferenceModal = false;
              this.isLoading = false;
              this.confirmDeletion(node, action, properties, fromCommand, false, {}, true);
            },
            onNoReferences: () => {
              this.enabledReferenceModal = false;
              this.isLoading = false;
              this.confirmDeletion(node, action, properties, fromCommand, false, {});
            },
            onCancel: () => {
              this.enabledReferenceModal = false;
              this.isLoading = false;
            },
            onError: (err: any) => {
              this.enabledReferenceModal = false;
              this.isLoading = false;
            }
          })
          .catch(() => {
            this.enabledReferenceModal = false;
            this.isLoading = false;
          });
      }
    }
  }

  private determineReferenceAction(genericAction: string): string {
    const deleteActions = [
      'FIELD_DELETE', 'TABLE_DELETE', 'FUNCTIONAL_PRIMARY_KEY_DELETE',
      'PARENT_TABLE_DELETE', 'LOOKUPFIELDS_DELETE'
    ];
    const renameActions = ['TABLE_RENAME', 'FIELD_RENAME', 'GROUP_RENAME'];
    const whereUsedActions = ['WHERE_USED'];

    if (deleteActions.includes(genericAction)) return 'DELETE';
    if (renameActions.includes(genericAction)) return 'RENAME';
    if (whereUsedActions.includes(genericAction)) return 'WHERE_USED';
    return 'UPDATE';
  }

  private buildReferenceExtras(rawData: any, nodedata: any): any {
    return {
      propertyAction: rawData.propertyAction,
      fieldProps: rawData.genericAction === 'FIELD_TYPE_UPDATE'
        ? { changedFieldType: rawData?.value, oldFieldType: nodedata?.f_type }
        : {},
      additionalProps: rawData.genericAction === 'LOOKUPFIELDS_DELETE' ? rawData.tablePropsInfo : {},
      parentTableDelete: !!rawData?.parentTableDelete
    };
  }

  private handleConfirmedReferenceAction(rawData: any): void {
    const tableUpdateActions = [
      'TABLE_UPDATE', 'LOOKUPFIELDS_DELETE', 'FUNCTIONAL_PRIMARY_KEY_DELETE',
      'PARENT_TABLE_DELETE', 'PARENT_TABLE_REMOVE', 'MANDATORY_FILTERS_UPDATE',
      'MANDATORY_FIELD_REMOVE', 'MANDATORY_FIELD_UPDATE', 'OPTIONAL_FILTERS_UPDATE',
      'OPTIONAL_FIELD_REMOVE', 'OPTIONAL_FIELD_UPDATE', 'UNIQUE_LOOKUPS_UPDATE',
      'UNIQUE_FIELD_REMOVE', 'QUERY_TYPE_UPDATE',
      'DISABLE_DEFAULT_ROW_DETAIL_PAGE', 'UPDATE_QUERY_TYPE_FROM_SINGLE',
      'UPDATE_QUERY_TYPE_FROM_MULTIPLE'
    ];

    if (rawData.genericAction === 'FIELD_DELETE' || rawData.genericAction === 'TABLE_DELETE') {
      this.confirmDeletion(rawData.node, rawData.action, rawData.properties, rawData.fromCommand, false, rawData.value, true);
      return;
    }

    if (tableUpdateActions.includes(rawData.genericAction)) {
      if (rawData.genericAction === ActionType.MANDATORY_FIELD_UPDATE || rawData.genericAction === ActionType.OPTIONAL_FIELD_UPDATE) {
        this.showTableSearchConflictConfirmation(rawData);
        return;
      }
      this.updateTableProps(rawData.tableData, rawData.originalNode || rawData.node, rawData.fancyTreeDataChange);
      return;
    }

    if (rawData.genericAction === 'FIELD_TYPE_UPDATE') {
      this.dataTypeChangeCall(rawData.value, rawData.node, rawData.tree, rawData.complexId, rawData.complexName);
      return;
    }

    if (rawData.genericAction === 'UPDATE_FIELD_PROPS') {
      this.updateFieldProps(rawData.node, rawData.fieldData);
      return;
    }

    if (rawData.genericAction === 'TABLE_RENAME') {
      this.renameTable(rawData.node, rawData.properties);
      return;
    }

    if (rawData.genericAction === 'FIELD_RENAME') {
      this.renameField(rawData.node, rawData.properties);
      return;
    }

    if (rawData.genericAction === 'GROUP_RENAME') {
      this.renameGroup(rawData.node, rawData.properties);
      return;
    }

    console.log('nothing to call');
  }

  private handleCancelledReferenceAction(rawData: any, nodedata: any): void {
    this.enabledReferenceModal = false;
    const renameActions = ['TABLE_RENAME', 'FIELD_RENAME', 'GROUP_RENAME'];

    if (!renameActions.includes(rawData.genericAction)) {
      this.store.dispatch(propertyActions.setPropertiesValues({ propertiesValues: { ...nodedata, typeChange: true } }));
      return;
    }

    if (!this.isField(rawData.node.type) && !this.isTable(rawData.node.type)) {
      return;
    }

    delete this.updatedTableName[rawData?.node?.data?.sid];
    const oldtitleToCheck = rawData?.node?.title.toLowerCase().replace(/\s\s+/g, ' ');

    if (this.isTable(rawData.node.type)) {
      this.revertTableTitleFromRawData(rawData, oldtitleToCheck);
    } else {
      this.revertFieldTitleFromRawData(rawData, oldtitleToCheck);
    }
    rawData.node.setTitle(rawData.node.data.name);
  }

  private revertTableTitleFromRawData(rawData: any, oldtitleToCheck: string): void {
    if (this.tableTitles.includes(rawData?.node?.title.toLowerCase())) {
      const i = this.tableTitles.indexOf(oldtitleToCheck);
      this.tableTitles[i] = rawData.node.data.name;
    }
  }

  private revertFieldTitleFromRawData(rawData: any, oldtitleToCheck: string): void {
    const parentKey = this.getParentTable(rawData?.node)?.key;
    const tableFields = this.fieldTitles[parentKey];
    if (tableFields && tableFields.includes(oldtitleToCheck)) {
      const i = this.fieldTitles[parentKey].indexOf(oldtitleToCheck);
      this.fieldTitles[parentKey][i] = rawData.node.data.name;
    }
  }

  private showTableSearchConflictConfirmation(rawData: any): void {
    const sids = (rawData.node?.data?.name || '').split(',').filter((s: string) => s.trim());
    const fieldNames = sids
      .map((sid: string) => this.getLatestDataFromFsData(sid.trim())?.name || sid)
      .join(', ');
    const message = this.translate.instant('TABLE_SEARCH_CONFLICT_MESSAGE', { fieldNames });
    const header = this.translate.instant('TABLE_SEARCH_CONFLICT_HEADER');
    const _self = this;
    this.zone.run(() => {
      _self.confirmationDialogService.confirm({
        header,
        message,
        acceptIcon: 'pi pi-check',
        rejectIcon: 'pi pi-times',
        accept: () => {
          _self.updateTableProps(rawData.tableData, rawData.originalNode || rawData.node, rawData.fancyTreeDataChange);
        },
        reject: () => {
          _self.store.dispatch(propertyActions.setPropertiesValues({
            propertiesValues: { ...(rawData.originalNode || rawData.node)?.data, typeChange: true }
          }));
        }
      });
    });
  }

  showReferenceTree(nodedata: any, value: any, rawData: any = {}) {
    this.enabledReferenceModal = true;
    this.softUpdateProps = false;

    const action = this.determineReferenceAction(rawData.genericAction);
    const nodeInfo = {
      name: nodedata?.name || rawData?.node?.title || '',
      type: this.isField(rawData?.node?.type) ? 'Field' : this.isTable(rawData?.node?.type) ? 'Table' : 'Item'
    };
    const extras = this.buildReferenceExtras(rawData, nodedata);

    this.EventTracker.start('modalRef');
    this.referenceUtil
      .openReferenceTree(nodeInfo, value, action, extras)
      .then((confirmed: boolean) => {
        this.EventTracker.stop('modalRef');
        console.log(`modalRef : ${this.EventTracker.trackedEvents.modalRef.duration}`);
        this.enabledReferenceModal = false;

        if (confirmed) {
          this.handleConfirmedReferenceAction(rawData);
        } else {
          this.handleCancelledReferenceAction(rawData, nodedata);
        }
      })
      .catch(() => {
        try {
          this.EventTracker.stop('modalRef');
        } catch {
          // do nothing
        }
        this.enabledReferenceModal = false;
      });
  }

  formConfirmationMessage(node, groupDeletion, typeChnage, value) {
    const name = node.title;
    const messageObj = {
      [nodeType.FIELD]: `Are you sure you want to delete the Field "${name}" ? `,
      [nodeType.FIELDGROUP]: `Are you sure you want to delete the Field Group "${name}" ? `,
      [nodeType.TABLE]: `Are you sure you want to delete the Table "${name}" ? `,
      [nodeType.GROUP]: `Are you sure you want to delete the Group "${name}" ? `
    };
    return messageObj[node.type];
  }

  confirmDeletion(
    node,
    action,
    properties,
    fromCommand,
    groupDeletion: boolean,
    value?: any,
    fromReferencePopup?: boolean
  ) {
    const message = this.formConfirmationMessage(node, groupDeletion, false, value);
    const _prop = [node, action, properties, fromCommand];
    const that = this;
    this.isLoading = false;
    this.propertyLoading = false;
    // this.loader.hide();
    let confirmationObj: Confirmation = {};
    if (!fromReferencePopup) {
      confirmationObj = {
        header: this.translate.instant('CONFIRMATION'),
        message,
        closable: true,
        accept: () => {
          this.showLoader = true;
          that.deleteNode(_prop[0]);
        },
        reject: () => {
          return;
        },
        acceptIcon: 'pi pi-check',
        rejectIcon: 'pi pi-times'
      };
      const _self = this;
      this.zone.run(() => {
        _self.confirmationDialogService.confirm(confirmationObj);
      });
    } else {
      this.showLoader = true;
      that.deleteNode(_prop[0]);
    }
  }

  confirmTypeChange(node, groupDeletion: boolean, value?: any) {
    const message = this.formConfirmationMessage(node, groupDeletion, true, value);
    // let _prop = [node, action, properties, fromCommand];
    const that = this;
    this.isLoading = false;
    this.propertyLoading = false;
    // this.loader.hide();
    let confirmationObj: Confirmation = {};

    if (this.hasReference) {
      confirmationObj = {
        message,
        acceptLabel: String(this.translate.instant('OK')),
        accept: () => {
          that.hasReference = false;
          return;
        },
        rejectVisible: false,
        acceptIcon: 'pi pi-check',
        rejectIcon: 'pi pi-times'
      };
    }
    const _self = this;
    this.zone.run(() => {
      confirmationObj.acceptIcon = 'pi pi-check';
      confirmationObj.rejectIcon = 'pi pi-times';
      _self.confirmationDialogService.confirm(confirmationObj);
    });
  }

  updateNodeOnDeletion(node) {
    this.showLoader = true;
    this.propertiesTasks.deleted.push(node.data.sid);
    this.debounceBatchSave();
  }

  deleteNode(node, setProp?: boolean) {
    let skipNodeDeletion = false;
    switch (node.type) {
      case nodeType.FIELD:
        if (node.data?.sysGen || node?.sysGen) {
          this.showMessage('error', "System generated fields can't be deleted");
          skipNodeDeletion = true;
        }
        break;
      case nodeType.TABLE:
        if (node.data?.sysGen || node?.sysGen) {
          this.showMessage('error', "System generated table can't be deleted");
          skipNodeDeletion = true;
        } else {
          this.tablesInfo = this.tablesInfo.filter((e) => e.data.sid !== node.data.sid);
          this.processTableInfos(true);
          this.removeChildNodes(node);
        }
        break;
    }
    if (skipNodeDeletion) {
      return;
    }
    if (node.data) {
      const referenceNode = node.getParent();
      this.removeTitles(node);
      this.updateNodeOnDeletion(node);
      node.remove();
      if (this.tablesInfo?.length === 0 && this.groupTitles?.length === 0) {
        this.dataModelDataOrder = [];
        this.initTree(this.dataModelDataOrder);
      }
      if (!setProp) {
        this.selectedNodeTitle = '';
        this.onActivateNode(null);
      }
    }
  }

  removeChildNodes(node) {
    while (node.hasChildren()) {
      node.children.forEach((child) => {
        //if (!child.data.sysGen)
        this.removeTitles(child);
        child.remove();
      });
    }
  }

  cancelPopup(form: FormGroup) {
    this.messages = [];
    if (form && form.dirty) {
      this.confirmationDialogService.confirm({
        message: this.translate.instant('You have unsaved changes. Are you sure you want to cancel ?'),
        header: 'Confirm',
        accept: () => {
          this.showPopup = false;
          this.showTblPopup = false;
          this.appForm = new FormGroup({
            name: new FormControl('', Validators.required)
          });
          this.tableForm = new FormGroup({
            name: new FormControl(''),
            type: new FormControl(DMConstants.TRANS_ONLY)
          });
        },
        reject: () => {
          console.log('rejected');
        }
      });
    } else {
      this.showPopup = false;
      this.showTblPopup = false;
      this.appForm = new FormGroup({
        name: new FormControl('', Validators.required)
      });
      this.tableForm = new FormGroup({
        name: new FormControl(''),
        type: new FormControl(DMConstants.TRANS_ONLY)
      });
    }
  }

  saveTable(titleToCheck, title, formObj) {
    const errorfields: any = [];
    if (
      this.appGlobalService.get('applicationType') === ApplicationTypes.MEMBER &&
      titleToCheck.toLowerCase() === 'application user'
    ) {
      this.showMessage('error', 'There is already an Application User table in the suite application');
      return;
    }
    if (this.tableTitles && this.tableTitles.includes(titleToCheck)) {
      errorfields.push(title);
      this.showMessage('error', 'Duplicate Table name not allowed');
      return;
    } else if (this.groupTitles?.includes(titleToCheck)) {
      errorfields.push(title);
      this.showMessage('error', 'Duplicate Table and Group name not allowed');
      return;
    }
    const id = uuidv4();
    const nodedata = {
      key: id,
      title: title,
      icon: DMConstants.TABLE_ICON,
      data: {
        sid: id,
        t_type: formObj.type
      },
      type: nodeType.TABLE,
      folder: true,
      isNewRec: true
    };
    if (formObj.type === DMConstants.TRANS_ANALY) {
      nodedata.data = { ...nodedata.data, ...{ t_aTableName: formObj.name } };
    }
    let newNode;
    // Guard against a transient state where the fancytree widget has been
    // destroyed by an in-flight initTree() but not yet re-initialised
    // (e.g. back-to-back firestore snapshots on a freshly-created app while
    // the Add Table dialog is open). Without this, getTree() returns
    // undefined, the next line throws, and tableTitles is left polluted -
    // causing a spurious "Duplicate Table name not allowed" on retry.
    const tree: any = $.ui.fancytree.getTree('#tree');
    if (!tree || typeof tree.getRootNode !== 'function') {
      this.showMessage('info', this.translate.instant('DATA_MODEL_STILL_LOADING'));
      return;
    }
    if (tree.getRootNode()?.children && tree.getRootNode()?.children[0].title?.toLowerCase() === 'no data.') {
      tree.getRootNode().removeChildren();
    }
    if (this.createTblPos) {
      // Ensure the node's parent is rendered before adding siblings to avoid insertBefore errors
      // Check if the node's parent has its ul element (DOM container for children)
      const parentNode = this.currNode?.parent;
      if (parentNode && !parentNode.ul) {
        parentNode.render(true);
      }
      newNode = this.currNode.addNode(
        { ...nodedata, ...{ groupId: this.currNode.parent ? this.currNode.parent?.data?.id : '' } },
        this.createTblPos
      );
    } else {
      let treeRootNode = tree.getRootNode();
      // Ensure the tree is rendered before adding children.
      // When all nodes are collapsed, FancyTree uses lazy rendering and
      // the DOM elements may not exist, causing insertBefore to fail.
      // Use tree.render() since root node doesn't have isRendered() method.
      if (!treeRootNode.ul) {
        tree.render(true);
      }
      newNode = treeRootNode.addChildren(nodedata);
    }
    // Only record the title once the node insertion has succeeded.
    if (this.tableTitles?.length) {
      this.tableTitles.push(titleToCheck);
    } else {
      this.tableTitles = [titleToCheck];
    }
    if (!this.fieldTitles[id]) {
      this.fieldTitles[id] = [];
    }
    const actNode = tree.getActiveNode();
    if (actNode) {
      this.store.dispatch(propertyActions.setPropertiesData({ propertiesData: null }));
      this.store.dispatch(propertyActions.setPropertiesValues({ propertiesValues: null }));
      actNode.setActive(false);
    }
    if (!this.propertiesTasks.added.length) {
      // if (this.utilService.getDeactivateRecords()) {
      //   newNode['deactivateRecords'] = this.utilService.getDeactivateRecords();
      // }
      this.addPropertiesTask(newNode);
      // newNode.setActive();
      if (!newNode.isExpanded()) {
        newNode.setExpanded();
      }
      this.showTblPopup = false;
      this.tableForm = new FormGroup({
        name: new FormControl(''),
        type: new FormControl(DMConstants.TRANS_ONLY)
      });
    }
  }

  createTable(event) {
    this.messages = [];
    const formObj = this.tableForm.getRawValue();
    if (!formObj.name) {
      this.messages.name = 'Table Name is Required';
      return;
    } else if (this.utilService.getRestrictedTableKeywords().includes(this.toLowerCaseKeywords(formObj.name))) {
      const translatedMessage = this.utilService.showKeywordWarning('Reserved Keyword', formObj.name);
      this.showMessage('error', translatedMessage);
      return;
    }
    const errorfields: any = [];

    // Validate table name
    const { title, titleToCheck } = this.utilService.validateTableName(formObj.name, this.messages, this.isRdbms);

    if (this.messages.name) {
      return;
    }

    if (formObj.type === DMConstants.TRANS_ANALY || formObj.type === DMConstants.ANALY_ONLY) {
      this.getTechStackData();
      this.isLoading = true;
      this.EventTracker.start('technologystackData');
      const techSubscription = this.store
        .select(technologystackData)
        .pipe(skip(1), take(1))
        .subscribe((techStackData: any) => {
          this.EventTracker.stop('technologystackData');
          console.log(`technologystackData : ${this.EventTracker.trackedEvents.technologystackData.duration}`);
          if (techStackData) {
            this.isLoading = false;
            if (!techStackData.analyticalDb) {
              errorfields.push(title);
              this.showMessage('error', this.translate.instant('SELECT_ANALYTICAL_DB'));
              return;
            }
            if (!techStackData.datasets || (techStackData.datasets && techStackData.datasets.length === 0)) {
              errorfields.push(title);
              this.showMessage('error', this.translate.instant('DATASETS_ERR'));
              return;
            }

            this.saveTable(titleToCheck, title, formObj);
          }
        });
      this.addToSubscriptionsList(techSubscription);
    } else {
      this.saveTable(titleToCheck, title, formObj);
    }
  }

  toLowerCaseKeywords(tableName: string): string {
    return tableName.toLowerCase().replace(/\s+/g, '');
  }

  getTechStackData() {
    if (this.appGlobalService.get('applicationType') !== utilEnum.ApplicationTypes.INDEPENDENT) {
      const params = {
        suiteid: this.appGlobalService.get('suiteId'),
        shareddbid: this.appGlobalService.get('sharedDbId')
      };
      this.store.dispatch(
        getTechnologyStackBySuiteId({
          apiConstants: ApiConstants.getTechnologyStackBySuiteId,
          params: params
        })
      );
    } else {
      this.store.dispatch(
        getTechnologyStack({
          apiConstants: ApiConstants.getTechnologyStackById,
          appId: this.appGlobalService.get('appId')
        })
      );
    }
  }
  createFields(event) {
    const formObj = this.appForm.getRawValue();
    this.showPopup = false;
    let fields: string[];
    if (!formObj.name) {
      this.showPopup = true;
      this.messages.addMultipleFields = this.translate.instant('ADD_FIELDS_EMPTY_ERROR');
      return;
    }
    const tree = $.ui.fancytree.getTree('#tree');
    let node: any = this.currNode || tree.getActiveNode();
    // If the node is a FIELD, navigate to its parent (TABLE or FIELDGROUP)
    if (node && node.type === nodeType.FIELD) {
      node = node.parent;
    }
    const name = formObj.name.trim();
    fields = name?.split(',')?.filter((f) => f.trim() !== '');
    if (fields.length > this.fieldMaxCount) {
      this.showMessage('error', this.translate.instant('MAX_NO_FIELDS', { maxNoFields: this.fieldMaxCount }));
      return;
    }
    const children: any = [];
    const errorfields: any = [];
    const that = this;
    let fieldsToSave = false;
    const errorMsgs: any = [];

    const lengthErrorFields: any = [];
    const keywordErrorFields: any = [];
    const systemFieldErrorFields: any = [];
    const sqlKeywordErrorFields: any = [];
    const duplicateFields: any = [];

    const alphanumericErrorFields: any = [];
    const newFieldTitlesInBatch: any = [];

    const validFldArr = fields.map((field) => field.trim().replace(/\s\s+/g, ' '));

    const fldArr = validFldArr.filter((title) => {
      if (!title) {
        return false;
      }
      if (title.length > this.titleMaxLength) {
        lengthErrorFields.push(title);
        return false;
      }
      const myRe = /^[a-zA-Z][a-zA-Z0-9 _]*$/;
      const array = myRe.exec(title);
      if (!array) {
        alphanumericErrorFields.push(title);
        return false;
      }

      const titleToCheck = title.toLowerCase();
      if (this.util.getRestrictedKeywords().includes(titleToCheck)) {
        keywordErrorFields.push(title);
        return false;
      }
      if (titleToCheck?.toLowerCase() === GlobalConstants.isActiveField.toLowerCase()) {
        errorfields.push(title);
        errorMsgs.push(this.translate.instant('RES_FLD_NAME'));
        return false;
      }
      if (this.systemFields.includes(titleToCheck)) {
        systemFieldErrorFields.push(title);
        return false;
      }
      if (this.isRdbms && this.util.getRestrictedSQLKeywords().includes(titleToCheck)) {
        sqlKeywordErrorFields.push(title);
        return false;
      }
      const parentKey = this.getParentTable(node)?.key;
      const tableFields = this.fieldTitles[parentKey];
      const namesToValidate = tableFields?.map((f: string) => f.toLowerCase().replace(/ /g, ''));
      if ((namesToValidate && namesToValidate.includes(titleToCheck.replace(/ /g, ''))) || newFieldTitlesInBatch.includes(titleToCheck.replace(/ /g, '')))
      {
        duplicateFields.push(title);
        return false;
      }
      newFieldTitlesInBatch.push(titleToCheck.replace(/ /g, ''));
      return true;

      /**create node object */
    });

    if (lengthErrorFields.length > 0) {
      errorMsgs.push(
        `${this.translate.instant('NAME_MAX_LENGTH_ERROR', { maxNo: this.titleMaxLength })}: ${lengthErrorFields.join(', ')}`
      );
    }

    if (alphanumericErrorFields.length > 0) {
      errorMsgs.push(
        this.translate.instant('ALPHANUMEREIC_CHARACTERS_ALLOWED_FIELDS', {
          titles: alphanumericErrorFields.join(', ')
        })
      );
    }

    if (keywordErrorFields.length > 0) {
      const translatedMessage = this.utilService.showKeywordWarning('Reserved Keyword', 'Field Name');
      errorMsgs.push(
        `${this.translate.instant('FIELD_IS_RESERVEDKEYWORD', { titles: keywordErrorFields.join(', ') })}. ${translatedMessage}`
      );
    }

    if (systemFieldErrorFields.length > 0) {
      errorMsgs.push(`${this.translate.instant('SYS_FLD_WARN')}: ${systemFieldErrorFields.join(', ')}`);
    }

    if (sqlKeywordErrorFields.length > 0) {
      const translatedMessage = this.utilService.showKeywordWarning('Sql Keyword', 'Field Name');
      errorMsgs.push(
        `${this.translate.instant('FIELD_IS_SQLKEYWORD', { titles: sqlKeywordErrorFields.join(', ') })}. ${translatedMessage}`
      );
    }

    if (duplicateFields.length > 0) {
      errorMsgs.push(this.translate.instant('FIELD_DUPLICATE', { titles: duplicateFields.join(', ') }));
    }

    if (errorMsgs.length > 0) {
      this.showMessage('error', errorMsgs.join('<br/>'));
      this.showPopup = true;
      return;
    }
    const pKey = this.getParentTable(node)?.key;
    if (this.fieldTitles[pKey]) {
      this.fieldTitles[pKey].push(...fldArr.map((e) => e.trim().toLowerCase()));
    } else {
      this.fieldTitles[pKey] = fldArr.map((e) => e.trim().toLowerCase());
    }
    this.appForm = new FormGroup({
      name: new FormControl('')
    });
    let preNodeId = null;
    if (node.hasChildren()) {
      const child = node.children;
      preNodeId = child[child.length - 1].data?.sid;
    }
    const fldProps: any = [];
    fldArr.forEach((e, i) => {
      const title = e.trim().replace(/\s\s+/g, ' ');
      const id = uuidv4();
      let tableId = node.type === nodeType.TABLE ? node.data.sid || node.data.id : '';
      const parentTable = this.getParentTable(node);
      if (!tableId) {
        tableId = parentTable.data.sid;
      }
      let nodeObj = {
        title: title,
        type: nodeType.FIELD,
        key: id,
        data: {
          sid: id,
          f_type: 'String',
          preNode: i > 0 ? children[i - 1].data.sid : preNodeId,
          pNode: node.data.sid,
          tabId: this.tabId,
          isNewRec: true
        }
      };
      this.getDefaultValues('String', nodeObj);
      const syncToAnalytical = parentTable?.data?.t_type === DMConstants.TRANS_ANALY;
      let fieldData = {
        ...nodeObj.data,
        name: nodeObj.title,
        aid: that.appId,
        f_tableId: tableId,
        f_hasAnalyticalSync: syncToAnalytical,
        type: nodeType.FIELD,
        orgId: this.orgId
      };
      if (this.formDefaultValues) {
        fieldData = { ...this.formDefaultValues, ...fieldData };
      }
      nodeObj = { ...nodeObj, ...{ data: { ...fieldData } } };
      children.push(nodeObj);
      fldProps.push(fieldData);
      fieldsToSave = true;
    });
    if (fieldsToSave) {
      node.addChildren(children);
      const added = [...this.propertiesTasks.added, ...fldProps];
      this.propertiesTasks = { ...this.propertiesTasks, ...{ added: added } };
      this.saveBatch();
      if (!node.isExpanded()) {
        node.setExpanded();
      }
    }
    if (errorfields.length > 0) {
      this.appForm.patchValue({ name: errorfields.join() });
      this.showPopup = true;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.setPageHeight();
  }

  setPageHeight() {
    const sidebarHt = $('#vbSidebar').outerHeight();
    const headerHt = $('#vbHeader').outerHeight() ?? 0;
    let pageHeaderHt = $('#vbPageHeader').outerHeight();
    pageHeaderHt = pageHeaderHt ? pageHeaderHt : 0;
    const windowHt = $(window).height() ?? 0;

    const pageHeight = windowHt - (headerHt + pageHeaderHt + 40);
    const div = this.splitter.el?.nativeElement?.querySelector('.p-splitter');
    if (div) {
      div.style.height = `${pageHeight}px`;
    }
  }

  GenerateRdbmsScript() {
    const rdbmsScriptApiConstants = ApiConstants.generateScript;
    const params = {
      appid: this.appGlobalService.get('appId')
    };
    this.store.dispatch(
      getScripts({
        rdbmsScriptApiConstants,
        params
      })
    );
  }

  formChildren(dataMap, nxtNodeMap, firstChildMap, node) {
    const output: any = [];
    //this.EventTracker.start('formChildren');
    //console.log(output);
    while (node) {
      if (firstChildMap.get(node.data.sid)) {
        let child = [];
        const ChildNode = dataMap.get(firstChildMap.get(node.data.sid));
        child = this.formChildren(dataMap, nxtNodeMap, firstChildMap, ChildNode);
        node = { ...node, ...{ children: child } };
      }
      output.push(node);
      const nsid = nxtNodeMap.get(node.data.sid);
      node = nsid ? dataMap.get(nsid) : null;
    }
    //console.log("output");
    //console.log(output);
    //this.EventTracker.stop('formChildren');
    //console.log("formChildren : " + this.EventTracker.trackedEvents["formChildren"]['duration']);
    return output;
  }

  formNode(obj) {
    const data = { ...obj };
    if (data.modifiedDate && data.modifiedDate.seconds) {
      data.modifiedDate = new Date(data.modifiedDate.seconds * 1000);
    }
    if (data.createdDate && data.createdDate.seconds) {
      data.createdDate = new Date(data.createdDate.seconds * 1000);
    }
    return {
      key: obj.sid,
      title: obj.name,
      type: obj.type,
      folder: obj.type !== nodeType.FIELD,
      data
    };
  }

  constructTree(structure) {
    this.EventTracker.start('constructTree');
    const dataMap = new Map();
    const firstChildMap = new Map();
    const nxtNodeMap = new Map();
    let curNode;

    // Pre-bind references for speed
    const groupTitles: string[] = (this.groupTitles = []);
    const tableTitles: string[] = (this.tableTitles = []);
    const tablesList: string[] = (this.tablesList = []);
    const tablesInfo: any[] = (this.tablesInfo = []);
    const tableMap = (this.tableMap = {});
    const tableFieldMap = (this.tableFieldMap = {});
    const fldTypMap = (this.fldTypMap = {});
    const fieldTitles = (this.fieldTitles = this.fieldTitles || {});
    const fieldGroupTitles = (this.fieldGroupTitles = this.fieldGroupTitles || {});

    for (let i = 0; i < structure.length; i++) {
      const obj = structure[i];
      const sid = obj.sid;
      const node = this.formNode(obj);
      dataMap.set(obj.sid, node);
      if (!obj.preNode) {
        if (!obj.pNode) {
          curNode = node;
          curNode.expanded = true;
        }
        firstChildMap.set(obj.pNode, obj.sid);
      }
      if (obj.preNode) {
        nxtNodeMap.set(obj.preNode, node.data.sid);
      }

      // Precompute clean title once
      const raw = obj.name || '';
      const title = raw.trim().replace(/\s\s+/g, ' ').toLowerCase();

      // Faster switch with direct assignment
      switch (obj.type) {
        case nodeType.GROUP:
          groupTitles.push(title);
          tableMap[sid] = obj.name;
          break;

        case nodeType.TABLE:
          tableTitles.push(title);
          tablesList.push(obj.name);
          tablesInfo.push(node);
          tableMap[sid] = obj.name;
          if (!fieldTitles[sid]) fieldTitles[sid] = [];
          break;

        case nodeType.FIELD: {
          const tId = obj.f_tableId;
          if (!fieldTitles[tId]) fieldTitles[tId] = [];
          fieldTitles[tId].push(title);
          tableFieldMap[sid] = obj.name;
          fldTypMap[sid] = obj.f_type;
          break;
        }
        case nodeType.FIELDGROUP: {
          const gId = obj.fg_tableId;
          if (!fieldGroupTitles[gId]) fieldGroupTitles[gId] = [];
          fieldGroupTitles[gId].push(title);
          tableFieldMap[sid] = obj.name;
          break;
        }
      }
    }
    this.loadedAppId = this.appId;
    this.dataModelDataOrder = this.formChildren(dataMap, nxtNodeMap, firstChildMap, curNode);
    const idMaps = {
      fieldsMap: this.tableFieldMap,
      tablesMap: this.tableMap
    };
    this.store.dispatch(setIdMapping({ idMaps: idMaps }));
    this.getAppUser();
    this.processTableInfos(true);
    this.EventTracker.stop('constructTree');
    console.log(`constructTree : ${this.EventTracker.trackedEvents.constructTree.duration}`);
    //return output;
  }

  updatetitle(node, data) {
    const title = data.name.toLowerCase().replace(/\s\s+/g, ' ');
    const oldtitleToCheck = node.title.toLowerCase().replace(/\s\s+/g, ' ');
    switch (node.type) {
      case nodeType.GROUP:
        if (this.groupTitles.includes(oldtitleToCheck)) {
          const i = this.groupTitles.indexOf(oldtitleToCheck);
          this.groupTitles[i] = title;
        } else {
          this.groupTitles.push(title);
        }
        this.tableMap = { ...this.tableMap, ...{ [data?.sid]: data.name } };
        break;
      case nodeType.TABLE:
        if (this.tableTitles.includes(oldtitleToCheck)) {
          const i = this.tableTitles.indexOf(oldtitleToCheck);
          this.tableTitles[i] = title;
        } else {
          this.tableTitles.push(title);
        }
        this.tableMap = { ...this.tableMap, ...{ [data?.sid]: data.name } };
        // Update normalTables with new name and dispatch to store
        if (this.normalTables) {
          const tableIndex = this.normalTables.findIndex((t) => t.sid === data.sid);
          if (tableIndex > -1) {
            this.normalTables = this.normalTables.map((t) => (t.sid === data.sid ? { ...t, name: data.name } : t));
            this.store.dispatch(propertyActions.setTableNames({ tableNames: this.normalTables }));
          }
        }
        break;
      case nodeType.FIELDGROUP:
        const parentKeysid = data.fg_tableId;
        const fieldGroups = this.fieldGroupTitles[parentKeysid];
        if (fieldGroups) {
          if (fieldGroups.includes(oldtitleToCheck)) {
            const i = fieldGroups.indexOf(oldtitleToCheck);
            this.fieldGroupTitles[parentKeysid][i] = title;
          } else {
            this.fieldGroupTitles[parentKeysid].push(title);
          }
        } else {
          this.fieldGroupTitles[parentKeysid] = [title];
        }
        this.tableFieldMap = { ...this.tableFieldMap, ...{ [data?.sid]: data.name } };
        break;
      case nodeType.FIELD:
        const parentKey = data.f_tableId;
        const tableFields = this.fieldTitles[parentKey];
        if (tableFields) {
          if (tableFields.includes(oldtitleToCheck)) {
            const i = tableFields.indexOf(oldtitleToCheck);
            this.fieldTitles[parentKey][i] = title;
          } else {
            this.fieldTitles[parentKey].push(title);
          }
        } else {
          this.fieldTitles[parentKey] = [title];
        }
        this.tableFieldMap = { ...this.tableFieldMap, ...{ [data?.sid]: data.name } };
        break;
    }
    const idMaps = {
      fieldsMap: this.tableFieldMap,
      tablesMap: this.tableMap
    };
    this.store.dispatch(
      setIdMapping({
        idMaps
      })
    );
  }

  updatePickuplistOnNewFld(data) {
    if (data.type === nodeType.FIELD && this.rowid === data.f_tableId) {
      if (this.pickList) {
        const plist = cloneDeep(this.pickList);
        let noImgFAFields = this.pickList?.noImgFAFields;
        let fields = this.pickList?.fields;
        let primaryFields = this.pickList?.primaryFields;
        let lookupFields = this.pickList?.lookupFields;
        let allFields = this.pickList?.allFields;
        let indexFields = this.pickList?.indexFields || [];
        // check whether field is already available and update
        if (allFields && !allFields.find((f) => f.sid === data.sid)) {
          if (
            (data.f_type.toLowerCase() === 'number' ||
              data.f_type.toLowerCase() === 'string' ||
              data.f_type.toLowerCase() === 'dropdown' ||
              data.f_type.toLowerCase() === 'lookup' ||
              data.f_type.toLowerCase() === 'datetime' ||
              data.f_type.toLowerCase() === 'checkboxgroup' ||
              data.f_type.toLowerCase() === 'currency' ||
              data.f_type.toLowerCase() === 'date' ||
              data.f_type.toLowerCase() === 'double' ||
              data.f_type.toLowerCase() === 'email' ||
              data.f_type.toLowerCase() === 'json' ||
              data.f_type.toLowerCase() === 'radio' ||
              data.f_type.toLowerCase() === 'color') &&
            !data.f_hasMultiVal &&
            !data.f_transientField &&
            data.name.toLowerCase() !== 'id'
          ) {
            primaryFields = [...primaryFields, { sid: data.sid, name: data.name }];
          }
        }
        if (data.f_searchable !== 'no') {
          fields = [...fields, { sid: data.sid, name: data.name }];
        }
        if (
          data.f_searchable !== 'no' &&
          !data.f_hasMultiVal &&
          data.f_type.toLowerCase() !== 'image carousel' &&
          data.f_type.toLowerCase() !== 'file attachments' &&
          data.f_type.toLowerCase() !== 'complex datatype' &&
          !data.f_transientField
        ) {
          lookupFields = [...lookupFields, { sid: data.sid, name: data.name }];
        }
        if (
          data.f_type.toLowerCase() !== 'image carousel' &&
          data.f_type.toLowerCase() !== 'file attachments' &&
          data.f_type.toLowerCase() !== 'checkboxgroup' &&
          data.f_type.toLowerCase() !== 'complex datatype' &&
          !data.f_sysF
        ) {
          noImgFAFields = [...noImgFAFields, { sid: data.sid, name: data.name }];
        }
        if (
          (data.f_type.toLowerCase() !== 'image carousel' &&
            data.f_type.toLowerCase() !== 'file attachments' &&
            data.f_type.toLowerCase() !== 'checkboxgroup' &&
            data.f_type.toLowerCase() !== 'complex datatype' &&
            data.name.toLowerCase() === 'sid') ||
          !data.f_sysF
        ) {
          if (!indexFields.find((f) => f.sid === data.sid)) {
            indexFields = [...indexFields, { sid: data.sid, name: data.name }];
          }
        }
        allFields = [...allFields, { sid: data.sid, name: data.name }];
        plist.noImgFAFields = noImgFAFields;
        plist.fields = fields;
        plist.primaryFields = [...primaryFields];
        plist.lookupFields = lookupFields;
        plist.allFields = allFields;
        plist.indexFields = indexFields;
        if (this.dataModelFlds) {
          this.dataModelFlds = [...this.dataModelFlds, data];
        }
        this.store.dispatch(propertyActions.setPickupProperties({ picklist: plist }));
        this.store.dispatch(setFieldsForTable({ tblFields: this.dataModelFlds }));
      }
    }
  }

  appendNode(data) {
    if (data.modifiedDate && data.modifiedDate.seconds) {
      data.modifiedDate = new Date(data.modifiedDate.seconds * 1000);
    }
    if (data.createdDate && data.createdDate.seconds) {
      data.createdDate = new Date(data.createdDate.seconds * 1000);
    }
    const tree = $.ui.fancytree.getTree('#tree');

    // Check if node already exists - if so, move it instead of adding a duplicate
    const existingNode = tree.getNodeByKey(data.sid);
    if (existingNode) {
      this.moveNode(existingNode, data);
      return;
    }

    const node = this.formNode(data);
    const sid = node.data.preNode ? node.data.preNode : node.data.pNode;
    const appendNode = tree.getNodeByKey(sid);
    if (appendNode) {
      if (node.data.preNode) {
        appendNode.addNode(node, 'after');
        if (!appendNode.isVisible()) {
          appendNode.getParent().setExpanded(false);
        }
      } else if (node.data.pNode) {
        appendNode.addNode(node, 'over');
      }
    }
    this.updatetitle(node, data);
    if (node.type === nodeType.TABLE) {
      this.addNewTableToTableList(node);
    }
  }

  moveNode(node, data, added?: boolean) {
    const tree = $.ui.fancytree.getTree('#tree');
    const oldParent = node.parent;
    if (data.preNode) {
      const preNode = tree.getNodeByKey(data.preNode);
      if (!preNode || preNode.key === node.key) {
        return;
      }
      // node.moveTo(preNode, 'after');
      if (added) {
        const movableNodes = [node];
        // Move below nodes also on moving current node, because the order mismatch will come (Add multiple fields)
        let nNode = node.getNextSibling();
        let sid = node.data.sid;
        while (nNode) {
          if (nNode.data.preNode === sid) {
            movableNodes.push(nNode);
            sid = nNode.data.sid;
            nNode = nNode.getNextSibling();
          } else {
            nNode = null;
          }
        }
        if (movableNodes.length) {
          movableNodes.forEach((n) => {
            const preNode = tree.getNodeByKey(n.data.preNode);
            if (preNode && preNode.key !== n.key) {
              n.moveTo(preNode, 'after');
            }
          });
        }
      } else {
        node.moveTo(preNode, 'after');
        if (node.isEditing() && node.title !== data.name) {
          this.updatetitle(node, data);
          node.title = data.name;
          this.curNodeData.input.val(data.name);
          $(this.curNodeData.input).blur();
          this.zone.run(() => {
            this.showMessage('info', `${this.curNodeData.orgTitle} is updated to ${data.name} by different user.`);
          });
        }
      }
    } else if (data.pNode) {
      const parentNode = tree.getNodeByKey(data.pNode);
      if (parentNode && parentNode?.hasChildren()) {
        const firstChild = parentNode.children[0];
        if (firstChild && firstChild.key !== node.key) {
          node.moveTo(firstChild, 'before');
        } else if (node.parent !== parentNode) {
          node.moveTo(parentNode, 'over');
        }
      } else if (parentNode && node.parent !== parentNode) {
        node.moveTo(parentNode, 'over');
      }
    } else {
      // if a node moved to the top
      const rootNode = tree.getRootNode();
      if (rootNode && rootNode.hasChildren()) {
        const firstChild = rootNode.children[0];
        if (firstChild && firstChild.key !== node.key) {
          node.moveTo(firstChild, 'before');
        }
      }
    }
    // Re-render node when node is moved across parents
    if (node.parent !== oldParent) {
      node.render(true);
    }
  }

  modifyNode(curnode, data) {
    if (curnode.title !== data.name && !curnode.isEditing()) {
      this.updatetitle(curnode, data);
      curnode.title = data.name;
      curnode.setTitle(data.name);
    }
    if (curnode.data.f_type !== data.f_type) {
      const $tdList = $(curnode.tr).find('>td');
      let fieldName;
      if (data.f_type === DMConstants.COMPLEX_FIELD_TYPE) {
        const id = data.f_cDataTypeId;
        const fieldValue = filter(this.complexTables, (e: any) => e.sid === id);
        fieldName = fieldValue[0] ? fieldValue[0].name : '';
      } else {
        const fieldValue = filter(this.dataTypes, (e: any) => e.value === data.f_type);
        fieldName = fieldValue[0] ? fieldValue[0].name : '';
      }
      console.log($tdList.eq(3));
      $tdList.eq(3).find('#data-field-type').text(fieldName);
    }
    if (this.rowid === data.sid) {
      if (data.type === nodeType.TABLE) {
        if (curnode.data.t_type !== data.t_type) {
          curnode.data = { ...curnode.data, ...data };
          this.onActivateNode(curnode);
        }
      } else if (data.type === nodeType.FIELD) {
        if (
          curnode.data.f_type !== data.f_type ||
          ((curnode.data.f_lookupTo || data.f_lookupTo) && curnode.data.f_lookupTo !== data.f_lookupTo)
        ) {
          curnode.data = { ...curnode.data, ...data };
          this.onActivateNode(curnode);
        }
      }
      // since allowed values is not supported in concurrency, that is explicity not included
      const allowedValTypes = ['dropdown', 'checkboxgroup', 'radiobutton'];
      if (
        !(
          data.type === nodeType.FIELD &&
          allowedValTypes.includes(data.f_type.toLowerCase()) &&
          data.tabId === this.tabId &&
          data.f_aValues !== curnode.data.f_aValues
        )
      ) {
        this.store.dispatch(
          propertyActions.setPropertiesValues({ propertiesValues: { ...data, ...{ typeChange: true } } })
        );
      }
    }
    curnode.data = { ...curnode.data, ...data };

    // Update QV error indicator icon when qvIsError or table type changes from Firestore
    curnode.renderTitle();
  }

  updateNodeFromFS(data, action) {
    delete data.actionType;
    const tree = $.ui.fancytree.getTree('#tree');

    // If tree is not available (e.g., when on a different view like query string component),
    // update only the internal data structures without tree UI operations
    if (!tree) {
      this.updateDataModelWithoutTree(data, action);
      return;
    }
    switch (action) {
      case 'added':
        if (data.tabId !== this.tabId) {
          const activeNode = tree.getActiveNode();
          let rect;
          if (activeNode && $(activeNode.tr)[0]) {
            rect = $(activeNode.tr)[0].getBoundingClientRect();
          }
          this.appendNode(data);
          if (activeNode) {
            activeNode.scrollIntoView();
          }
        } else {
          const addedNode = tree.getNodeByKey(data.sid);
          const prevNode = addedNode.getPrevSibling();
          if (addedNode.data.preNode !== data.preNode || (prevNode && prevNode.data.sid !== data.preNode)) {
            this.moveNode(addedNode, data, true);
          }
          if (data.modifiedDate && data.modifiedDate.seconds) {
            data.modifiedDate = new Date(data.modifiedDate.seconds * 1000);
          }
          addedNode.data = { ...addedNode.data, ...data };
        }
        this.updatePickuplistOnNewFld(data);
        break;
      case 'modified':
        const curnode = tree?.getNodeByKey(data.sid);
        if (curnode) {
          const prevNode = curnode.getPrevSibling();
          if (data.modifiedDate && data.modifiedDate.seconds) {
            data.modifiedDate = new Date(data.modifiedDate.seconds * 1000);
          }
          if (data.createdDate && data.createdDate.seconds) {
            data.createdDate = new Date(data.createdDate.seconds * 1000);
          }
          if (
            curnode.data.preNode !== data.preNode ||
            curnode.data.pNode !== data.pNode ||
            (prevNode && prevNode.data.sid !== data.preNode)
          ) {
            this.moveNode(curnode, data);
            // update the prenode/ pnode to properties pane if it is active node
            if (this.rowid === data.sid) {
              this.store.dispatch(
                propertyActions.setPropertiesValues({ propertiesValues: { ...data, ...{ typeChange: true } } })
              );
            }
            curnode.data = data;
          } else if (data.modifiedDate && curnode.data.modifiedDate) {
            const date1 = new Date(data.modifiedDate).getTime();
            const date2 = new Date(curnode.data.modifiedDate).getTime();
            if (date1 >= date2) {
              this.modifyNode(curnode, data);
            }
          } else {
            this.modifyNode(curnode, data);
          }
        }
        break;
      case 'removed':
        const curnode1 = tree?.getNodeByKey(data.sid);
        if (this.rowid === data.sid) {
          this.store.dispatch(propertyActions.setPropertiesData({ propertiesData: null }));
          this.store.dispatch(propertyActions.setPropertiesValues({ propertiesValues: null }));
        }
        if (curnode1) {
          this.removeTitles(curnode1);
          if (data.type === nodeType.TABLE) {
            this.tablesInfo = this.tablesInfo.filter((e) => e.data.sid !== curnode1.data.sid);
            this.processTableInfos(true);
          }
          // To check whether the node is in edit mode
          if (curnode1.isEditing()) {
            this.showMessage(
              'info',
              `The Editing ${this.curNodeData.node.type} Node was removed by ${this.appGlobalService?.get('appmetaInfo')[data.modifiedBy]}.`
            );
            this.curNodeData.input.val('');
            $(this.curNodeData.input).blur();
          }
          curnode1.remove();
        }
        break;
    }
  }

  /**
   * Updates internal data structures when the tree UI is not available.
   * This is called when Firestore listener receives updates while on a different view (e.g., query string component).
   * The fsData is already updated by the caller, so we only need to update auxiliary data structures.
   */
  syncDataModelDataOrderFromFsData() {
    if (!this.fsData) return;
    const dataMap = new Map();
    const firstChildMap = new Map();
    const nxtNodeMap = new Map();
    let curNode;

    for (let i = 0; i < this.fsData.length; i++) {
      const obj = this.fsData[i];
      const node = this.formNode(obj);
      dataMap.set(obj.sid, node);
      if (!obj.preNode) {
        if (!obj.pNode) {
          curNode = node;
          curNode.expanded = true;
        }
        firstChildMap.set(obj.pNode, obj.sid);
      }
      if (obj.preNode) {
        nxtNodeMap.set(obj.preNode, node.data.sid);
      }
    }

    this.dataModelDataOrder = this.formChildren(dataMap, nxtNodeMap, firstChildMap, curNode);
  }

  updateDataModelWithoutTree(data, action) {
    // Convert timestamps if needed
    if (data.modifiedDate && data.modifiedDate.seconds) {
      data.modifiedDate = new Date(data.modifiedDate.seconds * 1000);
    }
    if (data.createdDate && data.createdDate.seconds) {
      data.createdDate = new Date(data.createdDate.seconds * 1000);
    }

    switch (action) {
      case 'added':
        // Update title arrays and maps based on data type
        this.updateTitleFromData(data);
        // Update pickup list if applicable
        this.updatePickuplistOnNewFld(data);
        // Update tables info if it's a table
        if (data.type === nodeType.TABLE) {
          this.addTableToInfoFromData(data);
        }
        break;

      case 'modified':
        // Update title arrays and maps based on data type
        this.updateTitleFromData(data);
        // Update properties pane if this is the active node
        if (this.rowid === data.sid) {
          this.store.dispatch(
            propertyActions.setPropertiesValues({ propertiesValues: { ...data, ...{ typeChange: true } } })
          );
        }
        break;

      case 'removed':
        // Clear properties pane if this is the active node
        if (this.rowid === data.sid) {
          this.store.dispatch(propertyActions.setPropertiesData({ propertiesData: null }));
          this.store.dispatch(propertyActions.setPropertiesValues({ propertiesValues: null }));
        }
        // Remove from title arrays
        this.removeTitleFromData(data);
        // Remove from tablesInfo if it's a table
        if (data.type === nodeType.TABLE) {
          this.tablesInfo = this.tablesInfo.filter((e) => e.data?.sid !== data.sid);
          this.processTableInfos(true);
        }
        break;
    }
  }

  /**
   * Updates title arrays and maps from data object (used when tree is not available)
   */
  updateTitleFromData(data) {
    const title = data.name?.toLowerCase().replace(/\s\s+/g, ' ');
    if (!title) return;

    switch (data.type) {
      case nodeType.GROUP:
        if (!this.groupTitles.includes(title)) {
          this.groupTitles.push(title);
        }
        this.tableMap = { ...this.tableMap, [data.sid]: data.name };
        break;

      case nodeType.TABLE:
        if (!this.tableTitles.includes(title)) {
          this.tableTitles.push(title);
        }
        this.tableMap = { ...this.tableMap, [data.sid]: data.name };
        if (!this.fieldTitles[data.sid]) {
          this.fieldTitles[data.sid] = [];
        }
        break;

      case nodeType.FIELDGROUP:
        const fgParentKey = data.fg_tableId;
        if (fgParentKey) {
          if (!this.fieldGroupTitles[fgParentKey]) {
            this.fieldGroupTitles[fgParentKey] = [];
          }
          if (!this.fieldGroupTitles[fgParentKey].includes(title)) {
            this.fieldGroupTitles[fgParentKey].push(title);
          }
        }
        this.tableFieldMap = { ...this.tableFieldMap, [data.sid]: data.name };
        break;

      case nodeType.FIELD:
        const fParentKey = data.f_tableId;
        if (fParentKey) {
          if (!this.fieldTitles[fParentKey]) {
            this.fieldTitles[fParentKey] = [];
          }
          if (!this.fieldTitles[fParentKey].includes(title)) {
            this.fieldTitles[fParentKey].push(title);
          }
        }
        this.tableFieldMap = { ...this.tableFieldMap, [data.sid]: data.name };
        break;
    }

    // Update ID mappings in store
    const idMaps = {
      fieldsMap: this.tableFieldMap,
      tablesMap: this.tableMap
    };
    this.store.dispatch(setIdMapping({ idMaps }));
  }

  /**
   * Removes title from arrays (used when tree is not available)
   */
  removeTitleFromData(data) {
    const title = data.name?.toLowerCase().trim();
    if (!title) return;

    switch (data.type) {
      case nodeType.GROUP:
        const groupIndex = this.groupTitles.indexOf(title);
        if (groupIndex > -1) {
          this.groupTitles.splice(groupIndex, 1);
        }
        break;

      case nodeType.TABLE:
        const tableIndex = this.tableTitles.indexOf(title);
        if (tableIndex > -1) {
          this.tableTitles.splice(tableIndex, 1);
        }
        break;

      case nodeType.FIELDGROUP:
        const fgParentKey = data.fg_tableId;
        if (fgParentKey && this.fieldGroupTitles[fgParentKey]) {
          const fgIndex = this.fieldGroupTitles[fgParentKey].indexOf(title);
          if (fgIndex > -1) {
            this.fieldGroupTitles[fgParentKey].splice(fgIndex, 1);
          }
        }
        break;

      case nodeType.FIELD:
        const fParentKey = data.f_tableId;
        if (fParentKey && this.fieldTitles[fParentKey]) {
          const fIndex = this.fieldTitles[fParentKey].indexOf(title);
          if (fIndex > -1) {
            this.fieldTitles[fParentKey].splice(fIndex, 1);
          }
        }
        break;
    }
  }

  /**
   * Adds table to tablesInfo from data object (used when tree is not available)
   */
  addTableToInfoFromData(data) {
    // Check if table already exists in tablesInfo
    const exists = this.tablesInfo.some((t) => t.data?.sid === data.sid);
    if (!exists) {
      const nodeData = {
        key: data.sid,
        title: data.name,
        type: data.type,
        data: { ...data }
      };
      this.tablesInfo.push(nodeData);
      this.processTableInfos(true);
    }
  }

  orderElementsFromFS(dataMap, nxtNodeMap, firstChildMap, node, orderedNodes) {
    while (node) {
      orderedNodes.push(node);
      if (node.type !== nodeType.FIELD && firstChildMap.get(node.sid)) {
        const ChildNode = dataMap.get(firstChildMap.get(node.sid));
        this.orderElementsFromFS(dataMap, nxtNodeMap, firstChildMap, ChildNode, orderedNodes);
      }
      const nSid = nxtNodeMap.get(node.sid);
      node = nSid ? dataMap.get(nSid) : null;
    }
  }
  orderElements(data) {
    const dataMap = new Map();
    const firstChildMap = new Map();
    const nxtNodeMap = new Map();
    let orderedNodes: any = [];
    const nodes = data.filter((dt) => {
      dataMap.set(dt.sid, dt);
      if (!dt.preNode) {
        firstChildMap.set(dt.pNode, dt.sid);
      }
      const sepNode = data.find((d) => dt.preNode === d.sid || (dt.pNode === d.sid && !dt.preNode));
      if (dt.preNode) {
        nxtNodeMap.set(dt.preNode, dt.sid);
      }
      return !sepNode || (dt.recDeleted ? this.isLatestDeletedRec(dt) : false);
    });
    if (nodes.length !== data.length) {
      nodes.forEach((n) => {
        this.orderElementsFromFS(dataMap, nxtNodeMap, firstChildMap, n, orderedNodes);
      });
    } else {
      orderedNodes = [...data];
    }
    return orderedNodes;
  }

  isLatestDeletedRec(dt: any): boolean {
    const tree = $.ui.fancytree.getTree('#tree');
    return !!tree.getNodeByKey(dt.sid);
  }

  getAppUser() {
    this.appUserTableId = this.appGlobalService.get('appTableId');
    if (!this.appUserTableId) {
      this.appUserTableId = Object.keys(this.tableMap).find((key) => this.tableMap[key] === 'Application User');
    }
    this.getFields(this.appUserTableId);
  }

  async fetchInitialDataModelData() {
    if (this.dataModelService.areDataModelsAvailable()) {
      let datamodels = this.dataModelService.getDataModels();

      this.fsData = datamodels;
      this.initialFetchStartTime = this.dataModelService.getLastUpdatedTime() ?? new Date();
    } else {
      let batchSize = GlobalConstants.apiCallBatchSize;
      this.fsData = [];

      try {
        // Initiate datamodel count asyncronously
        let dataModelCount;
        firstValueFrom(this.bs.get(ApiConstants.getApplicationDataModelCount)).then((count) => {
          dataModelCount = count;
        });

        // Start the first api to fetch the datamodel documents
        let firstBatchApiCall = await firstValueFrom(
          this.bs.post(ApiConstants.getApplicationDataModel, {
            start: 0,
            length: batchSize
          })
        );

        // push the first set of results
        for (let i = 0; i < firstBatchApiCall['results']?.length; i++) {
          this.fsData.push(firstBatchApiCall['results'][i]);
        }

        // check if the result size is equal to batch size. if it is equal, there might be more records.
        if (firstBatchApiCall && firstBatchApiCall['results']?.length === batchSize) {
          // make further api calls, considering count is fetched
          if (!dataModelCount && typeof dataModelCount !== 'number') {
            console.error('Error/Still fetching datamodel count.');
          }

          if (dataModelCount && parseInt(dataModelCount as string) > batchSize) {
            let dataModelFetchSubs$: Observable<any>[] = [];

            for (let i = 1; i < Math.ceil(parseInt(dataModelCount as string) / batchSize); i++) {
              dataModelFetchSubs$.push(
                this.bs.post(ApiConstants.getApplicationDataModel, {
                  start: i * batchSize,
                  length: batchSize
                })
              );
            }

            let dataModelResponses = await firstValueFrom(forkJoin(dataModelFetchSubs$));

            dataModelResponses.forEach((res: any) => {
              res?.results?.forEach((rec) => {
                this.fsData.push(rec);
              });
            });
          }
        }
      } catch (error) {
        console.error('Error fetching initial data model data:', error);
      }
    }
  }

  /**
   *
   * @param queryObject Query object to fetch updated data from Firestore
   * This method sets up a Firestore listener to fetch real-time updates for the application data model.
   * It filters out metadata-only changes and processes added, modified, and removed records accordingly.
   * The method ensures that the local data model is kept in sync with the Firestore data.
   * It also tracks the duration of the data fetch operation for performance monitoring.
   * @returns void
   */
  getUpdatedDataModelData(queryObject: any) {
    this.EventTracker.start('ApplicationDataModel');
    let isInitialFetch = true;

    try {
      const fsDataSub = this.fsService
        .fireService(queryObject)
        .pipe(
          map((actions: any[]) =>
            actions.filter((a) => {
              if (a.type === 'added' || a.type === 'removed') {
                return true; // Always keep these
              }
              // Keep 'modified' only if it's not metadata-only
              return !(a.payload.doc.metadata.fromCache || a.payload.doc.metadata.hasPendingWrites);
            })
          )
        )
        .subscribe(
          (res) => {
            this.EventTracker.stop('ApplicationDataModel');
            console.log(`ApplicationDataModel: ${this.EventTracker.trackedEvents.ApplicationDataModel.duration}`);

            if (isInitialFetch) {
              for (let i = 0; i < res.length; i++) {
                let rec = res[i].payload.doc.data();
                let index = this.fsData.findIndex((d) => d.sid === rec.sid);

                if (res[i].type === 'added') {
                  if (index === -1) {
                    this.fsData.push(rec);
                  } else {
                    if (rec.recDeleted) {
                      this.fsData.splice(index, 1);
                    } else {
                      this.fsData[index] = rec;
                    }
                  }
                } else if (res[i].type === 'modified') {
                  if (index > -1) {
                    if (rec.recDeleted) {
                      this.fsData.splice(index, 1);
                    } else {
                      this.fsData[index] = rec;
                    }
                  }
                } else if (res[i].type === 'removed') {
                  if (index > -1) {
                    this.fsData.splice(index, 1);
                  }
                }
              }

              isInitialFetch = false;
              this.constructTree(this.fsData);
              this.initTree(this.dataModelDataOrder);
              this.isLoading = false;
            } else {
              // Handle updates after initial load
              const newData: any = [];

              const data = res
                .filter(
                  (obj) =>
                    (obj.payload.doc.exists && !this.isUnique(obj.payload.doc.data(), this.fsData)) ||
                    obj.type === 'added' ||
                    obj.type === 'modified'
                )
                .map((dt) => {
                  const rec = dt.payload.doc.data();
                  const isNewData = dt.type === 'added' && !this.fsData.find((d) => d.sid === rec.sid);

                  rec.actionType = dt.type;

                  // All the modified documents will be received as added documents when received for the first time in the listener.
                  // If the document of type added is available in the fsdata, this means tree contains this received data.
                  // The received data is the new updated data (type is modified)
                  if (dt.type === 'added') {
                    if (this.fsData.find((d) => d.sid === rec.sid)) {
                      rec.actionType = 'modified';
                    }
                  }

                  if (rec.recDeleted) {
                    rec.actionType = 'removed';
                  }

                  if (isNewData) {
                    newData.push(rec);
                  }

                  return rec;
                });

              for (let i = 0; i < data.length; i++) {
                const dt = data[i];
                if (dt.actionType === 'modified') {
                  const existingIndex = this.fsData.findIndex((d) => d.sid === dt.sid);
                  if (existingIndex > -1) {
                    this.fsData[existingIndex] = data[i];
                  }
                }
                if (dt.actionType === 'removed') {
                  const existingIndex = this.fsData.findIndex((d) => d.sid === dt.sid);
                  if (existingIndex > -1) {
                    this.fsData.splice(existingIndex, 1);
                  }
                }
              }

              if (data.length > 0 || newData.length > 0) {
                this.fsData = newData.length > 0 ? [...this.fsData, ...newData] : this.mergeFsData(data, this.fsData);
                const orderedData = this.orderElements(data);
                orderedData.forEach((obj) => {
                  this.updateNodeFromFS(obj, obj.actionType);
                });
                // Synchronize dataModelDataOrder structure for the visualizer components
                this.syncDataModelDataOrderFromFsData();
              }
            }
          },
          (error) => {
            console.error(error);
          }
        );
      this.unSubList.push(fsDataSub);
      this.dataMlSub.push(fsDataSub);
    } catch (e) {
      console.log(e);
    }
  }

  async getDataModelData() {
    this.isLoading = true;
    this.initialFetchStartTime = new Date();
    if (this.appId !== this.loadedAppId) {
      this.resetDataModelCaches();
    }
    await this.fetchInitialDataModelData();

    const version = this.appGlobalService.get('appVersion');
    const queryObject = {
      collectionName: `ApplicationDataModel_${version}`,
      filter: [
        {
          field: 'aid',
          operator: '==',
          value: this.appGlobalService.get('appId')
        },
        {
          field: 'modifiedDate',
          operator: '>=',
          value: this.initialFetchStartTime
        }
      ]
    };
    this.unsubscribeListener();
    this.getUpdatedDataModelData(queryObject);
  }

  private resetDataModelCaches() {
    this.groupTitles = [];
    this.tableTitles = [];
    this.tablesList = [];
    this.tablesInfo = [];
    this.tableMap = {};
    this.tableFieldMap = {};
    this.fldTypMap = {};
    this.fieldTitles = {};
    this.fieldGroupTitles = {};
    this.fsData = [];
  }

  loadTableData() {
    // this.isLoading = true;
    // TODO: get Tree object based on app id
    const apiConstants: any = {
      initialProperties: {
        ...ApiConstants.getDatamodelProperties
      }
    };
    this.store.dispatch(getDataModel(apiConstants));
  }

  getTreeStructure() {
    this.loadTableData();
    this.EventTracker.start('getTreeStructure');
    const dataSub = this.data$.subscribe((data) => {
      this.EventTracker.stop('getTreeStructure');
      console.log(`getTreeStructure : ${this.EventTracker.trackedEvents.getTreeStructure.duration}`);
      this.initialFieldProperties = data?.initialProperties?.fieldProperties;
      this.initialTableProperties = data?.initialProperties?.tableProperties;
      if (data?.initialProperties) {
        this.allProps = data.initialProperties;
        if (this.allProps?.field) {
          const field = this.allProps.field;
          this.allProps = { ...this.allProps, ...field };
        }
        if (dataSub) {
          dataSub.unsubscribe();
        }
      }
    });
  }

  ngAfterViewInit(): void {
    /**
     * Set splitter height
     */
    this.setPageHeight();
  }

  loadTableInfoForType() {
    const _self = this;
    _self.types = [..._self.dataTypes];
    this.complexTypes = [];
    this.complexTables.forEach((e) => {
      const obj = {
        name: e.name,
        value: e.sid,
        class: 'complex'
      };
      this.complexTypes.push(obj);
    });
    if (this.menuItems && this.menuItems[0] && this.menuItems[0].label === 'Show Audit Fields') {
      $('tr[audit-field]').attr('audit-field', 'yes');
    } else {
      $('tr[audit-field]').attr('audit-field', 'no');
    }
  }

  handleAppConnectivityChanges() {
    this.subscriptions.push(
      this.appGlobalService.isOnline$.subscribe((isOnline) => {
        if (isOnline) {
          this.EventTracker.stop('onlineEvent');
          console.log(`onlineEvent : ${this.EventTracker.trackedEvents.onlineEvent?.duration}`);
          // handle online mode
          console.log('Online...');
          if (this.util.checkEditPermission('datamodel')) {
            this.disallowEdit = false;
          }
          this.reloadCurrentRoute();
        } else {
          this.EventTracker.stop('offlineEvent');
          console.log(`offlineEvent : ${this.EventTracker.trackedEvents.offlineEvent?.duration}`);
          // handle offline mode
          console.log('Offline...');
          this.disallowEdit = true;
          this.unsubscribeListener();
        }
      })
    );
  }

  ngOnInit(): void {
    this.isLoading = true;
    
    this.dataSetMap = this.appGlobalService.get('dataSetMap');
    this.appId = this.appGlobalService.get('appId');
    this.orgId = this.appGlobalService.get('orgId');
    this.tabId = this.appGlobalService.get('tabId');

    // Prevent FOUC by setting initial state synchronously from snapshot
    if (this.acRoute.snapshot.queryParams['origin'] === 'companion') {
      this.isCompanionOrigin = true;
      this.isCompanionLoading = true;
    }

    const routeSub$ = this.acRoute.queryParams.subscribe((params) => {
      if (params['origin'] === 'companion') {
        // Fetch companion message to extract changeset data for visualizer
        this.isCompanionOrigin = true;
        this.isCompanionLoading = true;

        // When clicking Visualizer from LHS multiple times, re-trigger the RHS refresh
        if (this.companionTreeReady) {
          this.tryActivateCompanionVisualizer();
        }

        // Safety fallback: clear loading state if initTree doesn't fire within 10s
        setTimeout(() => {
          this.isCompanionLoading = false;
        }, 10000);
      } else {
        // Reset companion flags if origin is no longer 'companion'
        this.isCompanionOrigin = false;
        this.isCompanionLoading = false;

        this.showDbVisualizer = false;
        this.showVisualizer = false;
      }
    });
    this.addToSubscriptionsList(routeSub$);

    const selectedAppSub = this.store.select(selectedAppData).subscribe((app: any) => {
      if (app && app.sid) {
        this.applicationType = app.applicationType;
        this.getTechStackData();
      }
    });
    this.addToSubscriptionsList(selectedAppSub);
    const fsLoginInitiatedSub = this.store.select(fsLoginInitiated).subscribe((fsLogin: any) => {
      //console.log("fsLogin " + fsLogin);
      if (fsLogin) {
        this.getDataModelData();
        this.getAiMergingData();
      } else {
        this.unsubscribeListener();
      }
    });
    this.subscriptions.push(fsLoginInitiatedSub);
    this.getAllRoles();
    this.handleAppConnectivityChanges();
    this.EventTracker.start('getUserSubscripton');
    const getUserSubscripton = this.store.select(userData).pipe(
      rxjsFilter((user: any) => !!user),
      take(1)
    ).subscribe((user: any) => {
      this.EventTracker.stop('getUserSubscripton');
      console.log(`getUserSubscripton : ${this.EventTracker.trackedEvents.getUserSubscripton.duration}`);
      this.isBetaAccessPrivilegeConsumable = this.appGlobalService.isBetaAccessPrivilegeConsumableForApp();
      this.user = user;
      this.viewerSid = uuidv4();
      this.store.dispatch(
        updateViewerInfo({
          vwApiConstants: ApiConstants.updateViewer,
          userData: {
            entityName: 'ApplicationDataModel',
            name: this.appId,
            email: user.email,
            tabId: this.tabId,
            orgId: this.orgId,
            entityId: this.viewerSid
          }
        })
      );
    });
    this.addToSubscriptionsList(getUserSubscripton);

    this.utilService.setService(false);
    if (this.appGlobalService.get('transactionDb') === 'NoSQL') {
      this.generateScript = false;
    } else {
      // this.generateScript = true;
    }
    if (!this.util.checkEditPermission('datamodel')) {
      this.disallowEdit = true;
    }
    this.items = [
      {
        label: 'Table',
        icon: 'pi pi-table',
        command: () => {
          this.addTable();
        }
      },
      {
        label: 'Group',
        icon: 'pi pi-folder',
        command: () => {
          this.addGroup();
        }
      }
    ];

    this.menuItems = [
      {
        label: 'Show Audit Fields',
        icon: 'pi pi-eye',
        command: () => {
          this.toggleSysGenFields();
        }
      }
    ];

    this.queryStringItems = [
      {
        label: this.translate.instant('QUERY_STRINGS'),
        command: () => {
          this.activeIndex.set(2);
        }
      }
    ];
    this.getTreeStructure();
    this.types = [...this.dataTypes];
    this.uiTypes = this.dataTypes.map((type) => type.value);
    // Clear the popup data for adding fields
    this.appForm = this.fbuilder.group({
      name: ''
    });
    //get initial field and table properties to add to new child
    this.EventTracker.start('initDataSub');
    const initDataSub = this.data$.subscribe((data) => {
      this.EventTracker.stop('initDataSub');
      console.log(`initDataSub : ${this.EventTracker.trackedEvents.initDataSub.duration}`);
      if (data) {
        this.initialFieldProperties = data?.initialProperties?.fieldProperties;
        this.initialTableProperties = data?.initialProperties?.tableProperties;
        this.setExcelColumns();
        if (initDataSub) {
          initDataSub.unsubscribe();
        }
      }
    });
    this.EventTracker.start('propertyValSub');
    const propertyValSub = this.propertyPaneValues$.pipe(distinctUntilChanged()).subscribe((val) => {
      this.EventTracker.stop('propertyValSub');
      if (!val) {
        return;
      }
      if (val === 'error') {
        this.propertyLoading = true;
        return;
      }
      this.propertyLoading = false;
      if (this.updatedDatatypeList[val.sid] || this.updatedTableName[val.sid]) {
        return;
      }
      this.savePropertyPane(val);
    });
    this.addToSubscriptionsList(propertyValSub);
    this.EventTracker.start('propertyTypeSub');
    const propertyTypeSub = this.propertiesType$.pipe(distinctUntilChanged()).subscribe((val) => {
      this.EventTracker.stop('propertyTypeSub');
      console.log(`propertyTypeSub : ${this.EventTracker.trackedEvents.duration}`);
      this.selectedNodeType = val;
    });
    this.addToSubscriptionsList(propertyTypeSub);
    this.EventTracker.start('picklist');
    const dataSub = this.store.select(picklist).subscribe((picklist) => {
      this.EventTracker.stop('picklist');
      console.log(`picklist : ${this.EventTracker.trackedEvents.picklist.duration}`);
      if (picklist) {
        this.pickList = picklist;
      }
    });
    this.addToSubscriptionsList(dataSub);
    this.EventTracker.start('tableFieldsForDM');
    const allFldSub = this.store.select(tableFieldsForDM).subscribe((res: any) => {
      this.EventTracker.stop('tableFieldsForDM');
      console.log(`tableFieldsForDM : ${this.EventTracker.trackedEvents.tableFieldsForDM.duration}`);
      if (res) {
        this.dataModelFlds = res;
      }
    });
    this.addToSubscriptionsList(allFldSub);
    this.EventTracker.start('technologystackData');
    const techSub = this.store.select(technologystackData).subscribe((val) => {
      this.EventTracker.stop('technologystackData');
      console.log(`technologystackData : ${this.EventTracker.trackedEvents.technologystackData.duration}`);
      if (val) {
        this.techStackData = val;
        if (val.transactionDb === GlobalConstants.transactionDbRdbms) {
          this.tableTypeOptions = [
            {
              name: 'Transactional Only',
              value: 'transactional_only'
            },
            {
              name: 'Analytical Only',
              value: 'analytical_only'
            },
            {
              name: 'Transactional + Analytical',
              value: 'transactional_+_analytical'
            },
            {
              name: 'Query View',
              value: 'query_view'
            }
          ];
          this.appGlobalService.write('transactionDb', GlobalConstants.transactionDbRdbms);
          this.dataTypes = this.dataTypes.filter(
            (dataType) => dataType.value !== 'Lookup' && dataType.value !== 'Checkboxgroup'
          );
          this.types = [...this.dataTypes];
          this.uiTypes = this.types.map((type) => type.value);
          this.isRdbms = true;
        } else {
          this.isRdbms = false;
          this.loadDataTypes();
          this.types = [...this.dataTypes];
          this.uiTypes = this.types.map((type) => type.value);
          this.tableTypeOptions = [
            {
              name: 'Transactional Only',
              value: 'transactional_only'
            },
            {
              name: 'Analytical Only',
              value: 'analytical_only'
            },
            {
              name: 'Transactional + Analytical',
              value: 'transactional_+_analytical'
            },
            {
              name: 'Composite Datatype',
              value: 'composite_datatype'
            },
            {
              name: 'Query View',
              value: 'query_view'
            }
          ];
          this.appGlobalService.write('transactionDb', '');
        }
        this.defDataset = val.defaultDataset;
      }
    });
    this.addToSubscriptionsList(techSub);
    this.store.dispatch(
      getAppSettings({
        apiConstants: ApiConstants.getSettingsById,
        appId: this.appGlobalService.get('appId')
      })
    );
    this.EventTracker.start('appSettingsData');
    const appSettSub = this.store.select(appSettingsData).subscribe((val) => {
      this.EventTracker.stop('appSettingsData');
      console.log(`appSettingsData : ${this.EventTracker.trackedEvents.appSettingsData.duration}`);
      if (val) {
        this.settingsData = val;
      }
    });
    this.addToSubscriptionsList(appSettSub);
    this.excelColumns = [
      { type: 'text', title: 'Group', width: 120 },
      { type: 'text', title: 'Table', width: 120 },
      { type: 'text', title: 'FieldGroup', width: 120 },
      { type: 'text', title: 'Field', width: 120 }
    ];
    const appDMFailsub = this.store.select(appDMFailData).subscribe((val) => {
      if (val && !this.hasReloadedOnDMFail) {
        this.hasReloadedOnDMFail = true;
        this.showErrMsg(val);
        this.store.dispatch(updateAppDMFailure({ appDMFailData: null }));
        setTimeout(() => {
          this.reloadCurrentRoute();
          this.hasReloadedOnDMFail = false;
        }, 1500);
      }
    });
    this.addToSubscriptionsList(appDMFailsub);
    const appDMSuccsub = this.store.select(appDMSuccData).subscribe((val) => {
      if (val) {
        this.isLoading = false;
      }
    });
    this.addToSubscriptionsList(appDMSuccsub);
  }

  getParentFieldsId(node) {
    const parentNode = this.getParentTable(node);
    this.currentTableName = parentNode.title;
    this.currentTableId = parentNode.data.sid;
    this.appGlobalService.write('selectedTable', this.currentTableName);
    this.appGlobalService.write('selectedTableId', this.currentTableId);
    return parentNode?.data.sid;
  }

  getFieldsByParent(node) {
    const parentId = this.getParentTable(node)?.data.sid;
    this.getFields(parentId);
  }

  getFields(id) {
    if (id) {
      this.store.dispatch(
        getFields({
          serviceAPiConstants: ApiConstants.getFieldInfo,
          params: { tableId: id }
        })
      );
    }
  }

  onback() {
    setTimeout(() => {
      this.activeIndex.set(0);
      this.sampleDataWorkSheet = [];
    }, 100);
    let routerEvent;
    routerEvent = {
      label: 'Data Model'
    };
    // this.generateScript = true;

    setTimeout(() => {
      // Refresh datamodels first
      this.getDataModelData();

      const tree = $.ui.fancytree.getTree('#tree');

      if (tree) {
        const node = tree.getActiveNode();
        if (node) {
          // Force refresh properties pane with a slight delay to ensure data is loaded
          setTimeout(() => {
            this.onActivateNode(node);
          }, 0);
        }
      }
    }, 300);
    this.store.dispatch(setNavigationEnd({ routerEvent }));
  }

  handleChange(index) {
    // this.activeIndex = index;
    let routerEvent;
    if (index === 1) {
      this.generateScript = false;
      this.getSampleData('prototype');
      routerEvent = {
        label: this.translate.instant('SAMPLE_DATA')
      };
    } else if (index === 2) {
      routerEvent = {
        label: this.translate.instant('QUERY_STRINGS')
      };
      // Re-attach infinite scroll after tab is rendered
      setTimeout(() => {
        this.queryStringListComponent?.initialLoadData();
        this.queryStringListComponent?.reattachInfiniteScroll();
      }, 100);
    } else {
      routerEvent = {
        label: this.translate.instant('DATA_MODEL')
      };
    }
    this.store.dispatch(setNavigationEnd({ routerEvent }));
  }

  confirmGeneration() {
    this.generateScript = false;
    this.confirmationDialogService.confirm({
      message: 'Are you sure you want to generate sample data for all the tables which are not having any data filled?',
      header: 'Confirmation',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      accept: () => {
        this.getSampleData('generateAll');
      },
      reject: () => {
        /* empty */
      }
    });
  }

  openDropdownMenu(event: SplitButton, eventClick: MouseEvent): void {
    setTimeout(() => {
      event.onDropdownButtonClick(eventClick);
    }, 0);
  }

  getSampleData(status) {
    const apiConstants =
      status === 'generateAll' ? ApiConstants.getGenerateAllSampleData : ApiConstants.getPrototypeSampleData;
    this.store.dispatch(setSampleData({ sampleDataTable: null }));
    this.sampleDataWorkSheet = [];
    if (status === 'prototype') {
      this.store.dispatch(
        getSampleData({
          apiConstants
        })
      );
    } else {
      this.store.dispatch(
        triggerSampleData({
          apiConstants
        })
      );
    }
    this.sampleDataLoading = true;
    this.EventTracker.start('sampleDataSub');
    this.sampleDataSub = this.store.select(sampleDataTable).subscribe((sampleDataRes: any) => {
      this.EventTracker.stop('sampleDataSub');
      console.log(`sampleDataSub : ${this.EventTracker.trackedEvents.sampleDataSub.duration}`);
      if (sampleDataRes) {
        this.sampleDataLoading = false;
        if (sampleDataRes.length > 0) {
          this.sampleDatas = sampleDataRes;
          this.sampleDataWorkSheet = [];
          this.sampleDatas.map((table) => {
            const columnFields = table.fieldsMapping ? JSON.parse(table.fieldsMapping) : {};
            const rowDataFields = table.data ? JSON.parse(table.data) : [];
            let columns: any = [];
            let data: any = [];
            let col;
            for (const key in columnFields) {
              col = {
                type: 'text',
                title: this.appGlobalService.get('appmetaInfo')[columnFields[key]],
                id: key,
                align: 'left',
                width: 100
              };
              columns = [...columns, col];
            }
            columns = [...columns, { type: 'hidden', title: 'rowNumber' }];
            let keys = Object.keys(columnFields);
            keys = [...keys, 'rowNumber'];
            rowDataFields.map((row) => {
              let rowData: any = [];
              keys.forEach((key) => {
                const fid = columnFields[key];
                if (this.fldTypMap && (this.fldTypMap[fid] === 'Date' || this.fldTypMap[fid] === 'DateTime')) {
                  const d = new Date(row[key]);
                  if (!isNaN(d.getMonth())) {
                    row[key] = this.datePipe.transform(row[key], 'dd-MM-yyyy');
                  }
                }
                rowData = [...rowData, row[key]];
              });
              data = [...data, rowData];
            });
            const sheet = {
              columns: columns,
              data: data,
              minDimensions: [columns.length, 20],
              fieldsMapping: table.fieldsMapping ? table.fieldsMapping : {},
              tableHeight: '60vh',
              sheetName: table.tableName,
              stopGeneration: table.stopGeneration ? table.stopGeneration : false,
              modifiedRows: table.modifiedRows ? table.modifiedRows : [],
              modifiedRowNumbers: table.modifiedRowNumbers ? table.modifiedRowNumbers : [],
              modifiedColumns: table.modifiedColumns ? table.modifiedColumns : []
            };
            this.sampleDataWorkSheet = [...this.sampleDataWorkSheet, sheet];
          });
        } else {
          this.sampleDataWorkSheet = [];
        }
      }
    });
    this.addToSubscriptionsList(this.sampleDataSub);
  }

  updateSampleData(tableData) {
    const tableInd = tableData.sheetIndex;
    let sampleDataConfig = {
      sid: this.sampleDatas[tableInd].sid,
      tableId: this.sampleDatas[tableInd].tableId,
      tableName: this.sampleDatas[tableInd].tableName,
      appId: this.sampleDatas[tableInd].appId,
      orgId: this.sampleDatas[tableInd].orgId,
      fieldsMapping: this.sampleDatas[tableInd].fieldsMapping
    };
    const columnFields = this.sampleDatas[tableInd].fieldsMapping;
    const data = tableData.sheetData;
    const empty = [undefined, null, ''];
    const trimData = data.filter(function (a) {
      return a.some(function (val) {
        return !empty.includes(val);
      });
    });
    let keys = Object.keys(JSON.parse(columnFields));
    keys = [...keys, 'rowNumber'];
    const updSampData = trimData.map((row, rowInd) => {
      let obj = {};
      keys.forEach((key, i) => {
        const fid = columnFields[key];
        if (
          this.fldTypMap &&
          (this.fldTypMap[fid] === 'Date' || this.fldTypMap[fid] === 'DateTime') &&
          typeof row[i] === 'string'
        ) {
          const datestring = row[i] ? row[i].split('-') : '';
          if (datestring.length === 3) {
            const dateConverted = new Date(Number(datestring[2]), Number(datestring[1]) - 1, Number(datestring[0]));
            row[i] = dateConverted.getTime();
          }
        }
        obj = { ...obj, ...{ [key]: row[i] } };
      });
      return obj;
    });
    sampleDataConfig = { ...sampleDataConfig, ...{ data: JSON.stringify(updSampData) } };

    if (Array.isArray(tableData.modifiedRows) && tableData.modifiedRows.length === 0) {
      sampleDataConfig = { ...sampleDataConfig, ...{ modifiedRows: {} } };
    } else if (tableData.modifiedRows) {
      sampleDataConfig = { ...sampleDataConfig, ...{ modifiedRows: tableData.modifiedRows } };
    }
    const saveapiConstants = ApiConstants.upDateSampleData;
    const sampleData = sampleDataConfig;
    this.store.dispatch(
      saveSampleData({
        saveapiConstants,
        sampleData
      })
    );
  }
  /**
   * clear table search in datamodel
   */
  clearFilter() {
    this.searchTerm = '';
    if (this.isBetaAccessPrivilegeConsumable) {
      this.showBetaTableSearch = false;
    }
    const tree = $.ui.fancytree.getTree('#tree');
    tree.clearFilter();
  }
  /**
   *
   * @param actionModulerType
   * Get the default values for the selected type
   */
  getDefaultValues(actionModulerType: any, node?: any) {
    this.formDefaultValues = {};
    const nodeType = node.type;
    this.formDefaultValues = this.util.getDefaultValues(
      actionModulerType,
      this.filteredDefaultValues,
      this.formDefaultValues,
      this.allProps,
      nodeType
    );
    if (Object.prototype.hasOwnProperty.call(this.formDefaultValues, 'tableacl')) {
      const defVals = { ...this.formDefaultValues };
      delete defVals.tableacl;
      this.formDefaultValues = { ...defVals };
    }
    if (node?.data?.sysGen) {
      this.formDefaultValues = { ...this.formDefaultValues, ...{ f_editing: 'no' } };
    }
    if (actionModulerType === 'String') {
      this.formDefaultValues.f_maxL = 50;
    }
  }

  formFKTree(fkNode, fkMap) {
    let _self = this;
    // fkMap is an array of objects, so validate and process accordingly
    if (!Array.isArray(fkMap) || !fkMap.length) {
      return fkNode;
    }

    if (fkNode.type == nodeType.TABLE) {
      // Find all foreign keys for this table
      const fkForTable = fkMap.filter((fk) => fk.tableId === fkNode.data.sid);
      if (fkForTable.length) {
        fkNode.data = { ...fkNode.data, foreignKey: fkForTable };
      }
    } else if (fkNode.type == nodeType.GROUP && fkNode.children) {
      fkNode.children = fkNode.children.map((tableNd: any) => _self.formFKTree(tableNd, fkMap));
    }
    return fkNode;
  }

  //showing Visualizer

  toggleVisualizer() {
    this.showVisualizer = !this.showVisualizer;
    if (this.showVisualizer && this.isRdbms) {
      this.visLoading = true;
      this.handleRdbmsVisualization();
    } else if (this.showVisualizer) {
      this.visLoading = true;
      this.handleRegularVisualization();
    }
  }

  toggleDbVisualizer() {
    this.showDbVisualizer = !this.showDbVisualizer;
    if (this.showDbVisualizer) {
      this.showVisualizer = false;
    }
  }

  handleRdbmsVisualization() {
    const referredTableData = [];
    const dataSubscription = this.getReferredTableData(referredTableData).subscribe((res: any) => {
      this.processVisualization(res);
    });
    this.addToSubscriptionsList(dataSubscription);
  }

  handleRegularVisualization() {
    const referredTableData = [];
    const dataSubscription = this.getReferredTableData(referredTableData).subscribe((res: any) => {
      this.processVisualization(res);
    });
    this.addToSubscriptionsList(dataSubscription);
  }

  processFkMapAndData(promises) {
    const fkMapPromise = this.bs
      .get(ApiConstants.getAllForeignKeys, { appId: this.appId, orgId: this.orgId })
      .toPromise()
      .then((res) => {
        if (res) {
          const fkMap = cloneDeep(res);
          if (this.dataModelDataOrder) {
            this.dataModelDataOrder.map((node) => this.formFKTree(node, fkMap));
          }
        }
      });
    promises.push(fkMapPromise);
  }

  processVisualization(referredTableData: any[]) {
    this.visLoading = false;
    this.referredTableData = referredTableData;
    setTimeout(() => {
      this.setPageHeight();
    }, 1);
  }

  getReferredTableData(referredTableData) {
    return new Observable((observer) => {
      const tblSub = this.bs
        .get(ApiConstants.getModelReferencesByProperty, { modelId: this.appId, propertyName: 'LOOKUPTO_APP' })
        .subscribe(
          (appData) => {
            const ad = appData;
            const promises = [];
            ad.forEach((app) => {
              this.processLookupFields(app, ad, referredTableData, promises);
            });
            if (this.isRdbms) {
              this.processFkMapAndData(promises);
            }
            Promise.all(promises)
              .then(() => {
                observer.next(referredTableData);
                observer.complete();
              })
              .catch((error) => observer.error(error));

            tblSub.unsubscribe();
          },
          (error) => {
            observer.error(error);
            observer.complete();
          }
        );

      this.addToSubscriptionsList(tblSub);
    });
  }

  processLookupFields(app, td, referredTableData, promises) {
    const promise = this.bs
      .get(ApiConstants.getReferredTables, { appId: app.referredModelId })
      .toPromise()
      .then((data) => {
        data.map((d: any) => {
          if (d.table.type === 'TABLE') {
            referredTableData.push({
              data: d.table,
              type: 'TABLE',
              key: d.table.sid,
              title: d.table.name,
              referredapp: d.table.aid,
              appName: this.getMetaName(d.table.aid),
              children: d.fields
            });
          }
        });
      })
      .catch((error) => console.log(error));

    promises.push(promise);
  }

  toggleSysGenFields() {
    if ($('tr[audit-field]').attr('audit-field') == 'no') {
      $('tr[audit-field]').attr('audit-field', 'yes');
      this.menuItems[0].label = 'Show Audit Fields';
      this.menuItems[0].icon = 'pi pi-eye';
    } else {
      $('tr[audit-field]').attr('audit-field', 'no');
      this.menuItems[0].label = 'Hide Audit Fields';
      this.menuItems[0].icon = 'pi pi-eye-slash';
    }
    this.rearrageTreeLegIndicator(50);
  }

  /**
   *
   * @param event
   * method to change the data type
   * Open overlay panel and on click of selected type the panel will be closed
   */
  checkForQueryView(val) {
    const tree = $.ui.fancytree.getTree('#tree');
    this.queryCheck = tree.getNodeByKey(val.f_tableId)?.data?.t_type === 'query_view';
    return this.queryCheck;
  }
  selectType(event) {
    try {
      this.selectedRow = null;
      this.selectedRow = event.currentTarget.closest('tr');
      const parentId = $(this.selectedRow).attr('pid');
      this.complexTypesForDataType = this.complexTypes.filter((e) => e.value !== parentId);
      const tableId = this.activeNode?.data?.f_tableId;
      if (this.checkForQueryView(this.activeNode?.data)) {
        this.hideDts = true;
      } else {
        this.hideDts = false;
      }
      this.op.toggle(event);
      setTimeout(() => {
        $('#filter').focus();
      }, 100);
    } catch (e) {
      console.error(e);
    }
  }

  /**
   *
   * @param event
   * method to trigger context menu on left click
   */
  openContextMenu(event) {
    try {
      if (event.originalEvent.pointerId < 0) {
        return;
      }
      $(event.currentTarget).parent().parent().parent().find('.fancytree-title').contextMenu();
      $('.context-menu-list').css('visibility', 'hidden');
      setTimeout(() => {
        $(event.currentTarget);
        // Apply neutral beta styling to the context menu (it is appended to <body>,
        // outside the beta-scoped layout, so tag it explicitly for beta users).
        $('.context-menu-list').toggleClass('beta-access-enabled', !!this.isBetaAccessPrivilegeConsumable);
        $('.context-menu-list').css('left', event.clientX);
        $('.context-menu-list').css('visibility', 'visible');
      }, 0);
    } catch (e) {
      console.error(e);
    }
  }

  getImpExpRef(id) {
    const promise = new Promise<void>((resolve, reject) => {
      this.EventTracker.start('getImpExpRef');
      this.ref$ = this.bs.get(ApiConstants.getDatamodelTableData, { sid: id }).subscribe({
        next: (res: any) => {
          this.EventTracker.stop('getImpExpRef');
          console.log(`getImpExpRef : ${this.EventTracker.trackedEvents.getImpExpRef.duration}`);
          resolve(res);
        },
        error: (err: any) => {
          reject(err);
        },
        complete: () => {
          console.log('complete');
        }
      });
      this.addToSubscriptionsList(this.ref$);
    });
    return promise;
  }

  isCompAdded(complexId, cnode, pnode) {
    if (!cnode) {
      return null;
    }
    if (
      cnode.find((node) => {
        if (
          node.type === nodeType.FIELD &&
          node.data.f_type === DMConstants.COMPLEX_FIELD_TYPE &&
          node.data.f_cDataTypeId === complexId
        ) {
          pnode = node;
          return true;
        } else if (node.children) {
          pnode = this.isCompAdded(complexId, node.children, pnode);
          return pnode;
        }
        return false;
      })
    ) {
      return pnode;
    }
    return null;
  }
  /**
   *
   * @param value  // selected data type
   * @param complexId  // optional other than 'complex data type'
   * @param complexName // optional other than 'complex data type'
   */
  setDataType(value, complexId?: string, complexName?: string) {
    const tree = $.ui.fancytree.getTree('#tree');
    const node = tree.getActiveNode();
    const type = node.data?.f_type;
    const parentNode = this.getParentTable(node);
    const _self = this;
    this.op.hide();
    this.isLoading = true;
    if (!this.enabledReferenceModal) {
      this.enabledReferenceModal = true;
      const prevFieldType = node?.data?.f_type;
      const computedActionType = this.computeFieldTypeUpdateActionType(prevFieldType, value);
      this.fetchModelReferences({
        modelId: node.data.sid,
        modelType: ModelType.FIELD,
        actionType: computedActionType,
        action: 'FIELD_TYPE_UPDATE'
      }).then(
        (response: any) => {
          this.isLoading = false;
          if (response.length > 0 && response.filter((f) => f.propertyName !== 'SEARCHABLE') !== 0) {
            const d = {
              value: value,
              node: node,
              tree: tree,
              complexId: complexId,
              complexName: complexName,
              genericAction: 'FIELD_TYPE_UPDATE',
              oldType: prevFieldType,
              newType: value,
              actionType: computedActionType
            };
            const _self = this;
            this.zone.run(() => {
              if (_self.popupOpened) {
                return;
              }
              _self.util.setPopupRestriction(_self.popupOpened);
              this.appGlobalService.write('transientFieldUpdate', 'false');
              _self.showReferenceTree(node?.data, response, d);
            });

            // this.showReferenceTree(node?.data, response, d);
          } else {
            this.enabledReferenceModal = false;
            // condition to check composite table cannot have composite field types and attachment field types
            if (
              value === DMConstants.COMPLEX_FIELD_TYPE ||
              value === 'File Attachments' ||
              value === 'Image Carousel'
            ) {
              if (parentNode.data.t_type === DMConstants.COMPLEX_TYPE) {
                if (value === DMConstants.COMPLEX_FIELD_TYPE) {
                  // check parent composite table is already refered or not
                  const pnode = this.isCompAdded(parentNode.data?.sid, tree.rootNode?.children, null);
                  if (pnode) {
                    this.showMessage(
                      'error',
                      `Composite Table ${parentNode.title} is already declared in another composite table ${this.tableMap[pnode.data.sid]}. Only One level of composite inside composite is supported.`
                    );
                  } else {
                    // check selected composite table is already refered in another table or not
                    const comptblNode = tree.getNodeByKey(complexId ?? '')?.children;
                    const fnode = this.isCompAdded(complexId, comptblNode, null);
                    if (fnode) {
                      this.showMessage(
                        'error',
                        `Composite Table ${this.tableMap[complexId ?? '']} is already having another composite field. Only One level of composite inside composite is supported.`
                      );
                    } else {
                      this.dataTypeChangeCall(value, node, tree, complexId, complexName);
                    }
                  }
                } else {
                  this.showMessage('error', 'Composite Table cannot have attachments');
                }
              } else {
                this.dataTypeChangeCall(value, node, tree, complexId, complexName);
              }
            } else {
              this.dataTypeChangeCall(value, node, tree, complexId, complexName);
            }
          }
        },
        (error) => {
          this.isLoading = false;
          console.log(error); // Error triggered when reject() is returned.
        }
      );
    }
  }

  dataTypeChangeCall(value, node, tree, complexId?: string, complexName?: string) {
    let fieldTypeName = value;
    const preFieldType = node.data.f_type;
    node.data = { ...node.data, ...{ f_type: value } };
    if (value === DMConstants.COMPLEX_FIELD_TYPE) {
      const preComplexDataTypeId = node.data.f_cDataTypeId;
      node.data = { ...node.data, ...{ f_cDataTypeId: complexId } };
      fieldTypeName = complexName;
      if (preFieldType === value && preComplexDataTypeId !== complexId) {
        this.changeDataType(value, preFieldType, node);
      }
    } else {
      delete tree.getActiveNode().data.f_cDataTypeId;
    }
    if (preFieldType !== value) {
      this.changeDataType(value, preFieldType, node);
    }
    if (this.selectedRow) {
      const fieldVal = this.dataTypes.find((e) => e.value === fieldTypeName);
      $(this.selectedRow)
        .find('>td')
        .eq(3)
        .find('#data-field-type')
        .text(fieldVal ? fieldVal.name : fieldTypeName);
    }
    tree = null;
  }

  changeDataType(value, oldValue, node) {
    this.updateDataTypeChange(value, this.selectedNode, oldValue);
    this.loadFieldProperties(value);
  }

  /**
   * clear filter data while hiding the overlay panel for change data type
   */
  clearFilterData() {
    this.filter = '';
  }

  confirmTableTypeChange(tableData: any, fields: any, type: any) {
    const tableType = this.tableTypeOptions.find((option) => option.value === type);
    let message = '';
    if (fields.length === 1) {
      message = `Field  ${fields.join(', ')} is a system generated field for table type "${tableType.name}". Please delete the field to continue with table type change`;
    } else if (fields.length >= 1) {
      message = `Fields  ${fields.join(', ')} are system generated fields for table type "${tableType.name}". Please delete the fields to continue with table type change`;
    }

    const confirmationObj = {
      message,
      acceptLabel: String(this.translate.instant('OK')),
      accept: () => {
        tableData.typeChange = true;
        this.store.dispatch(propertyActions.setPropertiesValues({ propertiesValues: tableData }));
        return;
      },
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      rejectVisible: false
    };
    const _self = this;
    this.zone.run(() => {
      _self.confirmationDialogService.confirm(confirmationObj);
    });
  }

  confirmTableTypeChangeWithReference(tableData: any, references: any, tableType) {
    const keys = Object.keys(references);
    const keysLength = keys.length;
    if (keysLength === 0) {
      return false;
    }
    let message = '';
    for (let i = 0; i < keysLength; i++) {
      const id = keys[i];
      const obj = references[id];
      for (const j in obj) {
        const refObj = obj[j];
        const names = Object.values(refObj.info).join();
        if (!this.tableMap[id]) {
          if (names && refObj.objectType === 'Screens') {
            message += `${id} is used in ${names} in screens. `;
          } else if (
            names &&
            (refObj.objectType === 'Workflow' ||
              refObj.objectType === 'WorkflowActionStep' ||
              refObj.objectType === 'WorkflowActorStep')
          ) {
            message += `${id} is used in ${names} in Workflow. `;
          } else if (names && names.indexOf('Foreign Key') !== -1) {
            message += `${id} is used as Parent Table in ${names.split('-')[0]} for ${names.split('-')[1]}.\n `;
          }
        } else if (names && refObj.objectType === 'Screens') {
          message += `${this.tableMap[id]} is used in ${names} in screens. `;
        } else if (
          names &&
          (refObj.objectType === 'Workflow' ||
            refObj.objectType === 'WorkflowActionStep' ||
            refObj.objectType === 'WorkflowActorStep')
        ) {
          message += `${this.tableMap[id]} is used in ${names} in Workflow. `;
        } else if (names && names.indexOf('Foreign Key') !== -1) {
          message += `${this.tableMap[id]} is used as Parent Table in ${names.split('-')[0]} for ${names.split('-')[1]}.\n `;
        }
      }
    }
    if (message.length > 0) {
      message += `To continue with table type change, please remove the reference and try to change again.`;
      this.hasReference = true;
      const confirmationObj = {
        message,
        acceptLabel: String(this.translate.instant('OK')),
        accept: () => {
          if ((this.isRdbms && tableType === DMConstants.TRANS_ANALY) || tableType === DMConstants.TRANS_ONLY) {
            this.store.dispatch(propertyActions.setPropertiesValues({ propertiesValues: null }));
            this.loadTableValueBySid(tableData);
          }
        },
        rejectVisible: false,
        acceptIcon: 'pi pi-check',
        rejectIcon: 'pi pi-times'
      };
      const _self = this;
      this.zone.run(() => {
        _self.confirmationDialogService.confirm(confirmationObj);
      });
    }
    return message.length > 0;
  }

  public resizeStartHandler(e) {
    this.sizes = [...e.sizes];
  }

  public resizeEndHandler(e) {
    if (e.sizes.some((size) => size > this.maxSize)) {
      this.panelSizes = [...this.sizes];
    }
  }

  rearrageTreeLegIndicator(timeout = 0) {
    //cancel any pending recalculation before scheduling a new one
    if (this.rearrageTreeLegTimer) {
      clearTimeout(this.rearrageTreeLegTimer);
    }
    this.rearrageTreeLegTimer = setTimeout(() => {
      this.rearrageTreeLegTimer = null;
      if (this.isBetaAccessPrivilegeConsumable) {
        $('.vertical-line, .horizondal-line').remove();
        return;
      }
      $('.fancytree-folder').each((i, item: any) => {
        const vl = $(item).find('.vertical-line');
        const ftnode = item.ftnode;

        let shouldShowVline = false;

        if (ftnode.children && ftnode.expanded) {
          const linkNode = ftnode.children[this.reArrangeLegforGenFieldsAtBottom(ftnode)];
          if (linkNode) {
            const linkRowLine = $(linkNode.tr).find('.horizondal-line');
            if (linkRowLine && linkRowLine.offset()) {
              vl.css('display', 'block');
              const vlTop = vl.offset()?.top ?? 0;
              const hrTop = linkRowLine.offset()?.top ?? 0;
              vl.css('height', `${hrTop - vlTop - 0}px`);
              shouldShowVline = true;
            }
          }
        }
        if (!shouldShowVline) {
          vl.css('display', 'none');
        }
      });
    }, timeout);
  }
  /**
   * To get the index of the last field which is not system generated for vertical lines alignment.
   *
   * @param {Object} ftNode - The node of the corresponding clicked table.
   * @returns {int} - Returns the index of the last non-system generated field
   */
  reArrangeLegforGenFieldsAtBottom(ftNode) {
    let nodeNum;
    const auditFields = ['sid', 'modifieddate', 'createdby', 'createddate', 'modifiedby'];
    const condition = (element) => !element?.data.sysGen;
    const lastChild = ftNode?.children?.[ftNode?.children?.length - 1];
    if (
      lastChild &&
      lastChild.data?.sysGen &&
      auditFields.includes(lastChild.data?.name?.toLowerCase()) &&
      this.menuItems[0].label !== 'Hide Audit Fields'
    ) {
      const childArray: any[] = [...(ftNode?.children ?? {})];
      for (let i = childArray.length - 1; i >= 0; i--) {
        if (condition(childArray[i])) {
          nodeNum = i;
          return nodeNum;
        }
      }
    } else {
      nodeNum = ftNode?.children.length - 1;
    }
    return nodeNum;
  }
  getOldDataAndSid(diffObj: any, tableData: any, node: any) {
    this.dataSetMap = this.appGlobalService.get('dataSetMap');
    const isValueChanged = (current: any, previous: any) => {
      if (current === previous) return false;
      if (current == null && previous == null) return false;
      return true;
    };
    if (Object.prototype.hasOwnProperty.call(diffObj, 't_oFilters')) {
      tableData.t_oFiltersSid = node.data.t_oFiltersSid ? node.data.t_oFiltersSid : uuidv4();
      diffObj = {
        ...diffObj,
        ...{
          old_t_oFilters: node.data.t_oFilters,
          t_oFiltersSid: tableData.t_oFiltersSid,
          t_lookupFieldsSid: tableData.t_lookupFieldsSid
        }
      };
    }
    if (Object.prototype.hasOwnProperty.call(diffObj, 'f_dField')) {
      tableData.f_dFieldSid = node.data.f_dFieldSid ? node.data.f_dFieldSid : uuidv4();
      diffObj = { ...diffObj, ...{ old_f_dField: node.data.f_dField, f_dFieldSid: tableData.f_dFieldSid } };
      if (this.applicationType !== ApplicationTypes.INDEPENDENT) {
        let lookUpRefAppId;
        if (
          this.appGlobalService
            .get('groupedLookUpTables')
            .filter((app) => app.items.filter((tbl) => tbl.sid === tableData.f_lookupTo).length).length > 0
        ) {
          lookUpRefAppId = this.appGlobalService
            .get('groupedLookUpTables')
            .filter((app) => app.items.filter((tbl) => tbl.sid === tableData.f_lookupTo).length)[0].sid;
        } else {
          lookUpRefAppId = this.appGlobalService.get('appId');
        }
        diffObj = { ...diffObj, ...{ lookUpRefAppId: lookUpRefAppId } };
      }
    }
    if (Object.prototype.hasOwnProperty.call(diffObj, 'f_lookupTo')) {
      tableData.f_lookupToSid = node.data.f_lookupToSid ? node.data.f_lookupToSid : uuidv4();
      tableData.f_dFieldSid = node.data.f_dFieldSid ? node.data.f_dFieldSid : uuidv4();
      tableData.f_lookUpIMapSid = node.data.f_lookUpIMapSid ? node.data.f_lookUpIMapSid : uuidv4();
      tableData.f_lookUpOMapSid = node.data.f_lookUpOMapSid ? node.data.f_lookUpOMapSid : uuidv4();
      if (this.applicationType === ApplicationTypes.INDEPENDENT) {
        diffObj = {
          ...diffObj,
          ...{
            old_f_lookupTo: node.data.f_lookupTo,
            f_lookupToSid: tableData.f_lookupToSid,
            f_lookUpOMap: null,
            f_lookUpIMapSid: tableData.f_lookUpIMapSid,
            f_lookUpOMapSid: tableData.f_lookUpOMapSid
          }
        };
      } else {
        let lookUpRefAppId;
        if (
          this.appGlobalService
            .get('groupedLookUpTables')
            .filter((app) => app.items.filter((tbl) => tbl.sid === tableData.f_lookupTo).length).length > 0
        ) {
          lookUpRefAppId = this.appGlobalService
            .get('groupedLookUpTables')
            .filter((app) => app.items.filter((tbl) => tbl.sid === tableData.f_lookupTo).length)[0].sid;
        } else {
          lookUpRefAppId = this.appGlobalService.get('appId');
        }
        diffObj = {
          ...diffObj,
          ...{
            old_f_lookupTo: node.data.f_lookupTo,
            lookUpRefAppId: lookUpRefAppId,
            old_lookUpRefAppId: tableData.lookUpRefAppId,
            f_lookupToSid: tableData.f_lookupToSid,
            f_lookUpOMap: null,
            f_lookUpIMapSid: tableData.f_lookUpIMapSid,
            f_lookUpOMapSid: tableData.f_lookUpOMapSid
          }
        };
      }
    }
    if (Object.prototype.hasOwnProperty.call(diffObj, 'f_lookUpIMap')) {
      tableData.f_lookUpIMapSid = node.data.f_lookUpIMapSid ? node.data.f_lookUpIMapSid : uuidv4();
      diffObj = {
        ...diffObj,
        ...{ old_f_lookUpIMap: node.data.f_lookUpIMap, f_lookUpIMapSid: tableData.f_lookUpIMapSid }
      };
    }
    if (Object.prototype.hasOwnProperty.call(diffObj, 'f_lookUpOMap')) {
      tableData.f_lookUpOMapSid = node.data.f_lookUpOMapSid ? node.data.f_lookUpOMapSid : uuidv4();
      diffObj = {
        ...diffObj,
        ...{ old_f_lookUpOMap: node.data.f_lookUpOMap, f_lookUpOMapSid: tableData.f_lookUpOMapSid }
      };
    }
    if (Object.prototype.hasOwnProperty.call(diffObj, 'f_lookUpOMap')) {
      tableData.f_lookUpOMapSid = node.data.f_lookUpOMapSid ? node.data.f_lookUpOMapSid : uuidv4();
      diffObj = {
        ...diffObj,
        ...{ old_f_lookUpOMap: node.data.f_lookUpOMap, f_lookUpOMapSid: tableData.f_lookUpOMapSid }
      };
    }
    if (Object.prototype.hasOwnProperty.call(diffObj, 't_uniqueId')) {
      tableData.t_uniqueIdSid = node.data.t_uniqueIdSid ? node.data.t_uniqueIdSid : uuidv4();
      diffObj = { ...diffObj, ...{ old_t_uniqueId: node.data.t_uniqueId, t_uniqueIdSid: tableData.t_uniqueIdSid } };
    }
    if (
      Object.prototype.hasOwnProperty.call(diffObj, 't_mandatory_filters') &&
      isValueChanged(tableData.t_mandatory_filters, node.data.t_mandatory_filters)
    ) {
      tableData.t_mandatory_filters_sid = node.data?.t_mandatory_filters_sid
        ? node.data.t_mandatory_filters_sid
        : uuidv4();
      diffObj = {
        ...diffObj,
        ...{
          old_t_mandatory_filters: node.data.t_mandatory_filters,
          old_t_unique_for_lookup: node.data.t_unique_for_lookup,
          t_unique_for_lookup: node.data.t_unique_for_lookup,
          t_unique_for_lookup_sid: node.data.t_unique_for_lookup_sid,
          old_t_optional_filters: node.data.t_optional_filters,
          t_optional_filters: node.data.t_optional_filters,
          t_optional_filters_sid: node.data.t_optional_filters_sid,
          t_type: node.data.t_type,
          name: node.data.name,
          t_mandatory_filters: tableData.t_mandatory_filters,
          t_mandatory_filters_sid: tableData.t_mandatory_filters_sid
        }
      };
    }
    if (
      Object.prototype.hasOwnProperty.call(diffObj, 't_unique_for_lookup') &&
      isValueChanged(tableData.t_unique_for_lookup, node.data.t_unique_for_lookup)
    ) {
      tableData.t_unique_for_lookup_sid = node.data?.t_unique_for_lookup_sid
        ? node.data.t_unique_for_lookup_sid
        : uuidv4();
      diffObj = {
        ...diffObj,
        ...{
          old_t_unique_for_lookup: node.data.t_unique_for_lookup,
          old_t_mandatory_filters: node.data.t_mandatory_filters,
          t_mandatory_filters: node.data.t_mandatory_filters,
          t_mandatory_filters_sid: node.data.t_mandatory_filters_sid,
          t_type: node.data.t_type,
          name: node.data.name,
          t_unique_for_lookup: tableData.t_unique_for_lookup,
          t_unique_for_lookup_sid: tableData.t_unique_for_lookup_sid,
          old_t_optional_filters: node.data.t_optional_filters,
          t_optional_filters: node.data.t_optional_filters,
          t_optional_filters_sid: node.data.t_optional_filters_sid
        }
      };
    }
    if (
      Object.prototype.hasOwnProperty.call(diffObj, 't_optional_filters') &&
      isValueChanged(tableData.t_optional_filters, node.data.t_optional_filters)
    ) {
      tableData.t_optional_filters_sid = node.data?.t_optional_filters_sid
        ? node.data.t_optional_filters_sid
        : uuidv4();
      diffObj = {
        ...diffObj,
        ...{
          old_t_unique_for_lookup: node.data.t_unique_for_lookup,
          t_unique_for_lookup: node.data.t_unique_for_lookup,
          t_unique_for_lookup_sid: node.data.t_unique_for_lookup_sid,
          old_t_mandatory_filters: node.data.t_mandatory_filters,
          t_mandatory_filters: node.data.t_mandatory_filters,
          t_mandatory_filters_sid: node.data.t_mandatory_filters_sid,
          old_t_optional_filters: node.data.t_optional_filters,
          t_type: node.data.t_type,
          name: node.data.name,
          t_optional_filters: tableData.t_optional_filters,
          t_optional_filters_sid: tableData.t_optional_filters_sid
        }
      };
    }
    if (Object.prototype.hasOwnProperty.call(diffObj, 't_query_type')) {
      // To avoid sending t_query_type as empty string
      tableData.t_query_type = diffObj.t_query_type ? diffObj.t_query_type : null;
      diffObj = {
        ...diffObj,
        ...{
          old_t_query_type: node.data.t_query_type,
          t_type: node.data.t_type,
          t_query_type: tableData.t_query_type,
          name: node.data.name,
          old_name: node.data.name
        }
      };

      // Extract removed query strings from both queries
      const listQueryChanges = node.data.t_list_query
        ? this.utilService.changesMadeInQueryString(this.formatQSNameToSid(node.data.t_list_query), '')
        : {};
      const detailQueryChanges = node.data.t_detail_query
        ? this.utilService.changesMadeInQueryString(this.formatQSNameToSid(node.data.t_detail_query), '')
        : {};

      // Merge removed query strings from both queries
      const removedMap = {
        ...(listQueryChanges['REMOVED'] || {}),
        ...(detailQueryChanges['REMOVED'] || {})
      };

      if (Object.keys(removedMap).length > 0) {
        diffObj = {
          ...diffObj,
          removed: removedMap
        };
      }

      if (tableData.t_query_type === 'single') {
        diffObj = { ...diffObj, ...{ t_create_detail_page: false } };
      }
    }
    if (Object.prototype.hasOwnProperty.call(diffObj, 't_list_query')) {
      let queryString = tableData.t_list_query
        ? tableData.t_list_query.replace(GlobalConstants.queryStringRegex.trimPattern, ' ')
        : null;
      // Convert query string names to SIDs for storage
      let formattedOldQuery = this.formatQSNameToSid(node.data.t_list_query);
      queryString = this.formatQSNameToSid(queryString);
      let addedRemovedQS = this.utilService.changesMadeInQueryString(formattedOldQuery, queryString);
      diffObj = {
        ...diffObj,
        ...{
          t_list_query: queryString,
          added: addedRemovedQS['ADDED'],
          removed: addedRemovedQS['REMOVED']
        }
      };
    }
    if (Object.prototype.hasOwnProperty.call(diffObj, 't_detail_query')) {
      let queryString = tableData.t_detail_query
        ? tableData.t_detail_query.replace(GlobalConstants.queryStringRegex.trimPattern, ' ')
        : null;
      // Convert query string names to SIDs for storage
      queryString = this.formatQSNameToSid(queryString);
      let formattedOldQuery = this.formatQSNameToSid(node.data.t_detail_query);
      let addedRemovedQS = this.utilService.changesMadeInQueryString(formattedOldQuery, queryString);
      diffObj = {
        ...diffObj,
        ...{
          t_detail_query: queryString,
          added: addedRemovedQS['ADDED'],
          removed: addedRemovedQS['REMOVED']
        }
      };
    }
    if (
      Object.prototype.hasOwnProperty.call(diffObj, 'f_fKeyId') ||
      Object.prototype.hasOwnProperty.call(diffObj, 'f_pTableFId')
    ) {
      tableData.f_dpsSid = node.data.f_dpsSid ? node.data.f_dpsSid : uuidv4();
      if (!tableData.f_fKeyId) {
        diffObj = { ...diffObj, ...{ f_pTableFId: null } };
      }
      diffObj = {
        ...diffObj,
        ...{
          old_f_fKeyId: node.data.f_fKeyId,
          old_f_pTableFId: node.data.f_pTableFId,
          f_dpsSid: tableData.f_dpsSid
        }
      };
    }
    if (Object.prototype.hasOwnProperty.call(diffObj, 't_transactionalTable')) {
      diffObj = { ...diffObj, ...{ old_t_transactionalTable: node.data.t_transactionalTable } };
    }
    if (Object.prototype.hasOwnProperty.call(diffObj, 't_datasetName')) {
      let oldDataSetName =
        node.data.t_datasetName === null || !node.data.t_datasetName ? null : node.data.t_datasetName;
      if (oldDataSetName === tableData.t_datasetName) {
        oldDataSetName = null;
      }
      diffObj = { ...diffObj, ...{ old_t_datasetName: oldDataSetName, t_datasetName: tableData.t_datasetName } };
    }
    if (Object.prototype.hasOwnProperty.call(diffObj, 'dtoEnabled')) {
      diffObj = { ...diffObj, ...{ dtoEnabled: diffObj.dtoEnabled ?? false, old_dtoEnabled: node?.data?.dtoEnabled ?? false } };
    }
    return diffObj;
  }

  extractQueryStrings(query) {
    if (!query || typeof query !== 'string') {
      return [];
    }

    const regex = GlobalConstants.queryStringRegex.qStringMatchPattern;
    const matches = [...query.matchAll(regex)].map((match) => match[1]);

    return matches;
  }

  onTemplateValueChange(templateProps) {
    this.templateProps = templateProps;
  }

  getKeyByValue(obj, value) {
    const key = Object.keys(obj).find((key) => obj[key] === value);
    return key || null;
  }

  /**
   * Convert query string content from names to SIDs for storage
   * Replaces $${name} with _$sid$_ using queryStrings map
   */
  formatQSNameToSid(query: string): string {
    const queryStringsMap = this.appGlobalService.get('queryStrings') || {};
    const appMetaInfo = this.appGlobalService.get('appmetaInfo') || {};
    return this.monacoHelper.formatQSNameToSid(query, queryStringsMap, appMetaInfo);
  }

  isUnique(data, fsData) {
    let flag = true;
    if (fsData) {
      fsData.forEach((k) => {
        if (
          data.sid === k.sid &&
          !this.util.isEqualIgnoreCase(data, k, ['modifiedDate', 'actionType', 'createdDate', 'action'])
        ) {
          flag = false;
        }
      });
    }
    return flag;
  }

  mergeFsData(data, fsData) {
    if (data) {
      data.forEach((d) => {
        if (fsData) {
          const index = fsData.findIndex((k) => d.sid === k.sid);
          if (index !== -1) {
            fsData[index] = d;
          }
        }
      });
    }

    return fsData;
  }

  replaceEmptyValWithNull(arr) {
    if (arr) {
      if (Array.isArray(arr) && arr.length > 0) {
        arr.forEach((a) => {
          const isArray = Array.isArray(a);
          if (isArray && a.length > 0) {
            a = this.replaceEmptyValWithNull(a);
          } else if (typeof a === 'object') {
            a = this.replaceEmptyValWithNull(a);
          } else if (a === '') {
            a = null;
          }
        });
      } else if (typeof arr === 'object') {
        const key = Object.keys(arr).forEach((k) => {
          const isArray = Array.isArray(arr[k]);
          if (isArray && arr[k].length > 0) {
            arr[k] = this.replaceEmptyValWithNull(arr[k]);
          } else if (typeof arr[k] === 'object') {
            arr[k] = this.replaceEmptyValWithNull(arr[k]);
          } else if (arr[k] === '') {
            arr[k] = null;
          }
        });
      } else if (arr === '') {
        arr = null;
      }
    } else if (arr === '') {
      return null;
    }
    return arr;
  }

  getMetaName(id) {
    this.refAppMetaInfos = this.appGlobalService.get('refAppMetaInfos');
    const mdata: any = this.refAppMetaInfos && this.refAppMetaInfos[id] ? this.refAppMetaInfos[id] : null;
    return mdata || 'noname';
  }

  EventTracker: any = {
    trackedEvents: {},

    start: (key) => {
      const startTime = new Date();
      this.EventTracker.trackedEvents[key] = {
        start: startTime
      };
    },

    stop: (key) => {
      const endTime: any = new Date();
      this.EventTracker.trackedEvents[key].duration =
        `${this.utilService.formatDateForConsole(this.EventTracker.trackedEvents[key]?.start)} ${this.utilService.formatDateForConsole(endTime)}  ===> ${
          (endTime - this.EventTracker.trackedEvents[key].start) / 1000
        }s`;
      this.EventTracker.trackedEvents[key].end = endTime;
    }
  };

  /**
   * This method opens the Schema to datamodel component in a dialog
   */
  showSchemaToDataModelModal(data) {
    this.dynamicDialogService.open(SchemaToDataModelComponent, {
      showHeader: false,
      closeOnEscape: false,
      modal: true,
      styleClass: 'schema-to-data-model-modal',
      data
    });
  }

  /**
   * This method gets the Ai Merging data for the latest upload and sets the data model blocker if merge is in progress
   */
  getAiMergingData() {
    this.isLoading = true;

    const version = this.appGlobalService.get('appVersion');
    const queryObject = {
      collectionName: `AIImpSchUploadHistory_${version}`,
      filter: [
        {
          field: 'appId',
          operator: '==',
          value: this.appGlobalService.get('appId')
        },
        {
          field: 'recDeleted',
          operator: '==',
          value: false
        },
        {
          field: 'active',
          operator: '==',
          value: true
        }
      ]
    };

    try {
      this.EventTracker.start('AIImpSchUploadHistory');
      const aiMergingDataSubs$ = this.fsService.fireService(queryObject).subscribe(
        (res) => {
          this.EventTracker.stop('AIImpSchUploadHistory');
          console.log(`AIImpSchUploadHistory : ${this.EventTracker.trackedEvents.AIImpSchUploadHistory.duration}`);
          const latestUploadRes = res[res.length - 1];
          if (latestUploadRes && latestUploadRes.type !== 'removed') {
            this.lastestUploadData = latestUploadRes.payload.doc.data();
            if (
              this.lastestUploadData.generateDatamodelPercent === 100 &&
              this.lastestUploadData.mergingDatamodelStatus === 'MERGE_STARTED'
            ) {
              this.isAiDataModelMergeInProgress = true;
              this.appGlobalService.write('isAiDataModelMergeInProgress', true);
              this.isLoading = true;
              // Stop the datamodel listener when merge is in progress
              // Once merge done, again the data will be initiated
              this.dataMlSub.forEach((k) => {
                if (k && typeof k.unsubscribe === 'function') {
                  k.unsubscribe();
                }
              });
            }
          } else {
            if (latestUploadRes?.type === 'removed') {
              this.isAiDataModelMergedJustNow = true;
            }
            this.isAiDataModelMergeInProgress = false;
            this.appGlobalService.write('isAiDataModelMergeInProgress', false);
            this.isLoading = false;
            this.lastestUploadData = null;
            this.aiMergeErrorLogs = [];
          }
        },
        (error) => {
          console.error(error);
        }
      );
      this.addToSubscriptionsList(aiMergingDataSubs$);

      // Merge logs will not be available in the active history
      // get last merge log which was inactive
      this.EventTracker.start('AIImpSchUploadHistory - LastMerge');
      const mergeLogQuery = {
        collectionName: `AIImpSchUploadHistory_${version}`,
        filter: [
          {
            field: 'appId',
            operator: '==',
            value: this.appGlobalService.get('appId')
          },
          {
            field: 'lastMerged',
            operator: '==',
            value: true
          }
        ]
      };
      const aiMergeLogDataSubs$ = this.fsService.fireService(mergeLogQuery).subscribe(
        (res) => {
          this.EventTracker.stop('AIImpSchUploadHistory - LastMerge');
          console.log(
            `AIImpSchUploadHistory - LastMerge : ${
              this.EventTracker.trackedEvents['AIImpSchUploadHistory - LastMerge'].duration
            }`
          );
          if (res.length) {
            this.isAiDataModelMergeInProgress = false;
            this.appGlobalService.write('isAiDataModelMergeInProgress', false);
            this.aiMergeErrorLogs = [];
            const latestMergeData = res[0]?.payload?.doc?.data();
            const mergingDatamodelErrorMsg = latestMergeData?.mergingDatamodelErrorMsg;
            if (mergingDatamodelErrorMsg.length) {
              mergingDatamodelErrorMsg.forEach((msg) => {
                const parsedMessage = this.getParsedObject(msg);

                if (typeof parsedMessage === 'object') {
                  if (parsedMessage.skippedFieldInfo.length) {
                    this.aiMergeErrorLogs.push(parsedMessage);
                  }
                } else {
                  this.aiMergeErrorLogs.push(parsedMessage);
                }
              });

              if (this.aiMergeErrorLogs.length) {
                const aiMergeLogString = this.translate.instant('AI_MERGE_LOGS');
                if (!this.menuItems.find((menu) => menu.label === aiMergeLogString)) {
                  // Create new array reference for change detection
                  this.menuItems = [
                    ...this.menuItems,
                    {
                      label: aiMergeLogString,
                      icon: 'pi pi-file',
                      command: () => {
                        this.openMergingErrPopup();
                      }
                    }
                  ];
                }
                console.log(this.menuItems);
              } else {
                // Remove the logs options
                this.menuItems = this.menuItems.filter(
                  (menu) => menu.label !== this.translate.instant('AI_MERGE_LOGS')
                );
              }
            } else {
              // Remove the logs options
              this.menuItems = this.menuItems.filter((menu) => menu.label != this.translate.instant('AI_MERGE_LOGS'));
            }
            // Wait for a few moments to detect whether the last merge has completed and show the appropriate toast.
            // Since two different listeners are used—one for showing the blocker and another for displaying logs—the toast message should be handled here.
            // Once active is set to false, isAiDataModelMergedJustNow will be updated to true by the aiMergingDataSubs listener, and the merge status will be updated here so that a success or failure toast can be displayed.
            setTimeout(() => {
              if (this.isAiDataModelMergedJustNow) {
                if (latestMergeData.mergingDatamodelStatus === 'SUCCESS') {
                  this.messageService.add({
                    severity: 'success',
                    summary: this.translate.instant('MERGE_SUCCESS'),
                    detail: this.translate.instant('MERGE_SUCCESS_DETAIL')
                  });
                  // Update the flg to prevent displaying the toast multiple times
                  this.isAiDataModelMergedJustNow = false;
                } else {
                  this.messageService.add({
                    severity: 'error',
                    summary: this.translate.instant('MERGE_FAILED'),
                    detail: this.translate.instant('MERGE_FAILED_DETAIL')
                  });
                  // Update the flg to prevent displaying the toast multiple times
                  this.isAiDataModelMergedJustNow = false;
                }
                this.getDataModelData();
                this.getAiMergingData();
              }
            }, 500);
          }
        },
        (error) => {
          console.error(error);
        }
      );
      this.addToSubscriptionsList(aiMergeLogDataSubs$);
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * This method closes the Merge Error Popup
   */
  closeMergingErrPopup() {
    this.isMergeLogsPopupOpen = false;
  }

  /**
   * This method opens the Merge Error Popup
   */
  openMergingErrPopup() {
    this.isMergeLogsPopupOpen = true;
  }

  /**
   * This Method returns the Parsed Object from string, if it is a string, it returns the string.
   * @param obj
   * @returns
   */
  getParsedObject(obj) {
    try {
      return JSON.parse(obj);
    } catch (e) {
      return obj;
    }
  }

  /**
   * This method returns the type of the object. It is used in the template file.
   */
  getTypeOf(obj) {
    return typeof obj;
  }

  generateModelForFieldsPrompt(node) {
    // Get the confirmation from user and then open the schema to datamodel component with field details if user confirms
    this.confirmationDialogService.confirm({
      message: this.translate.instant('GENERATE_MODEL_FOR_FIELD_CONFIRMATION'),
      acceptLabel: String(this.translate.instant('YES')),
      rejectLabel: String(this.translate.instant('NO')),
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      accept: () => {
        this.showSchemaToDataModelModal({
          aiGenerationType: AiGenerationType.FIELD,
          tableId: node.data.sid
        });
      },
    });
  }

  /**
   * Activates the DM visualizer if the tree is ready.
   * DmVisualizer component handles extracting changeset data internally.
   */
  private tryActivateCompanionVisualizer() {
    if (this.companionTreeReady) {
      this.showVisualizer = false;
      this.showDbVisualizer = false;
      this.changeDetectorRef.detectChanges(); // Ensure the component is effectively destroyed in DOM

      // Force remount of the Data Model Visualizer (RHS) to cleanly apply new changeset
      setTimeout(() => {
        this.showDbVisualizer = true;
        this.changeDetectorRef.detectChanges(); // Ensure the component is effectively created in DOM
      }, 500);

      this.isCompanionLoading = false;
    }
  }

  showHideLoader() {
    this.isLoading = !this.isLoading;
  }
}

